// Swedish: baseline copy of English keys; replace with Swedish copy as needed
import { solutionComponentsSv } from './solutionComponentStrings.js';
import { lensComponentsSv } from './lensComponentStrings.js';
import { moduleIntroSv } from './moduleIntroStrings.js';
import { reportStringsSv } from './reportStrings.js';
import { foresightSv } from './foresightStrings.js';
import { foresightScenarioSv } from './foresightScenarioStrings.js';
import { foresightPathSv } from './foresightPathStrings.js';
import { foresightWildcardSv } from './foresightWildcardStrings.js';
import { futureReimaginedSv } from './futureReimaginedStrings.js';
import { negotiationLabSv } from './negotiationLabStrings.js';
import { kuusiKenttaaSv } from './kuusiKenttaaStrings.js';
import { bookletSv } from './bookletStrings.js';
import { pivotsV3Sv } from './pivotsV3Strings.js';
import { vipupisteFocusSv } from './vipupisteFocusStrings.js';
import { statisticsViewSv } from './statisticsViewStrings.js';
import { opinionDatasetsSv } from './opinionDatasetStrings.js';
import { knowledgeKindsSv, sourceTiersSv } from './knowledgeKindStrings.js';
import { instancePromptsSv } from './instancePromptsStrings.js';
import { solutionsV3Sv } from './solutionsV3Strings.js';
import { ongelmatV2Sv } from './ongelmatV2Strings.js';
import { ankkuritV2Sv } from './ankkuritV2Strings.js';
import { juurisyytV2Sv } from './juurisyytV2Strings.js';
import { ongelmakarttaV3Sv } from './ongelmakarttaV3Strings.js';
import { solutionsV4Sv } from './solutionsV4Strings.js';
import { futureReimaginedV2Sv } from './futureReimaginedV2SvStrings.js';
import { impactMapV2Sv } from './impactMapV2Strings.js';
import { pivotsV2Sv } from './pivotsV2Strings.js';
import { swotViewSv } from './swotViewStrings.js';

export const sv = {
  // Landing Page
  landing: {
    title: 'Välkommen till Kuutio.',
    subtitle: 'Välj din roll för att fortsätta',
    selectInstance: 'Välj Kuutio-instans',
    loadingInstances: 'Laddar instanser...',
    noInstances: 'Inga instanser tillgängliga',
    sitraUser: 'Jag är från Sitra',
    invited: 'Jag blev inbjuden',
    whatIsKuutio: '🤔 Vad är Kuutio?',
    footer: 'Den här vyn visas på alla datorer när Kuutio startar',
    infoModal: {
      title: 'Vad är Kuutio?',
      paragraph1: 'Kuutio är en medskapande plattform utvecklad av Sitra som samlar medborgare, beslutsfattare och experter för att lösa viktiga samhällsutmaningar.',
      paragraph2: 'Plattformen möjliggör interaktivt samarbete över flera skärmar och enheter. Deltagare kan bygga påverkansvägar, dela idéer och visualisera komplexa orsak-verkan-samband i realtid.',
      paragraph3: 'Kuutio stödjer demokratiskt beslutsfattande och samhällsförändring genom att göra komplexa fenomen begripliga och främja systemtänkande.',
      contactButton: 'Kontakta oss'
    }
  },

  // Individual Impact Path
  individualImpactPath: {
    // Start Modal
    startModal: {
      title: '🌍 Current State: Food System Challenges',
      intro: "Finland's food system is in transition.",
      introDetails: 'Climate change, geopolitical tensions and an aging population challenge traditional practices.',
      question: 'How do we ensure food security when:',
      challenges: [
        'Import dependency is 80% in many product groups',
        'Average age of farmers exceeds 53 years',
        'Extreme weather events are increasing',
        'Food prices rise faster than purchasing power'
      ],
      task: 'Your task:',
      taskDescription: 'Build a path towards a sustainable and more self-sufficient food system. Start by selecting one key question to explore.',
      continueButton: 'Continue'
    },
    
    // Question Selection Modal
    questionModal: {
      title: 'Choose a Focus Question',
      subtitle: 'Pick one of these key questions to explore in your impact pathway:',
      cancelButton: 'Cancel',
      selectButton: 'Select Question'
    },
    
    // Node Modal
    nodeModal: {
      addConsequence: 'Add Consequence',
      addRequirement: 'Add Requirement',
      addComment: 'Add Comment',
      generateWithAI: 'Generate with AI',
      removeNode: 'Remove Node',
      close: 'Close'
    },
    
    // Placeholder nodes
    placeholders: {
      addQuestion: '+ Add Question',
      addNode: '+ Add Node'
    },
    
    // View controls
    viewControls: {
      clustered: 'Clustered',
      individual: 'Individual',
      showAll: 'Show All',
      hideCompleted: 'Hide Completed'
    },
    
    // Settings panel
    settings: {
      title: 'Settings',
      viewMode: 'View Mode',
      clustering: 'Clustering',
      aiComments: 'AI Comments',
      enabled: 'Enabled',
      disabled: 'Disabled'
    }
  },
  
  activityLog: {
    exportFailed: 'Nedladdningen misslyckades: {{error}}',
  },
  knowledgeManager: {
    exportFailed: 'RAG-exporten misslyckades: {{error}}',
  },

  // Common UI elements
  common: {
    save: 'Spara',
    cancel: 'Avbryt',
    confirm: 'Bekräfta',
    ok: 'OK',
    delete: 'Ta bort',
    confirmDelete: 'Ja, ta bort',
    deleting: 'Tar bort...',
    edit: 'Redigera',
    add: 'Lägg till',
    close: 'Stäng',
    undo: 'Ångra',
    redo: 'Gör om',
    continue: 'Fortsätt',
    back: 'Tillbaka',
    next: 'Nästa',
    yes: 'Ja',
    no: 'Nej',
    loading: 'Laddar...',
    loadingContent: 'Laddar innehåll...',
    error: 'Fel',
    success: 'Lyckades',
    unknownSource: 'Okänd källa',
    showMoreSources: '+{{count}} källor till',
    showFewerSources: 'Visa färre',
    sourceTitleFallback: 'Källa',
    openSource: 'Öppna källa',
    noSources: 'Inga källor',
    errorBoundaryTitle: 'Något gick fel',
    errorBoundaryUnknown: 'Okänt fel',
    errorBoundaryReload: 'Ladda om',
    unsavedTitle: 'Förkasta osparade ändringar?',
    unsavedMessage: 'Dina ändringar har inte sparats. De går förlorade om du fortsätter.',
    unsavedLeave: 'Du har osparade ändringar. Lämna ändå?',
    discardChanges: 'Förkasta ändringar',
  },

  login: {
    title: 'Logga in',
    subtitle: 'Kuutio-workshopens adminpanel. Sitras personal loggar in med sitt Microsoft-konto.',
    microsoft: 'Logga in med Microsoft',
    orEmail: 'Utanför Sitra och fått åtkomst? Logga in med en kod som skickas till din e-post',
    emailNote: 'Använd adressen som du fått åtkomst med.',
    hint: 'Kontakta Kuutio-teamet om du behöver åtkomst. Genom att logga in godkänner du att användningen kan granskas för att skydda workshopdata.',
  },

  pinLogin: {
    title: 'Kuutio',
    chooseSubtitle: 'Hur loggar du in?',
    chooseEmail: 'Jag har en inbjudan till Kuutio med min e-postadress',
    choosePin: 'Jag deltar i en Kuutio-workshop och kan PIN-koden',
    chooseStaff: 'Sitras Kuutio-personal',
    town: {
      title: 'Vilken stad kommer du från?',
      subtitle: 'Valet sparas på den här enheten: ditt teams svar och förutsättningar bokförs på det. Du kan byta team på teamsidan.',
    },
    staffSignIn: 'Logga in med Microsoft',
    back: 'Tillbaka',
    denied: {
      signin: 'Logga in för att öppna länken.',
      instance: 'Din inloggning ger inte tillgång till den här workshoppen.',
      expired: 'Din session har gått ut. Logga in igen.',
    },
    placeholder: 'PIN',
    submit: 'Logga in',
    invalidPin: 'Ogiltig PIN-kod',
    modalTitle: 'Ange PIN-koden',
    modalText: 'Ange den 6 tecken långa PIN-kod du fått för att komma in i Kuutio.',
    emailPlaceholder: 'namn@organisation.fi',
    sendCode: 'Skicka kod',
    sending: 'Skickar…',
    codeSentTo: 'Kod skickad till',
    changeEmail: 'byt',
    signingIn: 'Loggar in…',
    resend: 'Skicka ny kod',
    resendIn: 'Skicka ny kod ({{s}} s)',
    codeResent: 'Ny kod skickad',
    invitedOnly: 'Koden skickas bara till inbjudna deltagare. Använd adressen du anmälde dig med.',
    codeIfInvited: 'Om adressen finns på inbjudningslistan är koden på väg. Kolla även skräpposten.',
    connectionError: 'Anslutningsfel. Försök igen.',
  },

  aiScorePanel: {
    researchSupport: 'Kunskapsbas',
    researchUnavailable: {
      searchFailed: 'Forskningsmaterialet kunde inte användas: söktjänsten svarade inte. Bedömningen bygger på allmän kunskap.',
      noDatasets: 'Forskningsmaterialet kunde inte användas: inget forskningsmaterial är kopplat till den här workshoppen. Bedömningen bygger på allmän kunskap.',
    },
    relevance: 'Träffsäkerhet',
    attachments: 'Bilagor',
    attachmentsCount: 'Bilagor ({{count}})',
  },

  evaluationTags: {
    ambitious: 'Ambitiös',
    feasible: 'Genomförbar',
    innovative: 'Innovativ',
    creative: 'Kreativ',
    research_backed: 'Kunskapsbaserad',
    systemic: 'Systemisk',
    tested_elsewhere: 'Testad annanstans',
    quick_to_implement: 'Snabb att genomföra',
    uncharted: 'Outforskat område',
    expert_insight: 'Expertinsikt',
    bold_hypothesis: 'Djärv hypotes',
    empty: 'Inga styrketaggar.',
    contradicts_research: 'Motsäger kunskapsbasen',
    sectionTitle: 'Taggar',
    researchConflictTitle: 'Obs från kunskapsbasens perspektiv',
    researchStance: {
      supported: 'Kunskapsbasen stödjer detta',
      silent: 'Kunskapsbasen behandlar inte detta',
      silentHint: 'Ingen svaghet — vanligt för expert- och frontidéer.',
      contradicted: 'Kunskapsbasen motsäger detta',
    },
    moreTags: '+{{count}}',
    expandReason: 'Visa motivering',
    collapseReason: 'Dölj motivering',
  },

  impactPath: {
    resetZoom: 'Visa hela kartan',
    loadingWorkshop: 'Laddar workshop...',
    loadingImpactPath: 'Laddar påverkansväg...',
    scenariosLoading: 'Laddar scenarier...',
    pathwayLoading: 'Laddar väg...',
    minCharsHint: 'minst 3 tecken',
    selectWorkshop: 'Välj workshop',
    selectScenario: 'Välj scenario',
    scenarioCount: '{{count}} scenarier',
    onlineBadge: 'Online',
    liveBadge: 'Live',
    initializingPaths: 'Inga vägar än — initierar...',
    chooseFutureFirst: 'Välj först en framtidsbild, så börjar påverkansvägen från dess variabler.',
    noStarterVariables: 'Scenariot har inga variabler som påverkansvägen kan börja från.',
    viewMode: {
      mineLabel: 'Mina',
      scenarioLabel: 'Scenario',
      allLabel: 'Alla',
      mineTitle: 'Mina',
      scenarioTitle: 'Scenario',
      allTitle: 'Alla',
      mineDescription: 'Endast dina idéer i detta scenario.',
      scenarioDescription: 'Allas idéer i detta scenario.',
      allDescription: 'Allas idéer från alla scenarier.',
      ownNodeLegend: 'Blå kant = din idé',
      switchToMine: 'Byt till Mina',
      switchToAll: 'Byt till Alla',
      introTitle: 'Så fungerar kartvyerna',
      introStepMineTitle: 'Mina',
      introStepMineBody: 'Använd Mina när du lägger till eller redigerar dina idéer.',
      introStepAllTitle: 'Alla',
      introStepAllBody: 'Använd Alla för att se hela workshopens karta.',
      introStepKeepTitle: 'Dina idéer finns kvar',
      introStepKeepBody: 'Att byta vy tar inte bort dina lappar.',
      introConfirm: 'Jag förstår',
      bannerDismiss: 'Dölj'
    },
    // Valence (§4b): is this consequence one the room wants?
    valence: {
      label: 'Önskvärdhet',
      byAi: 'AI:s bedömning',
    },
    votes: { title: 'Är detta viktigt?' },
    notes: { title: 'Anteckningar', placeholder: 'En anteckning — ett skäl, ett tvivel, en källa…', add: 'Lägg till' },
    // Route layout (settings.impactMapLayout = 'route'): goal and milestone cards.
    route: {
      goal: 'Mål',
      start: 'Start',
      milestone: 'Milstolpe',
      status: { saavutettu: 'Uppnådd', osittain: 'Delvis', ei: 'Inte uppnådd', avoin: 'Öppen' },
      progress: 'Framsteg',
      progressHint: 'Bara orter, milstolpar och mål. Av: hela kartan.',
    },
    // The map drawn from the scene (?scene=1): card kinds and connector words.
    scene: {
      loading: 'Laddar kartan…',
      error: 'Kartan kunde inte laddas: {{message}}',
      empty: 'Det finns inget på kartan ännu.',
      kind: {
        mission: 'Start', start: 'Start', done: 'Klart', goal: 'Mål', milestone: 'Milstolpe',
        blocker: 'Hinder', avoider: 'Sätt att undvika', input: 'Insats', output: 'Prestation', outcome: 'Resultat',
        impact: 'Effekt', consequence: 'Följd', condition: 'Förutsättning', question: 'Fråga', target: 'Förändringsmål', endState: 'Slutmål',
      },
      doneGoals: '{{count}} mål',
      axis: {
        quarter: 'K{{n}}', week: 'v. {{n}}', round: 'omgång {{n}}',
        report: 'Rapport {{date}}: {{count}} kort',
        noDates: 'Korten i vyn har inga datum',
        basis: { stated: '{{date}}', due: 'senast planerat {{date}}', reported: 'senast {{date}}' },
      },
      edge: {
        leads_to: 'leder till', enables: 'möjliggör', blocks: 'hindrar', reinforces: 'förstärker', weakens: 'försvagar',
        delays: 'fördröjer', relates_to: 'hänger ihop', is_same: 'samma sak', asks: 'frågar',
      },
    },
    // Adding a blocker on an edge: stopping a wanted consequence, or avoiding an unwanted one.
    // The node modal's neighbourhood (impactmap/neighbourhood): what leads to a card and what follows
    proposedLink: {
      title: 'Föreslagen koppling', by: 'AI:s motivering', accept: 'Godkänn', reject: 'Förkasta', failed: 'Beslutet sparades inte (HTTP {{status}}).',
    },
    neighbourhood: {
      into: 'Leder hit', outOf: 'Följer av detta', none: 'Inget ännu', start: 'Start', avoids: 'undviker',
      error: 'Kartans kopplingar kunde inte laddas.',
      source: { documents: 'Utkast ur projektets egna rapporter', ai: 'Föreslaget av AI', person: 'Skrivet av en deltagare' },
    },
    blockerDraft: {
      block: { label: 'Ett hinder stoppar detta', title: 'Lägg till hinder', subtitle: 'Vad hindrar detta från att ske?' },
      avoid: { label: 'En oönskad följd som undviks', title: 'Lägg till ett sätt att undvika', subtitle: 'Hur undviks detta?' },
    },
    // A card drafted from the team's own documents, awaiting a person.
    proposed: {
      title: 'Utkast ur ert material',
      tag: 'från materialet',
      lead: 'Detta är ett utkast ur era egna rapporter. Behåll det, mildra det med egna ord eller förkasta det.',
      provenanceTitle: 'Bygger på meningen',
      keep: 'Behåll',
      soften: 'Mildra',
      softenSave: 'Spara mildrat',
      softenLabel: 'Skriv med egna ord',
      reject: 'Förkasta',
      reasonPlaceholder: 'Motivering (valfritt)',
      decided: { keep: 'Behållen', soften: 'Mildrad med egna ord', reject: 'Förkastad' },
    },
    nodeModal: {
      headerTitle: 'Vad följer av detta?',
      parentLabel: 'Föregående',
      titleLabel: 'Rubrik',
      consequencePlaceholder: 'Skriv konsekvensen här...',
      thoughtTitlePlaceholder: 'Idéns rubrik...',
      thoughtDescPlaceholder: 'Idébeskrivning...',
      aiStreaming: 'Skriver...',
      aiLoading: 'Laddar...',
      completeLabel: 'Komplettera',
      closeTitle: 'Stäng',
      cancel: 'Avbryt',
      commentsTitle: 'Kommentarer',
      addImpact: 'Lägg till effekt',
      deleteWarning: 'Detta tar också bort alla {{count}} underidéer.',
      deleteBlocked: 'Noden har {{count}} konsekvensnoder som lagts till av andra deltagare. Borttagning är inte tillåten.',
      saveFailed: 'Sparning misslyckades. Försök igen.',
      deleteFailed: 'Kunde inte ta bort idén. Försök igen.',
      describeConsequenceLabel: 'BESKRIV KONSEKVENSEN',
      titleFieldLabel: 'RUBRIK',
      descriptionFieldLabel: 'BESKRIVNING',
      aiAnalyzingThought: 'AI analyserar idén...',
      editButtonTitle: 'Redigera',
      editAdjust: 'Justera',
      creating: 'Skapar...',
      analyzing: 'Analyserar...',
      continue: 'Fortsätt',
      saving: 'Sparar...',
      saveOrAnalyze: 'Analysera & spara',
      defaultNodeTitle: 'Idé',
      researchBacked: 'Forskningsbaserad',
      regenerate: 'Generera om',
      replaceAiTitle: 'Ersätt nuvarande AI-text',
      completeAiTitle: 'Komplettera text med AI',
      deleteBlockedAlert: 'Idén har innehåll som lagts till av andra deltagare. Borttagning är inte tillåten.',
      commentFailed: 'Kunde inte lägga till kommentar. Försök igen.',
    },
    aiAnalysis: {
      loadingTitle: '⏳ AI analyserar...',
      loadingDescription: 'Skapar tre perspektiv: hinder, möjlighet, fråga',
      analysisFailedTitle: '❌ AI-analys misslyckades',
      serviceUnavailable: 'AI-tjänsten är inte tillgänglig just nu',
      serviceOverloaded: 'AI-tjänsten är överbelastad. Försök igen om en stund.',
      serviceInternalError: 'Internt fel i AI-tjänsten. Försök igen.',
      researchSearchFailed: 'Konsekvenserna skrevs utan forskningsmaterial: söktjänsten svarade inte.',
      researchNoDatasets: 'Konsekvenserna skrevs utan forskningsmaterial: inget forskningsmaterial är kopplat till den här workshoppen.',
      generationErrorTitle: '❌ Fel i AI-analysen',
      generationErrorDescription: 'Tekniskt fel. Försök igen eller fortsätt utan AI-hjälp.',
      academicQuestion: 'Analysera påverkningsbanans steg "{{nodeText}}" och ge tre perspektiv: hinder, möjlighet, fråga. Förankra svaret i forskning.',
    },
    consequenceFlow: {
      connectionAdded: 'Tanken "{{node}}" lades till som följd av "{{parent}}"',
      connectionExists: 'Den här kopplingen finns redan.',
      connectionFailed: 'Kopplingen kunde inte skapas. Försök igen.',
      networkError: 'Nätverksfel. Kontrollera anslutningen och försök igen.',
      minCharsAlert: 'Skriv minst 3 tecken',
    },
    existingNodeSelector: {
      minCharsAlert: 'Skriv minst 3 tecken',
      title: 'Lägg till konsekvens',
      parentNodeLabel: 'Föregående nod',
      loadingSuggestions: 'Hämtar förslag...',
      instruction: 'Skriv en rubrik för konsekvensen nedan. Klicka på "Fortsätt" för att hitta liknande noder och AI-förslag.',
      titlePlaceholder: 'Konsekvensrubrik...',
      relatedSources: 'Relaterade källor:',
      sourceFallback: 'Källa',
    },
    nodeType: {
      scenario: 'Scenario',
      variable: 'Variabel',
      consequence: 'Konsekvens',
      start: 'START',
    },
    changeScenario: 'Byt scenario',
    infoTab: 'Info',
    infoPanel: {
      workshop: 'Workshop',
      participants: '{{count}} deltagare',
      perspectiveLabel: 'Perspektivfokus',
      scenarios: 'Scenarier ({{count}})',
      active: 'Aktiv',
    },
    settings: {
      userInfoSection: 'Användarinfo',
      userIdLabel: 'Användar-ID',
      userIdDesc: 'Din nuvarande deltagaridentifierare',
      notSet: 'Inte angiven',
      consequenceSection: 'Skapa konsekvens',
      twoStepLabel: 'Tvåstegs konsekvensflöde',
      twoStepDesc: 'Guidar användare att skapa konsekvenser i två steg: först text, sedan metadata.',
      aiSection: 'AI',
      aiAnalysisLabel: 'AI-analys för noder',
      aiAnalysisDesc: 'Forskningsstöd och relevanspoäng för noder. Stäng av om tjänsten är långsam.',
      beta: 'beta',
    },
    duplicateCheck: {
      title: 'Välj effekt',
      older: 'Äldre',
      newer: 'Nyare',
      combined: 'Kombination',
      existingFallback: 'Befintlig effekt',
      newFallback: 'Ny effekt',
      combinedFallback: 'Kombinerad effekt',
      cancel: 'Avbryt',
      accept: 'Godkänn valt',
    },
    addNode: {
      kindLabel: 'Vad är detta i kedjan?',
      title: 'Vad följer av detta?',
      titleInstead: 'Vad kunde hända i stället?',
      subtitle: 'Med egna ord. Noden hamnar på kartan direkt; AI:n sammanfattar en rubrik och söker liknande noder efteråt.',
      save: 'Lägg till på kartan',
      added: 'Tillagd: {{title}}',
    },
    createNode: {
      titleLabelOptional: 'Rubrik (valfri)',
      titleHintAi: 'Lämna tomt så sammanfattar AI:n från beskrivningen',
      titlePlaceholderAi: 'AI:n sammanfattar en rubrik från beskrivningen',
      descriptionHintLong: 'Skriv gärna långt',
      optional: 'Valfri',
      titleRequired: 'Rubrik är obligatorisk',
      title: 'Skapa ny nod',
      subtitle: 'Fyll i nodens uppgifter',
      parentLabel: 'Föregående nod',
      titleLabel: 'Rubrik *',
      titlePlaceholder: 'T.ex. Klimatförändring',
      descriptionLabel: 'Beskrivning',
      descriptionPlaceholder: 'Beskriv mer i detalj vad detta betyder...',
      researchSources: 'Forskningskällor ({{count}})',
      back: 'Tillbaka',
      save: 'Spara',
    },
    aiConsequence: {
      title: 'AI föreslår konsekvenser',
      subtitle: 'Välj vad som ska läggas till',
      targetNode: 'Målnod:',
      loading: 'AI analyserar och genererar förslag...',
      description: 'AI föreslår dessa konsekvenser baserat på forskning och kontext. Du kan redigera förslagen innan du lägger till dem.',
      titlePlaceholder: 'Rubrik...',
      descriptionPlaceholder: 'Beskrivning...',
      aiGenerated: 'AI-genererad',
      confidence: 'Tillförlitlighet: {{percent}}%',
      edited: '✏️ Redigerad',
      selectedOne: 'konsekvens',
      selectedMany: 'konsekvenser',
      selectedPrefix: 'Valda:',
      addSelected: 'Lägg till valda',
      empty: 'AI kunde inte generera förslag.\nFörsök igen eller lägg till en konsekvens manuellt.',
    },
    painPointVote: {
      title: 'Smärtpunkter: {{scenario}}',
      finish: 'Avsluta omröstningen och bilda muuttujat',
      finishing: 'Räknar röster…',
      finished: 'Omröstningen avslutad: {{votes}} röster, {{count}} muuttujat på kartan.',
      facilitatorOnly: 'Bara facilitatorn kan avsluta omröstningen.',
    },
    didYouMean: {
      title: 'Förslag om ämnet',
      subtitle: 'AI analyserar forskningskällor',
      searching: 'Söker:',
      parentLabel: 'Föregående nod',
      loading: 'Hämtar forskningskällor och skapar förslag...',
      researchSources: 'Använda forskningskällor ({{count}})',
      aiSuggestions: 'AI-förslag',
      moodPositive: '👍 Positiv',
      moodNegative: '👎 Negativ',
      moodQuestion: '❓ Fråga',
      moodNeutral: '➖ Neutral',
      existingSimilar: 'Befintliga liknande noder',
      similarity: '{{percent}}% liknande',
      empty: 'Inga liknande noder eller förslag hittades.\nSkapa en ny nod nedan.',
      createNew: 'Skapa egen nod',
    },
    similarAfterAdd: {
      title: 'Liknande noder på kartan',
      intro: 'Är det du lade till samma sak som någon av dessa? Välj, så markeras de som samma. Din nod stannar på kartan i vilket fall.',
      notSame: 'Inte samma sak',
      found: '{{count}} liknande noder på kartan: "{{title}}"',
      show: 'Visa',
      dismiss: 'Avfärda',
      similarity: '{{percent}}% liknande',
    },
    consequenceSelect: {
      title: 'Välj konsekvenser',
      subtitle: 'Koppla till aktuell nod: {{text}}',
      existingSection: 'Befintliga noder',
      existingDesc: 'Vi hittade dessa liknande noder i trädet. Du kan länka till dem och lägga till en kommentar.',
      existingBadge: 'Befintlig',
      depth: 'Djup: {{depth}}',
      aiSection: 'AI-förslag',
      aiDesc: 'AI föreslår dessa nya konsekvenser baserat på forskning och kontext.',
      aiGenerated: 'AI-genererad',
      confidence: 'Tillförlitlighet: {{percent}}%',
      empty: 'Inga förslag tillgängliga. Försök igen eller lägg till en konsekvens manuellt.',
      loading: 'Laddar förslag...',
      selectedOne: 'konsekvens',
      selectedMany: 'konsekvenser',
      selectedPrefix: 'Valda:',
      addSelected: 'Lägg till valda',
    },
    academicReview: {
      fillAll: 'Fyll i rubrik och beskrivning för alla tre perspektiv.',
      title: 'Granska AI-perspektiv',
      subtitle: 'Redigera texterna vid behov innan sparning. Maximal rubriklängd är {{max}} tecken.',
      labelBlocker: 'Hinder (blocker)',
      labelPossibility: 'Möjlighet (possibility)',
      labelQuestion: 'Fråga (question)',
      titleLabel: 'Rubrik',
      descriptionLabel: 'Beskrivning',
      cancel: 'Avbryt',
      saveNodes: 'Spara noder',
    },
  },

  futureReimagined: futureReimaginedSv,
  negotiationLab: negotiationLabSv,
  kuusiKenttaa: kuusiKenttaaSv,
  booklet: bookletSv,
  pivotsV3: pivotsV3Sv,
  vipupisteFocus: vipupisteFocusSv,
  statisticsView: statisticsViewSv,
  opinionDatasets: opinionDatasetsSv,
  knowledgeKinds: knowledgeKindsSv,
  sourceTiers: sourceTiersSv,
  instancePrompts: instancePromptsSv,
  solutionsV3: solutionsV3Sv,
  ongelmatV2: ongelmatV2Sv,
  ankkuritV2: ankkuritV2Sv,
  juurisyytV2: juurisyytV2Sv,
  ongelmakarttaV3: ongelmakarttaV3Sv,
  ratkaisutV4: solutionsV4Sv,
  futureV2: futureReimaginedV2Sv,
  impactMapV2: impactMapV2Sv,
  pivotsV2: pivotsV2Sv,
  swotView: swotViewSv,
  ratkaisutV2: {
    views: { analysis: "Analys" },
    analysisTitle: "Lösningarna och deras bedömning",
    analysisIntro: "Alla workshopens lösningar, hur de samverkar och AI:ns uppskattning av vad var och en skulle göra med kartans hävstångspunkter.",
    noProblem: "Inget problem",
    work: {
      title: "Vilken hävstångspunkt tar ni er an?",
      hint: "Välj en hävstångspunkt: en riktning något måste förändras i. Kartan visar grundorsakerna den bär och problemen de hör till, och sedan hjälper samtalet er att skriva en lösning som flyttar den.",
      pivotMeta: "Problem: {{problems}} · Lösningar: {{solutions}}",
      focused: "Valet av hävstångspunkter är låst: de valda erbjuds.",
      empty: "Kartan har inga hävstångspunkter ännu.",
      focusHint: "Hävstångspunktens grundorsaker, hinder för förändring och problem på kartan. Tryck för att gå vidare.",
      pivotLabel: "Hävstångspunkt",
      allPivots: "Alla hävstångspunkter…",
      leaveDraft: "Lösningsutkastet lämnas oavslutat. Byta ändå?",
    },
    effects: {
      title: "Möjliga effekter",
      hint: "Vad utkastet kunde göra med hävstångspunkterna i den här delen av kartan. När lösningen sparats bedöms den mot alla hävstångspunkter.",
      empty: "Samtalet lyfter fram effekterna när lösningen börjar ta form.",
      intended: "Avsedda effekter",
      side_effect: "Möjliga bieffekter",
      worsens: "åt fel håll",
    },
    setAnalysis: {
      title: 'Lösningarna som helhet',
      intro: 'AI:n läser lösningarna tillsammans: var de drar åt olika håll, mot intressen eller mot forskningen, vad de lämnar obehandlat och om något liknande har prövats på annat håll. Varje iakttagelse har sina egna källor.',
      needsSolutions: 'Skriv först några lösningar, så kan de analyseras som helhet.',
      waiting: 'Helhetsanalysen har inte körts ännu. Facilitatorn startar den, och resultatet visas här när det är klart.',
      stale: 'Lösningarna har ändrats sedan analysen. Läsningen gäller ett tidigare läge.',
      unaddressed: 'Hävstångspunkter som ingen lösning tar sig an',
      allAddressed: 'Varje hävstångspunkt tas an av minst en lösning.',
      recommended: 'Rekommenderad av kartanalysen',
      triedElsewhere: 'Prövat på annat håll',
      newsOnly: 'Bygger bara på en nyhetskälla — inte forskning.',
      outcome: { worked: 'Fungerade', mixed: 'Blandat', failed: 'Fungerade inte', unclear: 'Oklart' },
    },
    portfolioTitle: "Vad lösningarna rör tillsammans",
    portfolioHint: "{{count}} lösningar mot kartans hävstångspunkter. En röd pil betyder att lösningen för mätaren åt fel håll.",
    contested: "Motstridigt",
    untouched: "Ingen lösning berör dessa ännu ({{count}})",
    chartMeasured: "Relativ förändring — mätaren har en statistikserie",
    chartProposed: "Endast riktning — föreslaget mått, inga mätdata",
    today: "Idag",
    yearsOn: "år framåt",
    range: "Intervall",
    midpoint: "Mittvärde",
    chartLegend: "Detta är ett scenario, inte en prognos: den streckade linjen är en uppskattning och skuggningen dess osäkerhet. Ju längre fram, desto bredare.",
    tagDerived: "Beräknat ur bedömningen",
    tags: {
      marginal: "Marginell effekt",
      displaces_problem: "Flyttar problemet",
      slow_burn: "Långsam verkan",
      wide_reach: "Bred räckvidd",
      breaks_a_loop: "Träffar en slinga",
      no_way_in: "Ingen ingång",
      already_tried: "Redan prövat",
      depends_on_unlikely: "Vilar på det osannolika",
      research_backed: "Forskningsstöd",
      tested_elsewhere: "Fungerar annorstädes",
      systemic: "Strukturell",
      creative: "Kreativ",
    },
    scoresTitle: "Bedömning",
    ambitionUnreachable: "Ambitiöst men utan ingång: inget steg på vägen kan påbörjas med dagens aktörer och mandat. Det gör inte lösningen dålig, men första steget saknas.",
    pathwayMissing: "Ingen väg beskriven. Utan steg och aktörer finns ingenstans att börja.",
    pathwayTitle: "Väg",
    reasoningTitle: "Motivering",
    stepCount: "{{count}} steg",
    blockersTitle: "Hinder",
    now: "Nu",
    precondition: "Kräver",
    couldRemove: "Kunde undanröja",
    score: { feasibility: "Genomförbarhet", ambition: "Ambition", effectiveness: "Verkan" },
    scoreHint: { feasibility: "Kan arbetet börja i år med dagens aktörer?", ambition: "Hur grundläggande är förändringen?", effectiveness: "Hur mycket rör detta kartan?" },
    improve: {
      title: "Förbättra lösningen",
      intro: "Fråga, ifrågasätt bedömningen eller föreslå en ändring. När samtalet ger en bättre version föreslås den för er. En godkänd förbättring bedöms på nytt, och den gamla versionen sparas.",
      placeholder: "Svara, fråga eller föreslå en ändring…",
      readAssessment: "Läs bedömningen",
      writeNew: "Skriv en ny lösning",
      versionAccepted: "Version {{version}} godkänd",
      stale: "Siffrorna gäller den föregående versionen.",
    },
    previousScore: "v{{version}}: {{value}}",
    tagNew: "ny",
    tagsRemoved: "Föll bort:",
    versions: { title: "Versioner", current: "nuvarande" },
    wall: {
      title: "Lösningar",
      lead: "Bedömningen uppdateras efter varje godkänd förbättring.",
      justImproved: "Nyss förbättrad",
      next: "Nästa: Framtidstestning. Vi väljer tillsammans vilka lösningar som simuleras.",
      empty: "Inga lösningar har skrivits ännu.",
    },
    movesLabel: "Vad lösningen påverkar",
    noPivot: "Ingen hävstångspunkt",
    problemsReached: {
      title: "Problem som lösningen tar sig an",
      solves: "löser",
      touches: "lindrar",
      none: "Enligt bedömningen tar lösningen sig inte an något av workshopens problem.",
    },
    proposedEdit: "Föreslagen ändring av lösningen",
    acceptEdit: "Godta ändringen och bedöm om",
    accepting: "Bedömer om…",
    back: "Tillbaka till lösningar",
    edit: "Redigera",
    showAll: "Visa hela texten",
    showLess: "Visa mindre",
    running: "Bedömer…",
    runningHint: "AI:n går igenom varje hävstångspunkt. Bedömningen blir klar inom några minuter, även om du lämnar sidan.",
    notEvaluated: "Effekterna har inte bedömts ännu.",
    moves: "Påverkar {{count}} mätare",
    key: "↑ mätaren stiger · ↓ mätaren sjunker · rött kort: en förändring till det sämre",
    figuresExplained: "Vad betyder siffrorna?",
    figuresHelp: "Siffran är AI:ns uppskattning av hur många procent mätaren skulle ändras på fem år om lösningen genomfördes; intervallet står inom parentes. Grunden anger om uppskattningen vilar på forskning, en jämförelse från annat håll eller resonemang. Öppna ett kort för mekanismen, de andra åren och riskerna.",
    whyAndWhen: "Varför och när",
    risks: "{{count}} risker",
    unchanged: "Ingen effekt ({{count}})",
    worsens: "Försämrar",
    intended: "Avsedd",
    sideEffect: "Sidoeffekt",
    year: "{{n}} år",
    revisedFrom: "Version {{from}} → {{to}}",
    noEffect: "ingen effekt",
    wasBefore: "tidigare {{value}}",
    revisedHint: "Siffrorna kommer från den nya bedömningen av den reviderade lösningen. Dialogen bestämmer dem inte.",
    lag: "{{months}} mån fördröjning",
    watchFor: "Tidigt tecken",
    threatDelays: "Fördröjer",
    threatReduces: "Dämpar",
    threatBlocks: "Blockerar",
    basis: { research: "Forskning", analogue: "Motsvarighet", reasoned: "Härlett" },
    basisSplit: "Grund: forskning {{research}} · motsvarighet {{analogue}} · härlett {{reasoned}}",
    adverseFound: "Mest sannolika nackdel",
    adverseNone: "Ingen negativ effekt hittades",
    title: "Lösningar",
    intro: "Skriv ett förslag. Analysen bedömer det mot varje hävstångspunkt på kartan — även de ni inte tänkte på.",
    write: "Skriv en lösning",
    contextTitle: "Kartans hävstångspunkter",
    contextHint: "Dessa mätare hittade er workshop. En lösning mäts mot dem alla.",
    noVipupisteet: "Inga hävstångspunkter härledda ännu. Kör hävstångsanalysen på problemkartan först.",
    listTitle: "Lösningar ({{count}})",
    empty: "Inga lösningar ännu.",
    compose: {
      intro: "Berätta om er lösning med egna ord. Kuutio frågar en sak i taget — det analysen behöver för att bedöma den rättvist — och skriver ett utkast. Förslaget förblir ert.",
      startPlaceholder: "Vad skulle ni vilja göra?",
      start: "Börja",
      replyPlaceholder: "Svara här…",
      send: "Skicka",
      thinking: "Funderar…",
      summaryTitle: "Förslag och bedömning",
      yourProposal: "Ert förslag",
      yourProposalEmpty: "Det ni föreslår samlas här — med era ord.",
      draft: "Utkast",
      draftHint: "Ni kan redigera utkastet direkt. Ändringarna följer med i nästa tur.",
      missing: "Analysen saknar ännu",
      missingNone: "Lösningen har allt som analysen behöver.",
      suggestions: "Förslag från Kuutio — tryck för att lägga till det i ert svar",
      takeSuggestion: "Vi tar med: {{s}}",
    },
    modalTitle: "Lösningsförslag",
    modalIntro: "Skriv med egna ord. Härnäst bedömer AI:n vilka mätare detta skulle röra, och hur mycket.",
    titleLabel: "Rubrik",
    titlePlaceholder: "Ett kort namn för lösningen",
    bodyLabel: "Lösningen",
    bodyPlaceholder: "Vad görs, vem gör det och vad förändras?",
    save: "Spara lösning",
  },
  systemicMapV2: {
    whatIsThis: "Vad är detta?",
    bindTitle: "Statistikkoppling",
    bindIntro: "Detta är ett föreslaget mått. Hitta en verklig serie i verkstadens statistik så att projektionerna utgår från en uppmätt baslinje.",
    bindSearch: "Sök en serie",
    bindSearching: "Söker…",
    bindSearchingLong: "Söker i statistiken… {{elapsed}} s. Sökningen går igenom statistikkatalogen och kan ta en minut.",
    bindFailed: "Något gick fel. Försök igen om en stund.",
    bindNoDataset: "Ingen statistik är kopplad till den här kuben, så inga serier söks. Koppla den under Förberedelse → Kunskapsbas.",
    bindConfirm: "Bekräfta denna serie",
    binding: "Kopplar…",
    bindPoints: "{{count}} observationer",
    bindNone: {
      no_topic: "Inget i Statistikcentralens katalog mäter detta. Mätaren förblir föreslagen; den kan ändå användas i diskussionen.",
      no_tables: "Ämnet har inga statistiktabeller. Mätaren förblir föreslagen; den kan ändå användas i diskussionen.",
      no_table_match: "Verkstadens statistik har ingen tabell som mäter detta. Mätaren förblir föreslagen; den kan ändå användas i diskussionen.",
      unpinned_dimensions: "Statistik hittades, men inget motsvarade mätaren exakt, så inget kopplades på en gissning. Mätaren förblir föreslagen.",
      no_series: "Serien kunde inte hämtas just nu. Du kan försöka igen om en stund.",
    },
    statfiReview: {
      waiting: "{{count}} väntar",
      title: "Statistik för måtten",
      intro: "Sökningen letar efter en serie för varje föreslaget mått i verkstadens statistik: dess egna tabeller och Statistikcentralen. Inget kopplas utan bekräftelse: kontrollera tabellens namn, vad serien mäter och de senaste värdena, och bekräfta eller hoppa över.",
      preparing: "Förbereder sökningen…",
      progress: "{{stage}} · {{searched}} / {{metrics}} mått klara",
      stages: {
        file: "Söker i verkstadens egen statistik",
        catalogue: "Kontrollerar katalogen",
        triage: "Väljer ämnen",
        tables: "Väljer tabeller",
        metadata: "Hämtar tabelluppgifter",
        filters: "Avgränsar frågorna",
        series: "Hämtar serier",
        stewards: "Föreslår vem som mäter",
      },
      summary: "{{measured}} kopplade · {{review}} väntar på granskning · {{none}} utan lämplig serie · {{skipped}} överhoppade · {{errors}} fel · {{pending}} ej sökta",
      skip: "Hoppa över måttet",
    },
    statfiSource: {
      label: "Källa:",
      provider: "Statistikcentralen",
      table: "tabell {{table}}",
      open: "Öppna tabellen",
    },
    steward: {
      noDataset: "Inget material från Statistikcentralen hittades för detta mått.",
      title: "Vem kunde mäta detta?",
      practice: "I praktiken",
      responsible: "Ansvar för statistiken",
      basis: "Ett förslag som AI har resonerat fram, utan källa.",
      pending: "Ett förslag om vem som kunde mäta detta skrivs vid nästa statistiksökning.",
    },
    loopsTitle: "Slingor",
    loopsIntro: "En slinga uppstår när en hävstångspunkt återverkar på en grundorsak. Dessa är kartans enda härledda kanter — allt annat finns för att någon skrev en nod under en annan. Ribban är hög och ett tomt resultat är ett giltigt svar.",
    noLoops: "Inga slingor. Det är inte ett fel: materialet innehåller ännu inte två hävstångspunkter vars grundorsaker påverkar varandra med tillräcklig säkerhet.",
    reinforcing: "Förstärkande cirkel",
    balancing: "Balanserande",
    conditional: "Villkorad",
    conditionalHint: "Slingan innehåller en förutsättning. Den löper bara så länge förutsättningen gäller.",
    measuresLink: "mätare",
    effectTypes: {
      leads_to: "leder till",
      reinforces: "förstärker",
      weakens: "försvagar",
      nullifies: "upphäver",
      enables: "möjliggör",
      blocks: "hindrar",
      requires: "förutsätter",
      delays: "fördröjer",
      relates_to: "hänger ihop med",
      is_same: "samma sak",
    },
    loopSteps: "{{count}} steg",
    noNodeReasoning: 'Ingen egen motivering har registrerats för den här noden.',
    carousel: {
      clear: 'Rensa urval',
      causes: "Orsaker",
      effects: "Följder",
      lateral: "Relaterade",
      back: "Tillbaka",
    },
    legend: {
      title: "Förbindelsernas färger",
      toggle: "Visa eller dölj teckenförklaringen",
      families: {
        amplify: "Förstärker",
        dampen: "Dämpar",
        enabling: "Möjliggör",
        neutral: "Relaterad",
      },
      untyped: "Ingen typ ännu",
    },
    lists: {
      title: 'Kartans listor',
      all: 'Alla',
      nodes: 'Noder',
      edges: 'Kopplingar',
      loops: 'Slingor',
      search: 'Sök…',
      none: 'Inga träffar.',
      noLoops: 'Kartan har inga slingor ännu.',
      nodeTypes: { ongelma: 'Problem', este: 'Hinder för förändring', juurisyy: 'Grundorsak', vipupiste: 'Hävstångspunkt' },
      edgeTypes: { petal: 'Hinder → problem', mechanism: 'Grundorsak → hinder', measures: 'Hävstångspunkt', causal: 'Återkoppling' },
      strength: { strong: 'stark', weak: 'svag' },
      open: 'Öppna',
      loopKinds: { conditional: 'Villkorad', reinforcing: 'Förstärkande', balancing: 'Balanserande' },
    },
    edge: {
      details: 'Detaljer',
      nature: 'Sambandets art',
      reasoning: 'Motivering',
      loopPath: 'Slingans väg',
      metric: 'Mätare',
      noReasoning: 'Ingen motivering har registrerats för detta samband.',
      kinds: { petal: 'Hindret för förändring håller problemet på plats: så länge hindret står kvar, lättar inte problemet.', mechanism: 'Grundorsaken håller hindret uppe: den är orsaken till att hindret står kvar.', measures: 'Hävstångspunkten säger åt vilket håll det som ligger bakom grundorsaken måste förändras, och dess mätare hur grundorsaken kan följas. Sambandet påstår ingen påverkan.', causal: 'Återkoppling: när hävstångspunkten rör sig förändras målet. Sambandet härleddes av AI utifrån kartan.' },
      sign: { '+': 'När orsaken växer, växer följden.', '-': 'När orsaken växer, försvagas följden.' },
      title: 'Samband',
      from: 'Orsak',
      to: 'Följd',
      kind: 'Typ',
      relation: 'Mekanism',
      assumption: 'Antagande',
      testQuestion: 'Testfråga',
      counterArgument: 'Motargument',
      confidence: 'Säkerhet',
      aiMade: 'Samband härlett av AI',
    },
    analysisTitle: "Workshopanalys",
    analysisIntro: "En tung läsning av hela materialet på en gång: alla problem, hinder för förändring, grundorsaker och bedömningar. Skiljer på vad workshopen visat, vad som följer av det och vad som inte är känt.",
    analysisWaiting: "Analysen har inte körts ännu. Facilitatorn startar den, och resultatet visas här när det är klart.",
    staleWarning: "Kartan har ändrats sedan den här analysen. Läsningen gäller ett tidigare läge.",
    overview: "Helhetsbilden",
    patternTitle: "Helhetens form",
    contradictions: "Motsägelser",
    gaps: "Luckor och tunna ställen",
    tensions: "Spänningar och oenighet",
    blindSpots: "Blinda fläckar",
    reasoningOnly: "Analysens eget resonemang — källorna visar ingen oenighet",
    tensionKind: { room: "I gruppen", interests: "Intressen", research: "Forskning", room_vs_research: "Gruppen vs forskningen", solutions_conflict: "Mellan lösningar" },
    blindSpotKind: { research_not_on_map: "I forskningen, inte på kartan", unaddressed_dimension: "Obehandlat", alternative_frame: "Ett annat perspektiv", unaddressed_lever: "Hävstångspunkt utan lösning", research_not_addressed: "I forskningen, inte i lösningarna", alternative_approach: "Ett annat angreppssätt" },
    webSearchFailed: "Webbsökningen misslyckades, så analysen bygger bara på workshopens eget material.",
    recommendation: "Vart härnäst",
    generatedAt: "Analysen kördes {{when}}",
    whyTitle: "Varför denna steg fram",
    established: "Materialet visar",
    follows: "Av detta följer",
    notKnown: "Detta är inte känt",
    noAnalysisForNode: "Analysen har inte körts ännu. Kör den under kartan för att få motiveringen.",
    reachTitle: "Räckvidd",
    metricsTitle: "Hävstångspunkter",
    verdictsTitle: "Gruppens bedömningar",
    verdictsHint: "{{count}} bedömningar. Det är ett antal personer, inte enighet.",
    carriesTitle: "Grundorsaker som den här hävstångspunkten påverkar",
    lever: { what: 'Vad hävstångspunkten är', why: 'Varför i den här riktningen', how: 'Hur den kan mätas', metric: 'Mätare: {{label}}', details: 'Varför i den här riktningen och hur den mäts', pending: 'Den här hävstångspunkten har inte formulerats än. Facilitatorn startar formuleringen; till dess visas mätaren som följer den.' },
    introGraph: 'Samma workshop som ett helt nätverk: problem, hinder för förändring, grundorsaker och hävstångspunkterna som mäter dem. Dra, zooma och vrid. Hävstångspunkterna är gröna.',
    views: { 'analysis': 'Analys', '2d': '2D-karta', 'sphere': '3D-sfär', 'galaxy': 'Galax' },
    map3dFailed: { title: '3D-vyn kunde inte startas', hint: 'Webbläsaren gav 3D-vyn ingen WebGL-kontext (grafikacceleration av, eller ingen GPU?). 2D-kartan och listorna fungerar utan den.', back: 'Tillbaka till 2D-kartan' },
    title: 'Problemkartläggning',
    intro: 'Workshopen som en bild. Problemen i ringen, deras grundorsaker intill, och i mitten hävstångspunkterna — storheter som fler än en grundorsak rör. Ju fler problem en hävstångspunkt når, desto närmare mitten ligger den.',
    vipupisteetTitle: 'Hävstångspunkter',
    vipupisteetHint: 'Ordnade efter hur många problem storheten når. En som når flera är den vars rörelse känns på mer än ett ställe.',
    noVipupisteet: 'Inga gemensamma hävstångspunkter på kartan ännu. En hävstångspunkt kommer upp på kartan när flera grundorsaker delar den.',
    reach: '{{juurisyyt}} grundorsaker · {{ongelmat}} problem',
    carries: 'Bär {{count}} grundorsaker:',
    legendApproved: 'Godkänd grundorsak',
    legendRejected: 'Förkastad',
    legendUnjudged: 'Ej bedömd',
    legendApproval: 'Grundorsakens färg: godkännande 0 % (röd) – 100 % (grön), grå = inga röster',
    sources: {
      fold: 'Källor ({{count}})',
      web: 'Webbkällor',
      webNote: 'Sökt på webben, begränsat till granskade utgivare.',
      openPage: 'Öppna sidan',
      answered: 'Svarade på',
      pageAge: 'Publicerad',
      credibility: { research: 'Forskning', official: 'Myndighet', organisation: 'Organisation', interest: 'Intresseorganisation', news: 'Nyhet' },
      unavailable: 'Källtjänsten svarade inte — resonemanget kunde inte kontrolleras mot materialet.',
      none: 'Ingen källa i workshopens material.',
      workshop: 'Workshopens material',
    },
    review: {
      noVotes: 'inga röster',
      approval: '{{pct}} % · {{votes}} röster',
      earlierVersion: 'v{{version}}: {{approve}}/{{votes}} godkände, preciserad',
    },
    admin: {
      summary: '{{cards}} grundorsaker · {{voted}} röstade · {{kept}} behållna · {{revised}} omformulerade · {{toDelete}} tas bort · {{culled}} borttagna · {{open}} ej diskuterade',
      openHint: 'Bedömningarna är öppna. Lås dem med knappen i flödeskontrollen när diskussionen är klar.',
      lockedBy: 'Låst {{at}} ({{by}})',
      unlock: 'Lås upp',
      unlockReason: 'Varför låsa upp? Orsaken sparas.',
      swipeTab: 'Svepning',
      discussionTab: 'Diskussion',
      deckTally: '{{cards}} kort · {{voted}} röstade · {{votes}} röster',
      tally: '👍 {{approve}} · 👎 {{reject}} · ✎ {{refine}}',
      splitSelf: 'Upphovspersoner 👍 {{approve}} · 👎 {{reject}} · ✎ {{refine}}',
      splitOutside: 'Andra 👍 {{approve}} · 👎 {{reject}} · ✎ {{refine}}',
      onWall: 'Visa på väggen',
      offWall: 'Ta bort från väggen',
      keep: 'Behåll',
      edit: 'Redigera',
      reject: 'Förkasta',
      undoReject: 'Ångra förkastning',
      askAi: 'Fråga AI',
      notePlaceholder: 'Vad säger rummet? (AI använder detta)',
      saveVersion: 'Spara ny version (godkänd)',
      culled: 'Borttagen från kartan',
      wallEmpty: 'Grundorsaken som diskuteras visas här när facilitatorn sätter upp den på väggen.',
      outcomes: { keep: 'Behållen', revise: 'Omformulerad', reject: 'Tas bort' },
      moderatePrompt: 'Rummet röstade om denna grundorsak: {{approve}} godkände, {{reject}} förkastade, {{refine}} bad om precisering. Rummet säger: {{note}}. Nämn kort vad oenigheten verkar handla om och föreslå en skarpare formulering.',
    },
    legendMeasured: 'Uppmätt hävstångspunkt',
    legendProposed: 'Föreslagen hävstångspunkt',
    legendLateral: 'Når flera problem',
  },
  juurisyyV2: {
    generation: {
      loading: 'Laddar…',
      neverRun: 'Grundorsakerna har inte genererats än. Facilitatorn startar det.',
      running: 'Genererar grundorsaker… {{done}} / {{total}} hinder',
      connecting: 'Kopplar ihop grundorsaker och hävstångspunkter…',
      building: 'Kartan växer…',
      failed: 'Allt kunde inte genereras. Du kan ändå öppna kartan.',
      doneTitle: 'Grundorsakerna är genererade',
      doneHint: 'Kartan är redo att bedömas.',
      open: 'Öppna kartan',
      openAnyway: 'Öppna kartan ändå',
      fallback: 'Den 3D-bilden kan inte visas på den här enheten.',
    },
    title: 'Grundorsaker',
    loading: 'Laddar…',
    error: 'Något gick fel',
    card: {
      whyTitle: 'Varför den här grundorsaken',
      metricsTitle: 'Hävstångspunkter och mätare',
      noMetrics: 'Grundorsaken har ingen hävstångspunkt än.',
      shows: 'Vad den skulle visa',
      latest: 'Senaste värde: {{value}} ({{period}})',
      table: 'Statistikcentralen: {{table}}',
      sources: 'Källor ({{count}})',
    },
    map: {
      hint: "Tryck på en grundorsak för att rösta. Tryck på ett hinder för att föreslå en ny.",
      all: "Alla",
      voteTitle: "Rösta om grundorsaken",
      proposeTitle: "Föreslå en grundorsak för det här hindret",
      yourVote: "Din röst",
      noVote: "Du har inte röstat om den här än",
      votes: "Röster",
      earlier: "Tidigare versioner",
      resetsVotes: "Redigering startar en ny version: de nuvarande {{count}} rösterna stannar hos den tidigare versionen och rummet röstar på nytt.",
      resetsNone: "Redigering startar en ny version som rummet röstar om.",
      stale: "Grundorsaken redigerades. Det här är den nuvarande versionen: rösta om den.",
      lockedNote: "Bedömningarna är låsta: rösterna ändras inte längre.",
      proposed: "Förslag",
      loadFailed: "Grundorsaken kunde inte laddas",
      counts: { approve: "Godkände", reject: "Avvisade", refine: "Skulle precisera" },
    },
    cardsLeft: 'Kort kvar: {{count}}',
    intro: {
      title: 'Så här fungerar det',
      body: 'AI:n har härlett grundorsakerna ur era hinder för förändring. Er uppgift är att bedöma dem — inte att skriva nya.',
      approve: 'Godkänn: detta är en verklig orsak i vår värld.',
      reject: 'Förkasta: detta stämmer inte. Kortet bevaras, förkastandet noteras.',
      refine: 'Precisera: något är fel. Ni säger vad, och får en ny version att bedöma.',
      swipeHint: 'Du kan också svepa kortet: höger godkänner, vänster förkastar.',
      start: 'Börja',
    },
    add: {
      open: 'Lägg till den saknade grundorsaken',
      pickAnchor: 'Vilket hinder är detta en grundorsak till?',
      pickAnchorHint: 'Välj det hinder för förändring som denna grundorsak upprätthåller.',
      noAnchors: 'Detta problem har inga hinder för förändring ännu.',
      writeTitle: 'Skriv grundorsaken med egna ord',
      writeHint: 'Berätta vad som upprätthåller detta hinder. AI:n formar det till ett kort — den ersätter inte er poäng med sin egen.',
      placeholder: 'Vi tror att bakom detta ligger…',
      proposalLabel: 'Förslag till kort',
      duplicate: 'Detta finns redan i högen, med andra ord:',
      save: 'Spara på kartan',
      saved: 'Sparat',
      changeAnchor: 'Byt hinder',
      cancel: 'Avbryt',
    },
    approve: 'Godkänn',
    reject: 'Förkasta',
    refine: 'Precisera',
    metricMeasured: 'Uppmätt',
    metricMeasurable: 'Föreslaget mått — statistik finns sannolikt',
    metricCount: '{{count}} mått',
    metricProposed: 'Föreslaget mått — inga mätdata',
    refineTitle: 'Vad är fel med denna?',
    refinePlaceholder: 'Berätta med egna ord…',
    send: 'Skicka',
    thinking: 'Tänker…',
    newVersion: 'Ny version',
    acceptVersion: 'Bedöm denna version',
    cancelRefine: 'Tillbaka till kortet',
    deckDone: 'Högen är genomgången.',
    locked: 'Bedömningarna är låsta',
    lockedHint: 'Facilitatorn har låst bedömningarna av grundorsakerna. Röstningen är stängd.',
    why: {
      title: 'Varför detta kort?',
      falsifier: 'Fel om:',
      ownReasoning: 'Avsiktligt resonemang:',
      more: 'Vad som skulle göra detta fel, och resonemanget bakom',
      unverified: 'Forskningskontrollen blev inte klar för detta kort.',
      unverifiedRefined: 'Formuleringen är preciserad av gruppen: den har ännu inte kontrollerats mot forskningen.',
      basis: { research: 'Forskning', analogue: 'Jämförelse', reasoned: 'Resonemang' },
    },
    links: {
      title: 'Kopplingar',
      shared: 'Delas med {{count}} andra grundorsaker (problem: {{ongelmat}})',
      alone: 'Delas ännu inte med andra grundorsaker',
      vipupiste: 'På kartan som hävstångspunkt',
      show: 'visa',
      hide: 'dölj',
      inLoop: 'Del av en återkopplingsslinga',
    },
    notFound: 'Kom den centrala grundorsaken inte fram?',
    notFoundHint: 'Om något väsentligt saknas, berätta.',
    backToDecks: 'Tillbaka till dina högar',
    decks: {
      title: 'Dina högar',
      hint: 'Bedöm grundorsakerna ett kort i taget: svep åt höger för att godkänna, åt vänster för att avvisa, eller be om en förfining.',
      own: 'Dina hinder för förändring',
      ownHint: 'AI:n härledde de här grundorsakerna ur de hinder ni skrev. Träffade den rätt?',
      others: 'Andras hinder',
      othersHint: 'En blick utifrån på hinder som andra skrivit.',
      left: '{{count}} / {{total}} kvar',
      done: 'Klar',
      allDone: 'Du har gått igenom alla dina högar. Tack!',
      more: 'Bedöm fler',
      noMore: 'Alla hinder för förändring har redan delats ut för bedömning.',
      none: 'Inga högar för dig än: grundorsakerna har inte härletts än, eller så har de redan avgjorts.',
      nextDeck: 'Nästa hög',
    },
    version: 'version {{n}}',
  },
  ongelmaV2: {
    title: 'Problem',
    intro: 'Vilket problem möter du i ditt arbete, eller har du identifierat i det här ämnet? Skriv en sak i taget, med egna ord.',
    hint: 'Skriv så många konkreta saker ni vill.',
    placeholder: 'Ett konkret problem eller en iakttagelse…',
    start: 'Börja',
    thinking: 'Tänker…',
    reply: 'Svara…',
    send: 'Skicka',
    refinedTitle: 'Förslag på formulering',
    useRefined: 'Använd denna',
    keepMine: 'Behåll min formulering',
    save: 'Spara problem',
    saved: 'Sparat',
    saving: 'Sparar…',
    yours: 'Dina problem',
    none: 'Du har inte sparat några problem än.',
    another: 'Skriv ett problem till',
    current: 'Pågående',
    discard: 'Kasta',
    error: 'Något gick fel',
  },
  systemicV2: {
    title: 'Problemkartläggning',
    subtitle: 'Hinder för förändring, en lins i taget',
    loading: 'Laddar…',
    error: 'Något gick fel',
    retry: 'Försök igen',
    back: 'Tillbaka',
    steps: {
      ongelma: 'Problem',
      lens: 'Lins',
      dialogue: 'Samtal',
    },
    crumbs: { label: 'Steg', pending: 'välj…' },
    ongelmaPicker: {
      title: 'Vilket problem tar ni er an?',
      subtitle: 'Välj den som er grupp arbetar med.',
      empty: 'Den här workshopen har inga problem ännu.',
      anchorCount: 'Hinder för förändring: {{count}}',
    },
    ongelmaRail: {
      change: 'Byt problem',
      changeLens: 'Byt lins',
    },
    lensPicker: {
      title: 'Genom vilken lins ser du?',
      subtitle: 'Linsen avgränsar vilka hinder för förändring du letar efter.',
      empty: 'Den här workshopen har inga linser definierade.',
    },
    dialogue: {
      close: 'Stäng samtalet',
      title: 'Vad håller detta på plats?',
      opening: 'Berätta med egna ord, eller börja från något av dessa.',
      ownWords: 'Jag berättar med egna ord',
      suggestionsTitle: 'Eller börja här',
      placeholder: 'Skriv här…',
      send: 'Skicka',
      thinking: 'Tänker…',
      anchorsTitle: 'Hittade hinder för förändring',
      anchorsEmpty: 'Inga hinder ännu — samtalet skapar dem.',
      accept: 'Spara som hinder för förändring',
      accepted: 'Sparat',
      remove: 'Ta bort hindret',
      removeConfirm: 'Ta bort hindret och grundorsakerna som härletts ur det?',
      removeYes: 'Ta bort',
      removeNo: 'Avbryt',
      removeJudged: 'Hindret kan inte längre tas bort: gruppen har redan bedömt dess grundorsaker.',
      finish: 'Klar med detta hinder',
      finishHint: 'När detta hinder är klart kan du byta lins eller problem.',
    },
    swapGuard: {
      title: 'Byta mitt i samtalet?',
      bodyLens: 'Samtalet om detta hinder lämnas oavslutat. En ny lins startar ett nytt samtal.',
      bodyOngelma: 'Samtalet om detta hinder lämnas oavslutat. Ett nytt problem startar ett nytt samtal.',
      confirm: 'Byt ändå',
      cancel: 'Fortsätt samtala',
    },
    chain: {
      holds: 'håller på plats',
      seenThrough: 'sett genom linsen',
    },
  },
  systemicMap: {
    title: 'Systemkarta',
    nodeTypes: {
      v1: { ongelma: 'Smärtpunkt', este: 'Hinder', juurisyy: 'Fenomen', vipupiste: 'Hävstångsvariabel' },
      v2: { ongelma: 'Problem', este: 'Hinder för förändring', juurisyy: 'Grundorsak', vipupiste: 'Hävstångspunkt' },
    },
    loading: 'Laddar…',
    refresh: 'Uppdatera',
    stages: {
      map: 'Karta',
      kipupisteet: 'Smärtpunkter',
      blockers: 'Hinder',
      esteet: 'Hinder',
      loops: 'Loopar',
    },
    empty: {
      title: 'Kartan är tom',
      body: 'Börja med att lägga till en smärtpunkt — en oönskad situation som experter identifierar.',
      cta: 'Lägg till första smärtpunkten',
    },
    deepen: {
      title: 'Fördjupa hinder',
      subtitle: 'Samtala med AI mot konkreta fenomen',
      placeholder: 'Svara eller förtydliga…',
      send: 'Skicka',
      start: 'Börja fördjupning',
      loading: 'AI tänker…',
      candidates: 'Kandidatnoder',
      accept: 'Lägg till på kartan',
      editTitle: 'Redigera titel',
      agency: 'Aktörskap',
      close: 'Stäng',
      doneHint: 'Detta hinder verkar tillräckligt djupt — du kan stänga eller fortsätta.',
      openFromNode: 'Fördjupa med AI',
      error: 'Fördjupningen misslyckades',
    },
    addKipupiste: 'Lägg till smärtpunkt',
    flowerList: {
      title: 'Smärtpunkter',
      orphans: 'Övriga noder',
      noPetals: 'Inga hinder ännu',
    },
    errors: {
      noInstance: 'Välj en workshopinstans (kid) för att öppna systemkartan.',
      loadFailed: 'Kunde inte ladda systemkartan.',
      esteEsteForbidden: 'Två hinder kan inte kopplas direkt — lägg till ett fenomen emellan.',
    },
    edgeModal: {
      title: 'Koppling',
      proposed: 'AI-förslag — bekräfta eller redigera',
      confirmed: 'Bekräftad',
      contested: 'Omstridd',
      aiSuggested: 'AI',
      polarity: 'Effekt',
      strengthens: '+ Förstärker',
      weakens: '− Försvagar',
      strength: 'Styrka',
      strengthWeak: 'Svag',
      strengthStrong: 'Stark',
      rationale: 'Motivering',
      rationalePlaceholder: 'Varför fungerar kopplingen så här?',
      counterArgument: 'Alternativ väg',
      answerTest: 'Ditt svar på testfrågan (valfritt)',
      answerTestPlaceholder: 'Hur skulle du testa detta?',
      save: 'Spara',
      confirm: 'Bekräfta förslag',
      reject: 'Ta bort koppling',
      close: 'Stäng',
      spineHint: 'Detta är en layoutlänk. Sparande skapar en typad kausal kant ovanpå den.',
      saveSpine: 'Skapa typad koppling',
      addBlocker: 'Lägg till hinder för denna koppling',
    },
    loops: {
      title: 'Återkopplingsloopar',
      empty: 'Inga bekräftade loopar ännu. Bekräfta kantpolariteter för att hitta förstärkande (R) och balanserande (B) loopar.',
      reinforcing: 'R',
      balancing: 'B',
      nodes: 'noder',
      nameWithAi: 'Namnge med AI',
      naming: 'Namnger…',
      leverageWithAi: 'Hävstångspunkter med AI',
      leverageLoading: 'Söker hävstångspunkter…',
      leverageTitle: 'Möjliga hävstångspunkter',
    },
    list: {
      title: 'Lista',
      nodes: 'Noder',
      connections: 'Kopplingar',
      loops: 'Loopar',
      nodesEmpty: 'Inga faktorer på kartan ännu.',
      connectionsEmpty: 'Inga kopplingar ännu.',
      filtersLabel: 'Filtrera efter nodtyp',
    },
    duplicates: {
      title: 'Liknande faktor hittades',
      subtitle: '”{{existing}}” verkar vara densamma som nya ”{{neu}}”. Använd den befintliga?',
      useExisting: 'Använd befintlig',
      keepBoth: 'Behåll båda',
    },
    assumption: {
      reveal: 'Visa antagande med AI',
      loading: 'Visar antagande…',
      label: 'Antagande',
      testQuestion: 'Testfråga',
    },
    critique: {
      title: 'Kartkritik',
      run: 'Kartkritik',
      loading: 'Analyserar…',
      empty: 'Inga frågor den här gången.',
      close: 'Stäng',
      check: 'Kontrollera med AI',
      checking: 'Kritisk AI tänker…',
      errorTimeout: 'Kontrollen tog för lång tid. Du kan försöka igen eller lägga till ändå.',
      errorFailed: 'Kontrollen misslyckades. Du kan försöka igen eller lägga till ändå.',
      dialogHint: 'Skriv faktorn och tryck Kontrollera — AI utmanar form, mekanism och trovärdighet före sparning.',
      checkFirstHint: 'Sparning låses upp efter kontrollen. Vid fel kan du ändå lägga till.',
      verdictReady: 'Redo för kartan',
      verdictRefine: 'Värt att förfina',
      mechanism: 'Mekanism',
      relevance: 'Relevans',
      plausibility: 'Trovärdighet',
      suggestedRewrite: 'Föreslagen omskrivning',
      applyRewrite: 'Använd förslaget',
      applyRewriteAndAdd: 'Lägg till med denna formulering',
      possibleDuplicate: 'Möjlig dubblett: ”{{title}}”',
      replyLabel: 'Ditt svar till AI',
      replyPlaceholder: 'Motivera eller förfina…',
      sendReply: 'Skicka svar',
      edit: 'Redigera',
      addAnyway: 'Lägg till ändå',
      openQuestion: 'Öppen fråga',
      replyNow: 'Svara nu',
      dialogueTitle: 'Kritisk dialog',
      contestedFilter: 'Omstridda',
      contestedEmpty: 'Inga omstridda noder eller kanter.',
      categories: {
        gap: 'Lucka',
        hub: 'Nav',
        loop: 'Loop',
        contested: 'Omstridd',
        rationale: 'Motivering',
        dialogue: 'Dialog',
        other: 'Övrigt',
      },
    },
    blockers: {
      title: 'Hinder (motstår förändring)',
      suggestAi: 'Föreslå hinder med AI',
      loading: 'Frågar AI…',
      empty: 'Inga förslag ännu. Kör AI-förslag eller lägg till ett hinder manuellt.',
      weakens: 'Försvagar',
      accept: 'Lägg till på kartan',
      dismiss: 'Avvisa',
      manualTitle: 'Lägg till hinder manuellt',
      fieldTitle: 'Hinder',
      fieldDescription: 'Beskrivning',
      fieldTarget: 'Vad försvagar det?',
      pickTarget: 'Välj en smärtpunkt…',
      pickKipupiste: 'Välj först en smärtpunkt som hindret hör till.',
      add: 'Lägg till hinder',
      proposedTitle: 'Obekräftade hinder',
      confirm: 'Bekräfta',
      reject: 'Avvisa koppling',
      scopeLabel: 'Kan vi påverka detta?',
      scopeEndogenous: 'Vi kan påverka detta',
      scopeExogenous: 'Utanför vår kontroll — randvillkor',
      fromEdgeHint: 'Hindret kopplas till den valda förbindelsen (försvagar dess målnod).',
      votes: '{{count}} röster',
      vote: 'Rösta',
      unvote: 'Ta bort röst',
    },
    addNode: {
      title: 'Lägg till nod',
      kipupisteTitle: 'Lägg till smärtpunkt',
      esteTitle: 'Lägg till hinder',
      ilmioTitle: 'Lägg till fenomen',
      from: 'Förälder',
      text: 'Titel',
      description: 'Beskrivning (valfritt)',
      save: 'Spara',
      saveReady: 'Lägg till på kartan',
      cancel: 'Avbryt',
    },
    suggestConnections: {
      title: 'Föreslagna kopplingar',
      subtitle: 'AI hittade möjliga länkar för ”{{node}}”. Acceptera bara om motiveringen håller.',
      loading: 'Söker möjliga kopplingar…',
      empty: 'AI hittade inga nya kopplingsförslag för denna nod.',
      linkMeta: '{{polarity}} · tillit {{confidence}}%',
      bridgeVia: 'Kräver ett fenomen mellan hinder: ”{{title}}”',
      accept: 'Lägg till som förslag',
      acceptBridge: 'Lägg till fenomen + länkar',
      dismiss: 'Avvisa',
      close: 'Stäng',
    },
    nodeModal: {
      title: 'Redigera nod',
      text: 'Text',
      description: 'Beskrivning',
      relations: 'Kopplingar (klicka för att redigera)',
      noRelations: 'Inga kopplingar ännu. Lägg till en konsekvens, länka en befintlig nod eller klicka på en kant.',
      spine: 'layout',
      starterHint: 'Scenariorot — text kan redigeras; borttagning är inte tillåten.',
      save: 'Spara',
      addChild: 'Lägg till konsekvens',
      addEste: 'Lägg till hinder',
      addIlmio: 'Lägg till fenomen',
      addConnection: 'Länka till befintlig',
      suggestConnections: 'Föreslå kopplingar (AI)',
      linkOther: 'Annan faktor',
      linkPick: 'Välj en nod…',
      linkDirection: 'Riktning',
      linkFromHere: 'Från denna → annan',
      linkToHere: 'Från annan → denna',
      linkPolarity: 'Effekt',
      linkSave: 'Skapa koppling',
      linkCancel: 'Avbryt',
      linkNoneLeft: 'Alla andra noder är redan länkade till denna.',
      delete: 'Ta bort nod',
      close: 'Stäng',
      scopeLabel: 'Hindrets karaktär',
      votes: '{{count}} röster',
      vote: 'Rösta',
      unvote: 'Ta bort röst',
    },
    layout: {
      arrange: 'Ordna',
      arrangeHint: 'Ordnar om kartan',
    },
    view: {
      flat: '2D',
      sphere: '3D',
      galaxy: 'Galax',
    },
    pan: {
      label: 'Flytta kamerafokus',
      forward: 'Panorera framåt',
      back: 'Panorera bakåt',
      left: 'Panorera åt vänster',
      right: 'Panorera åt höger',
      up: 'Panorera uppåt',
      down: 'Panorera nedåt',
      recenter: 'Centrera till origo',
    },
    guide: {
      title: 'Så använder du systemkartan',
      dismiss: 'Uppfattat',
      mouse: {
        open: 'Håll musen över en faktor för förhandsvisning, klicka för att öppna.',
        loops: 'Håll musen över en loop för att spåra den på kartan, klicka för att välja.',
        navigate: 'Scrolla för att zooma, dra för att panorera.',
      },
      touch: {
        open: 'Tryck på en faktor för att markera den, tryck igen för att öppna.',
        loops: 'Tryck på en loop i panelen för att spåra den på kartan.',
        navigate: 'Dra för att panorera, nyp för att zooma.',
      },
    },
    legend: {
      title: 'Förklaring',
      starter: 'Scenariorot',
      factor: 'Faktor',
      blocker: 'Hinder',
      ongelma: 'Smärtpunkt',
      este: 'Hinder',
      ilmio: 'Fenomen',
      strengthens: '+ Förstärker',
      weakens: '− Försvagar (streckad)',
      strengthWeak: 'Svag koppling (tunn)',
      strengthStrong: 'Stark koppling (tjock)',
      proposed: 'AI-förslag (streckad)',
      loop: 'Loop (rörlig glöd)',
    },
  },

  painPoints: {
    title: 'Smärtpunktsinsamling',
    loading: 'Laddar…',
    quickfireHint: 'Skriv snabbt in så många konkreta frågor ni vill.',
    inputPlaceholder: 'En smärtpunkt eller fråga…',
    add: 'Lägg till',
    allInputs: 'Alla inlägg',
    yours: 'Dina',
    noInputs: 'Inga inlägg ännu.',
    clusters: 'Föreslagna smärtpunkter',
    runCluster: 'Klustra med AI',
    clustering: 'Klustrar…',
    promote: 'Skapa smärtpunkter på kartan',
    noClusters: 'Inga kluster ännu — samla inlägg och klustra.',
    members: 'medlemmar',
    drop: 'Ta bort',
    restore: 'Återställ',
    editPrompt: 'Redigera prompt',
    savePrompt: 'Spara',
    cancel: 'Avbryt',
    suggestWording: 'Föreslå formulering',
  },

  manualInputs: {
    saving: 'Sparar…',
    locked: 'Workshoppen är låst. Lås upp den innan du matar in uppgifter för hand.',
    loading: 'Laddar…',
    staticPivots: {
      title: 'Vändpunkter från färdig lista',
      intro: 'Skriv eller klistra in vändpunkterna, en per rad. Lägg till en beskrivning efter ett lodstreck: Rubrik | beskrivning. Sparandet gör just dessa till listans vändpunkter; tidigare vändpunkter från listan slutar vara vändpunkter men raderas inte.',
      current: 'Instansen har nu {{count}} vändpunkter.',
      placeholder: 'Energipris | Hur priset styr val\nKollektivtrafik',
      save: 'Spara {{count}} vändpunkter',
      saved: 'Sparade {{count}} vändpunkter.',
    },
    hmw: {
      title: 'Tänk om-frågor för hand',
      intro: 'Skriv frågorna, en per rad. Sparandet ersätter den nuvarande listan.',
      placeholder: 'Tänk om…?',
      save: 'Spara {{count}} frågor',
      saved: 'Sparade {{count}} frågor.',
    },
    lensItems: {
      title: 'Hinder och möjligheter för hand',
      intro: 'Lägg till ett hinder eller en möjlighet till en vändpunkt genom en av de sex linserna. Redigera och ta bort dem i vyn Hinder och möjligheter.',
      noPivots: 'Instansen har inga vändpunkter ännu. Mata in dem först.',
      pivot: 'Vändpunkt',
      lens: 'Lins',
      type: 'Typ',
      obstacle: 'Hinder',
      opportunity: 'Möjlighet',
      itemTitle: 'Rubrik',
      add: 'Lägg till',
      count: 'Hinder och möjligheter totalt: {{count}}',
    },
  },

  navigation: {
    results: 'RESULTAT',
    impactPath: 'Effektkarta',
    systemicMap: 'Systemkarta',
    painPoints: 'Smärtpunktsinsamling',
    v2Ongelmat: 'Problem',
    v2Ankkurit: 'Hinder för förändring',
    v2Juurisyyt: 'Grundorsaker',
    impactPathScenarios: 'Scenarier',
    impactPathMap: 'Effektkarta',
    pivotPoints: 'Vändpunkter',
    ragSourceMap: 'Kunskapsbas',
    ragSourceMapV2: 'Kunskapsbas (v2)',
    dashboard: 'Lägesbild',
    lenses: 'Hinder och möjligheter',
    solutions: 'Lösningar',
    report: 'AI-sammanfattning',
    backToInstances: 'Tillbaka till instansval',
    home: 'Startsida',
    userSettings: 'Användarinställningar',
    signOut: 'Logga ut / byt användare',
    signOutShort: 'Logga ut',
    locked: 'Låst',
    moduleLocked: 'Workshoppen har inte kommit hit ännu',
    menuUnavailable: 'Menyn kunde inte laddas: {{error}}',
    phasesOpen: 'Öppna faserna',
    phasesClose: 'Stäng faserna',
    phasesHeading: 'Kuutions faser',
    leaveWorkshopConfirm: 'Lämna workshopen?',
  },

  drawer: {
    chat: 'Chat',
    settings: 'Inställningar',
    widthMode: {
      label: 'Panelens bredd',
      normal: 'Normal',
      wide: 'Bred',
      full: 'Full bredd',
      next: 'Byt bredd: {{mode}}',
    },
  },

  tooltip: {
    dismissSession: 'Visa inte igen',
    close: 'Stäng',
  },

  reportsList: {
    loading: 'Laddar rapporter...',
    pageTitle: 'Kuutio-rapporter',
    subtitle: 'Resultat från framtidsworkshops — scenarier, påverkansvägar, lösningar och AI-analys',
    empty: 'Inga publicerade rapporter ännu.',
    solutionsCount: '{{count}} lösningar',
    transcriptsCount: '{{count}} inlägg',
    participantsCount: '{{count}} deltagare',
  },

  screenClient: {
    loading: 'Laddar...',
    selectDisplay: 'Välj skärm',
    selectInstanceAndDisplay: 'Välj instans och skärm',
    selectInstancePlaceholder: 'Välj instans...',
    changeInstance: 'Byt instans',
    selectInstanceFirstHint: '☝️ Välj först en instans ovan',
    displaysSection: 'Skärmar',
    ipadsSection: 'iPad',
    wallRow: 'Vägg {{id}} ({{name}})',
    wallNorth: 'Norr',
    wallEast: 'Öster',
    wallSouth: 'Söder',
    wallWest: 'Väster',
    screenTakeoverConfirm: 'Skärmen {{code}} används redan. Ta över?',
  },

  workshopControls: {
    selectInstanceTitle: 'Välj först en instans',
    selectInstanceBody: 'Gå till Admin-startsidan för att välja instans.',
    adminHome: 'Admin-startsida',
    pageTitle: 'Workshopstyrning',
    pageDescription:
      'För varje scenario, välj vilken framtidsbild deltagare använder i påverkansvägen. "Egen framtidsbild" betyder att deltagare börjar från tom bord utan fördefinierade variabler.',
    noScenariosTitle: 'Inga scenarier',
    noScenariosBody: 'Denna instans har inga scenarier ännu.',
    futuresAvailable: '{{count}} framtidsbilder tillgängliga',
    activeFutureLabel: 'Aktiv framtidsbild',
    customFuture: 'Egen framtidsbild',
    freeBadge: 'Fri',
    saving: 'Sparar...',
    saved: 'Sparat',
    noFuturesForScenario: 'Inga framtidsbilder definierade för detta scenario',
    topicFocusTitle: 'Ämnesfokus',
    topicFocusDescription:
      'Välj workshopens fokus. Det valda perspektivet visas i påverkansvägen och styr AI-analys i alla frågor.',
    selectedPerspectiveLabel: 'Valt perspektiv',
    noPerspectiveAll: 'Inget valt — alla perspektiv',
    noFocusTitle: 'Ingen avgränsning',
    noFocusDescription: 'Alla perspektiv är likvärdiga — inget fokusområde',
  },

  workshopReport: {
    reportTitle: 'Rapport',
    workshopReportTitle: 'Workshoprapport',
    selectInstanceFirst: 'Välj en instans i Admin Hub för att se rapporten.',
    backToAdmin: '← Tillbaka till Admin Hub',
    errorTitle: 'Fel',
    retry: 'Försök igen',
    pageToolbarTitle: 'Rapport',
    generating: 'Genererar...',
    refreshReport: 'Uppdatera',
    generateReport: 'Generera rapport',
    noReportYet: 'Ingen rapport ännu',
    noReportHint: 'Klicka på "Generera rapport" för att skapa en sammanfattning av workshopen.',
    generateBig: 'Generera rapport',
    generatingReport: 'Genererar rapport...',
    summarySection: 'Sammanfattning',
    statParticipants: 'Deltagare',
    statSuggestions: 'Förslag',
    statScenarios: 'Scenarier',
    moodDistribution: 'Stämningsfördelning',
    moodPositive: 'Positiv',
    moodNeutral: 'Neutral',
    moodConcerned: 'Orolig',
    chartsSection: 'Diagram',
    chartScenarioActivity: 'Scenarioaktivitet',
    noData: 'Ingen data',
    footerPlatform: 'Kuutio Workshop Platform',
    footerGenerated: 'Rapport genererad {{date}}',
    loadError: 'Fel vid inläsning av data: {{message}}',
    unknownScenario: 'Okänd',
  },

  lenses: {
    pivotLabel: 'Vändpunkt',
    stepLenses: 'Hinder och möjligheter',
    navLenses: 'Linser',
    navOverview: 'Översikt',
    navPivot: 'Vändpunkt',
    navEM: 'E&M',
    noInstance: 'Ingen instans vald. Lägg till URL-parametern ?kid= eller ?instance=.',
    loadingData: 'Laddar hinder och möjligheter...',
    loadErrorTitle: 'Fel vid inläsning av data',
    pivotSummaryNeedPivot: 'Välj en vändpunkt före sammanfattningen.',
    pivotSummaryLoadFailed: 'Kunde inte ladda sammanfattningen. Försök igen.',
    pivotReportFailed: 'Kunde inte skapa rapporten. Försök igen.',
    pivotSummaryBtn: 'Sammanfattning och analys',

    // Dashboard tabs & chrome
    tabSummary: 'Sammanfattning',
    tabPivots: 'Vändpunkter ({{count}})',
    tabBrief: 'Kort sammanfattning',
    tabInnovations: 'Innovationer',
    tabListing: 'Lista',
    itemsCount: '{{count}} poster',
    obstacleOne: 'hinder',
    obstacleOther: 'hinder',
    opportunityOne: 'möjlighet',
    opportunityOther: 'möjligheter',
    manualCount: '{{count}} manuella',
    aiCount: '{{count}} AI',
    ragCount: '{{count}} RAG',
    evaluatedTags: 'Bedömda (taggar) {{count}}',
    qualityScore: 'Relevans {{score}}',
    researchSupport: 'Kunskapsbas {{score}}',
    pivotPointsSection: 'Vändpunkter ({{count}})',
    emptyItems: 'Inga poster ännu. Lägg till hinder och möjligheter via linserna.',
    noInstanceBrief: 'Ingen instans — sammanfattningen kan inte laddas.',
    noInstanceInnov: 'Ingen instans — innovationer kan inte laddas.',
    unknownPivot: 'Okänd vändpunkt',
    briefFailed: 'Sammanfattning misslyckades ({{status}})',
    innovFailed: 'Innovationer misslyckades ({{status}})',

    // Pivot summary
    formingPivotSummary: 'Skapar sammanfattning för vändpunkten...',
    lensCountsTitle: 'Antal per lins',
    obstaclesCountShort: '{{count}} hinder',
    opportunitiesCountShort: '{{count}} möjligheter',
    viewClusters: 'Kluster',
    viewLenses: 'Linser',
    refreshClusters: 'Uppdatera kluster',
    refreshClusterAnalysis: 'Uppdatera klusteranalys',
    clustersStaleHint: 'Poster har ändrats — en facilitator kan uppdatera klusteranalysen.',
    formingClusters: 'Skapar kluster...',
    clusterFetchFailed: 'Klusterhämtning misslyckades ({{status}})',
    clustersFetchFailed: 'Kunde inte hämta kluster',
    noItems: 'Inga poster',
    obstacleClustersTitle: 'Hinderkluster',
    opportunityClustersTitle: 'Möjlighetskluster',
    clusterDefaultTitle: 'Kluster',
    unnamedItem: 'Namnlös post',
    obstacles: 'Hinder',
    opportunities: 'Möjligheter',
    pivotAnalysis: 'Vändpunktsanalys',
    membersCount: '{{count}} medlemmar',
    severityOptimism: 'Allvar {{severity}} / 5 · Optimism {{optimism}} / 5',
    report: 'Rapport',
    reportNotCreated: 'Ingen rapport har skapats för denna vändpunkt ännu.',
    creating: 'Skapar...',
    createReport: 'Skapa rapport',
    recreating: 'Skapar på nytt...',
    recreate: 'Skapa på nytt',

    // Simple / innovative / listing summaries
    formingBrief: 'Skapar sammanfattning...',
    tryAgain: 'Försök igen',
    noItemsToSummarize: 'Inga linsposter att sammanfatta ännu.',
    refresh: 'Uppdatera',
    keyFindings: 'Centrala fynd',
    notableBlockersOpps: 'Viktiga hinder och möjligheter',
    fromCache: 'Från cache (innehållet matchar aktuella poster).',
    pickingInnovations: 'Plockar innovativa perspektiv...',
    noItemsToAnalyze: 'Inga linsposter att analysera ännu.',
    innovationsTitle: 'Innovationer och överraskningar',
    noHighlights: 'Inga höjdpunkter returnerades.',
    related: 'Relaterat:',
    fromCacheShort: 'Från cache.',
    listing: 'Lista',
    noItemsToList: 'Inga poster att lista.',
    groupByLens: 'Gruppera efter lins',
    groupByType: 'Gruppera efter typ',
    obstacle: 'Hinder',
    opportunity: 'Möjlighet',

    // Item modal
    editObstacle: 'Redigera hinder',
    editOpportunity: 'Redigera möjlighet',
    addObstacle: 'Lägg till hinder',
    addOpportunity: 'Lägg till möjlighet',
    obstaclePrompt: 'Vad hindrar eller saktar ner genomförandet av vändpunkten "{{title}}"{{lensSuffix}}?',
    opportunityPrompt: 'Vilken möjlighet öppnas i vändpunkten "{{title}}"{{lensSuffix}}?',
    lensSuffix: ' ur ett {{lens}}-perspektiv',
    writeObstacle: 'Skriv ett hinder...',
    writeOpportunity: 'Skriv en möjlighet...',
    saveLocked: 'Workshoppen är låst, så det går inte att spara nu. Din text finns kvar i det här fönstret.',
    saveFailed: 'Det gick inte att spara: {{error}}. Din text finns kvar i det här fönstret.',
    findObstaclesOpps: 'Hitta hinder och möjligheter',
    eachLensPerspective: 'Varje lins lyfter sitt eget perspektiv',
    letsStart: 'Nu kör vi!',

    // Pivot curation (post–Let's go)
    curation: {
      title: 'Teamens vändpunkter',
      empty: 'Inga vändpunkter',
      add: 'Lägg till vändpunkt',
      selectTitle: 'Välj denna vändpunkt',
      selectionHint: 'Välj de vändpunkter som bearbetas i nästa skeden · {{selected}}/{{total}} valda',
    },
    editModal: {
      createTitle: 'Lägg till vändpunkt',
      editTitle: 'Redigera vändpunkt',
      titleLabel: 'Titel',
      titlePlaceholder: 'Vändpunktens titel...',
      descriptionLabel: 'Beskrivning',
      descriptionPlaceholderCreate: 'Kort beskrivning av vändpunkten...',
      descriptionPlaceholderEdit: 'Beskrivning...',
      generateAi: 'Generera med AI',
      generating: 'Genererar...',
      regenerate: 'Generera igen',
      generateTitle: 'Generera beskrivning med AI',
      replaceTitle: 'Ersätt aktuell AI-text',
      aiHint: 'AI-genererad — redigera fritt',
    },
    pivotPointsNav: 'Vändpunkter',
    lensFallback: 'Lins',
    aiObstacles: 'AI-hinder',
    aiOpportunities: 'AI-möjligheter',
    emptyLensDetail: 'Lägg till hinder och möjligheter för denna vändpunkt ur linsen "{{lens}}".',
    emptyLensDetailAi: 'Eller låt AI föreslå dem utifrån forskning.',
    emptyNoItemsYet: 'Inga hinder eller möjligheter ännu',
    aiSuggestionsTitle: 'AI: {{type}}',
    aiAnalyzingResearch: 'Analyserar forskningsmaterial...',
    aiAnalyzingHint: 'Det tar en stund — AI går igenom forskningsdatabasen',
    aiSuggestFailed: 'Kunde inte skapa AI-förslag.',
    noSuggestions: 'Inga förslag tillgängliga.',
    suggestMore: 'Föreslå fler',
    adding: 'Lägger till...',
    addSelected: 'Lägg till valda ({{count}})',
    aiSuggestsObstacles: 'AI föreslår hinder',
    aiSuggestsOpportunities: 'AI föreslår möjligheter',
    editBeforeAdd: 'Redigera vid behov innan du lägger till',
    selectAndEditBeforeAdd: 'Välj och redigera innan du lägger till',
    aiAnalyzingGenerating: 'AI analyserar och genererar förslag...',
    aiCouldNotGenerate: 'AI kunde inte generera förslag.',
    tryAgainOrManual: 'Försök igen eller lägg till manuellt.',
    aiSelectorHint: 'AI-förslag bygger på forskning. Välj vad du vill behålla, redigera vid behov och lägg till.',
    descriptionPlaceholder: 'Beskrivning...',
    edited: 'redigerad',
    confidence: 'Tillförlitlighet: {{pct}}%',
    selectedCount: 'Valda: {{selected}} / {{total}}',
    sourceManual: 'Manuell',
    sourceAiGenerated: 'AI-genererad',
    sourceResearch: 'Forskningsmaterial',
    tabDetails: 'Uppgifter',
    tabConnections: 'Kopplingar ({{count}})',
    tabSources: 'Källor ({{count}})',
    metadata: 'Metadata',
    aiConfidence: 'AI-tillförlitlighet',
    addedBy: 'Tillagd av',
    relatedItems: 'Relaterade hinder och möjligheter',
    noRelatedItems: 'Inga relaterade poster.',
    own: 'Egen',
    aiAnalyzing: 'AI analyserar...',
    untitled: 'Namnlös',
    requestFailed: 'Begäran misslyckades',
    clustersRefreshFailed: 'Kunde inte uppdatera kluster',
    deleteItemTitle: 'Ta bort post',
    deletePivotTitle: 'Ta bort vändpunkt',
    deleteConfirm: 'Ta bort "{{title}}"? Detta kan inte ångras.',
    matrixTitle: 'Vändpunkt × Lins-matris',
    totalShort: 'Tot.',
    total: 'Totalt',
    lensDistribution: 'Linsfördelning',
  },

  solutionAnalysis: {
    title: 'Analys och utvärdering',
    swot: {
      strengths: 'Styrkor',
      weaknesses: 'Svagheter',
      opportunities: 'Möjligheter',
      threats: 'Hot',
    },
    swotTitle: 'SWOT-analys',
    nextSteps: {
      title: 'Så här går vi vidare',
      universal: 'För alla städer',
      town: 'För er · {{town}}',
    },
    lensesTitle: 'Linser',
    lensesAssessed: '{{count}} linser bedömda',
    coverageTitle: 'Linstäckning',
    coverageAddressed: '{{count}} täckta',
    coverageAnswered: '{{count}} hinder besvarade',
    coverageOpen: '{{count}} öppna hinder',
    eval: {
      impact: "Genomslag",
      feasibility: "Genomförbarhet",
      innovation: "Innovation",
      evidence: "Forskningsstöd",
    },
    solutionsTitle: "Lösningar",
    solutionsIntro: "Workshopgrupperna utvecklade {{count}} lösningsförslag till forskningsfrågan.",
    hybridTitle: "Kombinerade lösningar",
    hybridIntro: "AI:n analyserade workshopens {{count}} lösningsförslag och identifierade kombinationer där flera gruppers förslag kompletterar varandra.",
  },
  instanceSettingsModal: {
    modalTitle: 'Instansinställningar',
    modalSubtitle: 'Redigera denna Kuutio-instans och hantera dess tillstånd.',
    successSaved: 'Ändringar sparades.',
    statsHeading: 'Statistik',
    statParticipants: 'Deltagare',
    statPatterns: 'Mönster',
    statDays: 'Dagar',
    labelName: 'Namn',
    labelDescription: 'Beskrivning',
    labelWorkshopGoal: 'Workshopens mål',
    placeholderWorkshopGoal: 'T.ex. Vad krävs för att arbetsgivare ska anställa unga?',
    helpWorkshopGoal: 'Frågan som workshopen söker svar på. AI:n styrs att hitta hävstångspunkter och utvärdera lösningar mot detta mål. Obligatoriskt fält.',
    workshopGoalRequired: 'Workshopens mål är obligatoriskt — frågan som workshopen söker svar på.',
    labelAiContextDescription: 'AI-kontextbeskrivning',
    helpAiContextDescription: 'Beskrivning av Kuutio och denna workshop som infogas i AI-promptarna. Du kan redigera standardtexten direkt. Lämna den oförändrad för att behålla den delade standarden.',
    langFi: 'Finska',
    langEn: 'Engelska',
    langSv: 'Svenska (sv-FI)',
    labelStatus: 'Status',
    labelType: 'Typ',
    typeLive: 'Live — fysisk workshop (iPad)',
    typeOnline: 'Online — distansdeltagare',
    googleSlidesLabel: 'Google Slides-presentation',
    googleSlidesHelp: 'Klistra in Google Slides URL eller ID. Används för workshopens bilder.',
    slideImagesLabel: 'Bilder',
    syncImages: 'Synka bilder',
    syncingImages: 'Synkar...',
    imagesSyncedProgress: '{{synced}}/{{total}} bilder synkade',
    syncedCount: '{{count}} synkade',
    skippedCount: '{{count}} hoppades över',
    errorsCount: '{{count}} fel',
    sheetSyncLabel: 'Synka från Google Sheet',
    sheetSyncHelp: 'Importera scenarier, variabler och flödessteg från ett Google Sheet.',
    loading: 'Laddar...',
    preview: 'Förhandsgranska',
    sync: 'Synka',
    syncing: 'Synkar...',
    previewBoxTitle: 'Förhandsgranskning',
    sheetInstance: 'Instans:',
    sheetScenarios: 'Scenarier:',
    sheetVariables: 'Variabler:',
    replaceConfigWarning: 'Detta ersätter nuvarande konfiguration',
    aiSuggestLabel: 'AI-förslag (hinder / möjligheter)',
    aiSuggestHint: 'Hur många AI-förslag per lins (standard 1)',
    testModeLabel: 'Testläge',
    openPinTitle: 'Öppen PIN',
    openPinDesc: 'Alla PIN accepteras (test / demo)',
    lockLabel: 'Lås',
    lockTitle: 'Lås instans',
    lockDesc: 'Förhindra ändringar i alla vyer (påverkansväg, vändpunkter, linser)',
    reportVisibilityLabel: 'Rapportsynlighet',
    implementationTitle: 'Visa avsnitt "Hur börjar vi?"',
    implementationDesc:
      'AI-genererade 12-månadersplaner visas med lösningar i rapporten',
    scenariosHeading: 'Scenarier',
    scenarioNamePlaceholder: 'Scenarionamn',
    scenarioDescPlaceholder: 'Beskrivning (valfritt)',
    hideScenario: 'Dölj',
    showScenario: 'Visa',
    deleteScenario: 'Ta bort',
    deleteScenarioContent: 'Scenariots påverkansväg har {{count}} noder eller hinder som deltagarna lagt till. De tas bort med scenariot när du sparar.',
    addScenario: 'Lägg till scenario',
    clearDataTooltip: 'Rensa all deltagarinmatning (behåller instansen)',
    clearData: 'Rensa data',
    deleteInstance: 'Ta bort instans',
    saveChanges: 'Spara ändringar',
    savingChanges: 'Sparar...',
    clearConfirmTitle: 'Bekräfta rensning',
    clearConfirmP1: 'Rensa all deltagardata från instansen "{{title}}"?',
    clearConfirmP2:
      'Detta tar bort det som workshopen producerat, dess röster och AI-resultat samt workshopens egna RAG-bitar, och flödet börjar om. Behålls: scenarier, variabler, linser, inställningar, PIN-koder, deltagare, kunskapsbasen (forskningsmaterialet) och deltagarnas förhandsuppgifter.',
    clearPreviewHeading: 'Tar bort {{count}} rader:',
    clearPreviewNothing: 'Inget att ta bort.',
    clearPreviewFailed: 'Förhandsvisningen misslyckades: {{error}}',
    clearing: 'Rensar...',
    deleteConfirmTitle: 'Bekräfta borttagning',
    deleteConfirmP1:
      'Ta bort instansen "{{title}}" permanent? All relaterad data tas bort.',
    deleting: 'Tar bort...',
    deletePermanently: 'Ta bort permanent',
    errorSyncFailed: 'Synk misslyckades',
    errorPreviewFailed: 'Förhandsgranskning misslyckades',
    errorSheetSyncFailed: 'Synk misslyckades',
    confirmSheetReplace: 'Detta ersätter alla nuvarande scenarier, variabler och flödessteg. Fortsätta?',
    syncDoneAlert: 'Synkat! {{scenarios}} scenarier, {{variables}} variabler',
    syncStart: 'Startar...',
    syncSyncingImages: 'Synkar {{total}} bilder...',
    syncLoadingImage: 'Laddar bild {{current}}/{{total}}',
    syncRetryRound: 'Nytt försök {{round}}/{{maxRounds}} ({{failedCount}} misslyckade)',
    syncRetryingSlide: 'Försöker igen {{slideIndex}}/{{total}} (runda {{round}})',
    timeJustNow: 'nyss',
    timeMinutesAgo: '{{count}} min sedan',
    timeHoursAgo: '{{count}} h sedan',
    timeDaysAgo: '{{count}} d sedan',
    newScenarioTitle: 'Nytt scenario',
    statusReadOnlyHint: 'Ändra i Workshop-vyn',
    pinLabel: 'Instans-PIN-kod',
    pinHelp: 'Deltagare loggar in med denna PIN direkt till denna instans.',
    lensesSectionLabel: 'Linser (hinder & möjligheter)',
    lensDescriptionTitle: 'Skapa även beskrivning',
    lensDescriptionDesc: 'AI skapar en beskrivning utöver titeln för hinder och möjligheter.',
    devSectionLabel: 'Utveckling',
    qaToggleTitle: 'QA-testning',
    qaToggleDesc: 'Visar QA-panelen i alla admin-vyer. Sparas endast på denna enhet.',
  },

  flowBuilder: {
    title: 'Workshopflöde',
    subtitle: '{{instance}} · byggare',
    save: 'Spara',
    cancel: 'Avbryt',
    unsaved: 'Osparade ändringar',
    allSaved: 'Allt sparat',
    fromTemplate: 'Börja från en mall…',
    fromInstance: 'Kopiera från en instans…',
    liveBanner: 'Du redigerar en pågående workshop',
    liveNow: 'Pågår nu: {{module}}. Sparade ändringar syns direkt för deltagarna.',
    readinessOk: 'Beredskap: allt som behövs finns',
    readinessManual: '{{count}} att mata in för hand',
    readinessOrder: '{{count}} ordningsvarning(ar)',
    readinessYellow: '{{count}} för hand eller valfria',
    readiness: 'Beredskap',
    palette: 'Moduler',
    paletteHint: 'Dra in i flödet eller klicka för att se beskrivningen.',
    inChain: 'I flödet',
    producesAlready: 'Överlappande modul: {{module}}',
    chain: 'Flöde',
    tieto: 'Uppgift',
    alwaysAvailable: 'Alltid tillgänglig',
    reportFixed: 'Alltid sist',
    noInputs: 'Kräver inga tidigare uppgifter',
    optional: 'valfri',
    statusUpstream: 'tillgänglig',
    statusSatisfied: 'tillgänglig',
    statusPreseeded: 'för hand',
    statusOrder: 'för sent',
    statusManual: 'saknas',
    statusOptional: 'inte tillgänglig',
    enterByHand: 'Mata in för hand',
    unsavedTag: 'Osparad',
    liveTag: 'Pågår',
    contentTag: 'Har innehåll',
    moveUp: 'Flytta upp',
    moveDown: 'Flytta ned',
    remove: 'Ta bort ur flödet',
    removeNote: 'Borttagning raderar inga uppgifter – modulens innehåll slutar bara visas. Ändringen sparas först med Spara.',
    addToChain: 'Lägg till i flödet',
    swapVersion: 'Byt till den här versionen',
    showInChain: 'Visa i flödet',
    conflictSameFamily: '{{other}} finns redan i flödet och producerar samma uppgifter. Flödet kan bara ha en version.',
    conflictOther: '{{other}} producerar redan {{handoff}}. Välj en av dem.',
    needs: 'Behöver',
    canUse: 'Använder om tillgänglig',
    produces: 'Producerar',
    facilitationTitle: 'För facilitatorn',
    facilitationWhat: 'Vad?',
    facilitationWhy: 'Varför?',
    facilitationHow: 'Hur?',
    facilitationEmpty: 'Inte ifyllt ännu',
    participantModule: 'Deltagare',
    facilitatorOnly: 'Endast facilitator',
    openInWorkshop: 'Öppna i workshopstyrningen',
    enterOnContent: 'Anges på sidan Innehåll under Förberedelse →',
    prepareSettings: 'Inställningar i förberedelsefasen',
    liveSettings: 'Inställningar i genomförandefasen',
    noSettings: 'Inga inställningar',
    liveSwitches: 'Brytare',
    liveActions: 'Åtgärder',
    livePanel: 'Kontrollpanel',
    prepareAfterAdd: 'Kan redigeras när modulen har lagts till i flödet.',
    tietoPreseeded: 'Inmatad för hand',
    tietoMissing: 'Saknas – matas in för hand',
    tietoOptionalMissing: 'Inte tillgänglig – valfri',
    tietoUnused: 'Används inte i flödet',
    consumers: 'Används av: {{list}}',
    hasContent: 'Har innehåll',
    noContent: 'Inget innehåll ännu',
    storage: 'Lagras i',
    producer: 'Produceras av',
    status: 'Status',
    content: 'Innehåll nu',
    noProducer: 'Ingen modul i flödet',
    editorsTitle: 'Mata in för hand',
    editorsBlocked: 'Spara först ändringarna i flödet – uppgifter som matas in för hand sparas direkt och ingår inte i utkastet.',
    editorWarnDestructive: 'Ersätter nuvarande innehåll',
    editorsNote: 'Uppgifter som matas in för hand kan också förifylla uppgifter som en senare modul producerar – modulen fortsätter från dem.',
    editorsOpenInWorkshop: 'Editorerna öppnas i workshopstyrningen vid den modulen.',
    templatesTitle: 'Börja från en mall',
    templatesNote: 'En mall ersätter utkastets flöde. Inget sparas före Spara, och inga uppgifter raderas.',
    templateSuggests: 'Föreslår inmatning för hand: {{list}}',
    copyTitle: 'Kopiera från en instans',
    copyNote: 'Den valda instansens flöde hamnar i utkastet. Inget sparas före Spara.',
    confirmTitle: 'Spara ändringarna i flödet?',
    confirmLive: 'Workshopen pågår ({{module}}). Ändringarna syns för deltagarna så snart de sparats.',
    confirmStarted: 'Workshopen har redan börjat.',
    confirmRemoved: 'Tas bort ur flödet: {{module}}.',
    confirmRemovedContent: 'Tas bort ur flödet: {{module}} – innehållet finns kvar, det slutar bara visas.',
    confirmRemovedLive: 'Den pågående modulen {{module}} tas bort – flödet går vidare till nästa modul.',
    confirmAdded: 'Läggs till i flödet: {{module}}.',
    confirmReordered: 'Ordningen ändras.',
    confirmLiveMoved: 'Den pågående modulen flyttas.',
    confirmSave: 'Spara ändringarna',
    confirmBack: 'Tillbaka till redigering',
    leaveConfirm: 'Du har osparade ändringar i flödet. Lämna ändå?',
    saved: 'Sparat.',
    saveFailed: 'Kunde inte spara: {{error}}',
    stale: 'Någon annan sparade flödet under tiden. Ladda om – ändringarna i ditt utkast går förlorade.',
    reload: 'Ladda om',
    close: 'Stäng',
    shortcuts: 'Tangenter: ↑ / ↓ flyttar vald modul · Delete tar bort · Ctrl+S sparar · Esc stänger',
    loadFailed: 'Flödet kunde inte laddas: {{error}}',
    noInstance: 'Välj först en instans.',
    openBuilder: 'Redigera flödet',
    drag: 'Dra för att flytta',
    view: 'Vy',
    viewStatic: 'Diagram',
    viewDynamic: 'Dynamisk',
    viewTimeline: 'Tidslinje',
    groupSocial: 'Sociala',
    addAgain: 'Lägg till igen',
    timelineStart: 'Kuutio börjar',
    timelineTotal: 'Totalt {{hours}} h {{minutes}} min',
    timelineSavedOnly: 'Tidslinjen visar det sparade flödet — spara ändringarna för att se dem här.',
    timelineDay: 'Dag {{day}}',
    timelineMin: 'min',
    timelineDayBreak: 'Börja en ny dag från det här steget',
    timelineAnchor: 'Ange en exakt starttid',
    timelineAnchorHint: 'Steget börjar exakt:',
    timelineAnchorClear: 'Ta bort starttiden',
    timelineNoStart: 'Ange Kuutios starttid så beräknas klockslag för varje steg.',
    timelineEnd: 'Kuutio slutar',
    legendIn: 'Indata',
    legendOut: 'Utdata',
    reportUsesThis: 'Rapporten använder detta',
    reportUsesCount: 'Rapporten använder {{count}} uppgifter',
    reportSections: 'Rapportens avsnitt',
    groupStart: 'Framtid',
    groupMapping: 'Kartläggning',
    groupPivots: 'Vändpunkter',
    groupWork: 'Linser och lösningar',
    groupSystemicV2: 'Problemkartläggning',
    groupForesight: 'Scenarier',
  },
  moduleFacilitation: {
    title: 'Facilitering',
    lead: 'Modulernas gemensamma faciliteringstexter – grunden som varje Kuutios manus utgår från. Ändringar gäller alla Kuutio och sparas som versioner. En Kuutios egna ändringar görs i dess manus.',
    search: 'Sök modul',
    selectModule: 'Välj en modul till vänster',
    noMatches: 'Inga träffar.',
    loadFailed: 'Det gick inte att ladda: {{error}}',
    group: { work: 'Arbetsfaser', social: 'Sociala' },
    minutes: '{{count}} min',
    editedBadge: 'Redigerad · v{{version}}',
    manifestBadge: 'Ursprunglig',
    finnishOnly: 'Du redigerar de finska texterna. Översättningarna behålls som de är.',
    field: {
      what: 'Vad',
      why: 'Varför',
      how: 'Hur',
      intro: 'Inledning (förslag på formulering)',
      technicalSetup: 'Teknisk uppställning',
      recommendedDuration: 'Rekommenderad längd (min)',
      steps: 'Körschema',
    },
    stepsTotal: 'Stegen totalt {{minutes}} min',
    stepTitle: 'Rubrik',
    stepMinutes: 'Min',
    stepText: 'Vad som händer',
    addStep: 'Lägg till steg',
    removeStep: 'Ta bort steg',
    moveUp: 'Flytta upp',
    moveDown: 'Flytta ned',
    versionName: 'Versionens namn',
    versionNameHint: 't.ex. efter K9',
    changeNote: 'Vad som ändrades',
    save: 'Spara',
    cancel: 'Avbryt',
    saved: 'Sparad som version {{version}}.',
    saveFailed: 'Det gick inte att spara: {{error}}',
    history: 'Versionshistorik',
    liveVersion: 'Nuvarande · v{{version}}',
    manifestLive: 'Nuvarande · ursprunglig text',
    manifestVersion: 'ursprunglig text',
    noVersions: 'Inga tidigare versioner.',
    preview: 'Visa',
    rename: 'Byt namn',
    restore: 'Återställ',
    restoreTitle: 'Återställa version {{version}}?',
    restoreMessage: 'Versionen återställs som en ny nuvarande version. Inget går förlorat: den nuvarande texten finns kvar i versionshistoriken.',
    restoredNote: 'Återställd version {{version}}',
    restored: 'Version {{version}} återställdes; den nuvarande är nu v{{live}}.',
    emptyText: 'Ingen text.',
  },
  scriptView: {
    title: 'Manus',
    hint: 'Alla steg i Kuutio med deras faciliteringstexter. Ändringar gäller bara denna Kuutio; modulernas gemensamma grund utvecklas separat.',
    edit: 'Redigera för denna Kuutio',
    noInstance: 'Välj först en Kuutio.',
    loadFailed: 'Det gick inte att ladda flödet: {{error}}',
    print: 'Skriv ut',
    editTimes: 'Redigera tider (Flöde)',
    noStart: 'Kuutios starttid är inte angiven, så klockslag saknas. Ange den på flödets tidslinje.',
    day: 'Dag {{day}}',
    minutes: '{{count}} min',
    what: 'Vad',
    why: 'Varför',
    intro: 'Inledning',
    technicalSetup: 'Teknisk uppställning',
    how: 'Hur',
    runOfPlay: 'Körschema',
    notes: 'Anteckningar',
    customized: 'för denna Kuutio',
    noContent: 'Inget faciliteringsinnehåll har skrivits ännu.',
    end: 'Kuutio slutar',
  },
  facilitationPanel: {
    title: 'Facilitering',
    customizedCount: '{{count}} anpassade för denna Kuutio',
    hint: 'Grå text är modulens gemensamma grund. Skriv här när denna Kuutio behöver en egen — grunden förblir som den är, och ändringen syns inte i andra Kuutio.',
    what: 'Vad',
    why: 'Varför',
    intro: 'Inledning (förslag på formulering)',
    how: 'Hur',
    technicalSetup: 'Teknisk uppställning',
    notes: 'Egna anteckningar',
    customized: 'anpassad för denna Kuutio',
    reset: 'Återställ grunden',
    noBase: 'Ingen grund har skrivits ännu.',
    steps: 'Upplägg',
    customizeSteps: 'Redigera upplägget för den här Kuution',
    noBaseSteps: 'Grunden har inget upplägg.',
    stepsTotal: 'Stegen totalt {{minutes}} min',
    stepTitle: 'Rubrik',
    stepMinutes: 'Min',
    stepText: 'Vad händer',
    addStep: 'Lägg till steg',
    removeStep: 'Ta bort steget',
    moveUp: 'Flytta upp',
    moveDown: 'Flytta ned',
  },
  facilitationChat: {
    title: 'Förbättra med AI',
    close: 'Stäng samtalet',
    hintBase: 'AI:n granskar texterna och föreslår förbättringar. Ett godkänt förslag förs in i fältet; spara en version som vanligt. Samtalet sparas inte och försvinner när du byter modul.',
    hintInstance: 'AI:n föreslår förbättringar av den här Kuutios texter. Ett godkänt förslag sparas genast för den här Kuution; grunden förblir som den är. Samtalet sparas inte.',
    emptyHint: 'Du kan lämna fältet tomt: då granskar AI:n texterna och föreslår allmänna förbättringar.',
    generalRequest: 'Allmänna förbättringar, tack.',
    original: 'Ursprunglig',
    originalEmpty: '(tom)',
    originalNoSteps: '(inga steg)',
    placeholder: 'Berätta vad du vill förbättra…',
    send: 'Skicka',
    progress: {
      reading: 'AI:n läser texterna…',
      thinking: 'AI:n funderar på förbättringar…',
      writing: 'AI:n skriver förslag…',
    },
    proposalsTitle: 'Förslag',
    proposalsEmpty: 'Inga förslag ännu.',
    accept: 'Godkänn',
    accepted: 'Godkänt',
    stepsProposal: 'Föreslaget upplägg',
    stepsReplace: 'Godkännandet ersätter hela upplägget.',
    stepsWipeTranslations: 'Stegens översättningar (en/sv) töms.',
    minutes: '{{count}} min',
    error: 'Samtalet misslyckades: {{error}}',
    cutOff: 'Svaret bröts.',
    lockedNote: 'Kuution är låst, så förslag kan inte godkännas.',
  },
  workshopOrchestrator: {
    screenStateDeleteConfirm: 'Ta bort det här skärmläget?',
    pathwayImportReplaceConfirm: 'Kartan har redan {{count}} noder. Importen ersätter instansens trender, variabler och hela påverkanskartan med den här JSON-filen. Fortsätta?',
    controlLockedReached: 'Låst: workshoppen har redan nått det här steget, så valet kan inte längre ändras.',
    loading: 'Laddar…',
    selectInstanceTitle: 'Välj först en instans',
    selectInstanceBody: 'Gå till adminstartsidan för att välja en instans.',
    adminHome: 'Adminstartsida',
    tabContent: 'Innehåll',
    tabScreens: 'Skärmar',
    lockedBar: 'Workshopen är låst — ändringar är blockerade tills du låser upp den.',
    unlockedBar: 'Workshopen kan redigeras. Lås den för att förhindra oavsiktliga ändringar.',
    lock: 'Lås',
    unlock: 'Lås upp',
    lockFailed: 'Låset kunde inte uppdateras: {{error}}',
    unlockTitle: 'Lås upp workshopen?',
    unlockMessage: 'Detta tillåter ändringar igen. Lås den igen så snart du är klar, så att oavsiktliga ändringar inte slinker igenom.',
    notStartedTitle: 'Workshopen har inte startat',
    notStartedBody: 'Du kan förbereda modulerna redan nu. Starta när rummet är redo: väggarna visar Kuutio-kuben först.',
    start: 'Starta workshopen',
    startFailed: 'Starten misslyckades: {{error}}',
    chainMissing: 'Den här instansen har inget workshopflöde.',
    chainLoadFailed: 'Workshopflödet kunde inte laddas: {{error}}',
    manualNeededBar: 'Mata in för hand innan start: {{items}}',
    orderWarningBar: 'Ordningsvarning: {{items}} produceras först senare i flödet.',
    navAria: 'Moduler',
    setup: 'Förberedelse',
    stepOf: 'Modul {{current}} / {{total}}',
    gate: {
      ok: 'Kontrollerna uppfyllda',
      unmet: '{{count}} kvar',
      open: 'Öppna stegets reglage',
    },
    moduleActions: {
      neverRun: 'Inte kört än',
      running: 'Pågår',
      done: 'Klart',
      failed: 'Misslyckades',
      errors: '{{count}} fel',
      leaveTitle: 'Innan du fortsätter',
      continueAnyway: 'Fortsätt ändå',
      cancel: 'Avbryt',
      checkUnreadable: 'Kontrollen kunde inte läsas: {{detail}}',
      signin: 'Modulens åtgärder kräver inloggning med Sitra-konto.',
    },
    previous: 'Föregående',
    next: 'Nästa',
    pause: 'Paus',
    resume: 'Fortsätt',
    timerPlus: 'Lägg till 5 minuter',
    timerMinus: 'Ta bort 5 minuter',
    stop: 'Avsluta workshopen',
    live: 'LIVE',
    state: {
      ready: 'Resultatet klart',
      missing: 'Resultatet saknas',
      checksOk: 'Kontrollerna uppfyllda',
    },
    noSettingsTitle: 'Inga facilitatorinställningar',
    noSettingsBody: 'Den här modulen behöver inga separata inställningar från facilitatorn.',
    manualTitle: 'Matas in för hand',
    manualBody: 'Den här modulen behöver uppgifter som ingen tidigare modul producerar. Mata in dem för hand innan modulen börjar.',
    manualDone: 'inmatat för hand',
    orderWarning: '{{handoff}} produceras först senare ({{producer}}).',
    noEditor: 'Det finns ännu ingen editor för de här uppgifterna.',
    openEditor: 'Mata in för hand',
    closeEditor: 'Stäng',
    enterOnContent: 'Ange det på sidan Innehåll',
    blockedUntil: 'Modulens innehåll öppnas när {{items}} har matats in.',
    settingsTitle: 'Skärmar och tidsplan',
    duration: 'Längd (min)',
    slideStart: 'Första bild',
    slideEnd: 'Sista bild',
    access: 'Deltagare',
    accessAuto: 'Öppnas när flödet når modulen',
    accessOpen: 'Alltid öppen',
    accessLocked: 'Låst',
    screenStates: 'Skärmlägen: {{count}}',
    editScreens: 'Redigera skärmar',
    saved: 'Sparat',
    saveFailed: 'Kunde inte spara: {{error}}',
    chainTitle: 'Workshopflöde',
    chainHint: 'Instansens moduler i ordning. Moduler och ordning redigeras i byggaren; förberedelse, tidsplan och uppgifter som matas in för hand: Workshopstyrning.',
    openOrchestrator: 'Öppna workshopstyrningen',
  },
  adminHome: {
    stage_prepare: 'Förberedelse',
    stage_run: 'Genomförande',
    stage_results: 'Resultat',
    currentStage: 'Nu',
    nextStep: 'Nästa steg',
    moveTo_run: 'Gå till genomförande',
    moveTo_results: 'Gå till resultat',
    stageDone: 'Allt klart.',
    allViews: 'Alla vyer',
    legacy: 'gammal',
    health: 'Tjänsternas status',
    backend: 'Bakgrundstjänst',
    database: 'Databas',
    rag: 'Kunskapssökning',
    view_impactPath: 'Effektkarta',
    view_pivotPoints: 'Vändpunkter',
    view_lenses: 'Hinder och möjligheter',
    view_solutions: 'Lösningar',
    view_report: 'Offentlig rapport',
    view_impactMachine: 'Impact Machine',
    view_statmap: 'Statistikkarta',
  },
  stageStatus: {
    goal: 'Workshopens mål inskrivet',
    language: 'Språk: {{language}}',
    flow: 'Flödet sammanställt: {{modules}} moduler',
    inputs: 'Modulernas indata: {{missing}} saknas',
    scenarios: 'Scenarier: {{count}}',
    access: 'Åtkomst: workshopens PIN eller {{count}} personliga koder',
    datasets: 'Kunskapsbas: {{count}} material, {{pending}} väntar på granskning',
    slides: 'Bildspel kopplat',
    organisations: 'Organisationer importerade: {{count}}',
    started: 'Workshopen startad',
    progress: 'I flödet: fas {{current}}/{{total}}',
    devices: 'Enheternas anslutningar',
    report: 'Rapporten skapad',
    translations: 'Översättningar: {{languages}}',
    transcripts: 'Transkript: {{count}}',
    whatif: 'Tänk om? -texter: {{count}}',
    summary: 'Sammanfattning för ledningen',
    export: 'Export och arkivering',
    optional: 'valfri',
    byScript: 'med skript',
  },
  stageRow: {
    live: 'Workshopen pågår',
    stillRunning: 'Workshopen fortsätter; skärmarna stannar i steget',
    step: 'steg {{current}}/{{total}}',
    backToWorkshop: 'Tillbaka till Workshop',
  },
  prep: {
    title: 'Modulernas indata',
    beforeTitle: 'Före Kuution',
    duringTitle: 'Bestäms under Kuution (Workshop)',
    required: 'krävs',
    optional: 'valfri',
    sameAsAbove: 'Samma som ovan.',
    preparedAbove: 'Scenarier och variabler, överst på sidan',
    knowledge: 'på sidan Kunskapsbas',
    system: 'Skapas automatiskt',
    workshop: 'Skapas under Kuution i modulen {{module}}',
    none: 'Kan inte anges i förväg.',
    noneRequired: 'Krävs, men det finns inget sätt att ange det i förväg: endast med skript eller i databasen. Lägg till en modul i flödet som skapar det.',
    noInputs: 'Inga indata.',
    noDecisions: 'Inga beslut för handledaren under Kuution.',
    panel: 'Modulens egen handledarpanel',
    noChain: 'Inga moduler har valts för flödet ännu.',
    openFlow: 'Sätt ihop flödet',
  },
  scenarioVariables: {
    noFuture: 'Utan framtidsbild',
    groupCount: '{{count}} variabler',
    sectionTitle: 'Scenarier och variabler ({{count}})',
    title: 'Variabler ({{count}})',
    name: 'Variabel',
    description: 'Beskrivning',
    future: 'Framtidsbild',
    add: 'Lägg till variabel',
    delete: 'Ta bort variabel',
    deleteConfirm: 'Ta bort variabeln {{name}}?',
    newName: 'Ny variabel',
    toggle: 'Variabler',
    saveFirst: 'Spara scenariot först för att lägga till variabler.',
  },
  scenarioCopy: {
    label: 'Kopiera från en annan Kuutio:',
    pick: 'Välj en Kuutio…',
    count: '{{count}} scenarier',
    button: 'Kopiera scenarier och variabler',
    done: 'Kopierade {{scenarios}} scenarier och {{variables}} variabler.',
    confirmReplace: 'Den här Kuution har redan {{count}} noder på effektkartan. Kopieringen ersätter variablerna i scenarier med samma namn och döljer de övriga. Fortsätta?',
  },
  instanceList: {
    title: 'Hantering av instanser',
    lead: 'Alla kuber. Öppna tar dig till kubens översikt, där dess faser och inställningar finns.',
    create: 'Skapa en ny kub',
    search: 'Sök på namn eller beskrivning',
    filter_archived: 'Arkiverade',
    filter_all: 'Alla',
    loadFailed: 'Kunde inte hämta instanser: {{error}}',
    retry: 'Försök igen',
    empty: 'Inga kuber ännu. Skapa den första.',
    noMatches: 'Inga kuber matchar sökningen.',
    participants: 'Deltagare',
    participantCount: '{{count}} deltagare',
    workshopDate: 'Workshopdatum',
    open: 'Öppna',
    filter_current: 'Aktuella',
    archive: 'Arkivera',
    archiveHint: 'En arkiverad kub försvinner ur alla menyer och visas bara under filtret Arkiverade på sidan Instanser. Den kan återställas.',
    archivedHelp: 'Den här kuben är arkiverad: den visas inte i menyer. Återställ tar den tillbaka.',
    archivedOn: 'Arkiverad {{date}}',
    restore: 'Återställ',
    archived: '"{{title}}" arkiverades.',
    restored: '"{{title}}" återställdes.',
    deleted: '"{{title}}" togs bort ({{count}} rader).',
  },
  instanceLabels: {
    title: 'Etiketter',
    help: 'Välj minst en. Listan Instanser filtreras efter etikett.',
    required: 'Välj minst en etikett för kuben.',
    filterBy: 'Etikett:',
    none: 'Ingen etikett',
    edit: 'Redigera etiketter',
    kuutio: 'Kuutio',
    kuutio_hint: 'En riktig workshop med riktiga deltagare',
    demo: 'Demo',
    demo_hint: 'För visning för besökare',
    simulation: 'Simulering',
    simulation_hint: 'En körning med AI-personas',
    test: 'Test',
    test_hint: 'Ett tekniskt test eller en engångskopia',
    lab: 'Lab',
    lab_hint: 'Prov av en ny modul på riktiga data eller ett riktigt tillfälle',
    event: 'Evenemang',
    event_hint: 'Ett enskilt tillfälle, inte en hel kub',
  },
  instanceDelete: {
    title: 'Ta bort kuben permanent',
    lead: 'Kuben "{{title}}" och alla dess data tas bort permanent. Detta kan inte ångras.',
    previewHeading: '{{count}} rader tas bort:',
    previewFailed: 'Förhandsvisningen misslyckades: {{error}}',
    typeTitle: 'Bekräfta genom att skriva kubens namn: {{title}}',
  },
  settingsPages: {
    keyActorsTitle: 'Viktigaste aktörer',
    keyActorsLead: 'Vilka den här workshopen når: vilka som är på plats eller nås genom dem.',
    keyActorsLabel: 'En aktör per rad',
    keyActorsPlaceholder: 'T.ex. ett ministerium, ett kommunfullmäktige eller en organisation',
    keyActorsHelp: 'Problemkartläggningens hävstångspunkter läser listan tillsammans med workshopens beskrivning: när någon av dessa kan ändra ett instrument ligger det inom workshopens mandat. Tom bedömer AI mandatet utifrån beskrivningen.',
    keyActorsSave: 'Spara aktörer',
    keyActorsSaved: 'Aktörer sparade',
    webSearchTitle: 'Webbsökning',
    webSearchLead: 'Sammanfattande analyser kan också söka på webben, hos granskade utgivare.',
    webSearchLabel: 'Webbsökning för sammanfattande analyser',
    webSearchHelp: 'Problemkartans och lösningarnas sammanfattande analyser söker på webben, till exempel om något liknande har prövats på annat håll. Bara sidor från granskade utgivare visas, åtskilda från forskningsmaterialet och klassificerade (forskning, myndighet, organisation, intresseorganisation, nyhet). Sökfrågorna innehåller hävstångspunkternas och lösningarnas rubriker.',
    personAddTitle: 'Lägg till en deltagare',
    personTitle: 'Titel',
    personOrganisation: 'Organisation',
    personAdded: '{{who}} tillagd i listan. Inbjudan går iväg när du trycker Skicka inbjudningar.',
    peopleInvitedCol: 'Inbjuden',
    peopleNotInvited: 'inte inbjuden',
    peopleSignedIn: 'inloggad {{date}}',
    peopleSelectAll: 'Välj alla',
    peopleResendOne: 'Skicka igen',
    peopleSendOne: 'Skicka inbjudan',
    peopleSendInvites: 'Skicka inbjudningar ({{count}})',
    peopleSendHint: 'Välkomstmeddelandet till de markerade. Det kan skickas igen.',
    peopleInviteConfirm: 'Skicka välkomstmeddelandet till {{count}} deltagare?',
    peopleInvitedDone: 'Inbjudan skickad till {{count}} deltagare.',
    peopleInviteFailed: 'Skickade {{sent}}, misslyckades {{failed}}: {{error}}',
    personAdd: 'Lägg till deltagare',
    personAlreadyIn: '{{who}} fanns redan i listan.',
    peopleFromFile: 'Lägg till från fil',
    peopleFileHint: 'Excel (.xlsx) eller CSV. Rubrikrad: namn, titel, organisation, e-post — eller en ren adresslista.',
    peopleFileAdded: '{{rows}} rader i filen: {{added}} tillagda, {{alreadyIn}} fanns redan, {{skipped}} hoppades över (ingen adress).',
    peopleSendInvitesTitle: 'Skicka inbjudningarna?',
    peopleSendInvitesShort: 'Skicka',
    peopleInvitedOn: 'Inbjuden {{date}}',
    peopleTitle: 'Kuutios deltagare',
    peopleLead: 'Den här listan är Kuutios deltagare: de ser Kuutio på sin egen sida (/me) och får deltagarmeddelandena från sidan Viestit.',
    peopleEmpty: 'Inga deltagare ännu. Klistra in adresser nedan eller importera Lyytis anmälda.',
    peopleName: 'Namn',
    peopleEmail: 'E-post',
    peopleRole: 'Roll',
    peopleLastLogin: 'Inloggad',
    peopleNeverSignedIn: 'inte ännu',
    peopleRemove: 'Ta bort från Kuutio',
    peopleRemoveConfirm: 'Ta bort {{who}} från Kuutios deltagare? Kontot finns kvar.',
    peopleRemoved: '{{who}} borttagen från Kuutio.',
    peopleImportLyyti: 'Importera Lyytis anmälda',
    peopleNoLyyti: 'Kuutio har inget Lyyti-evenemang.',
    peopleFromLyyti: '{{registrants}} anmälda i Lyyti, {{added}} tillagda.',
    role_participant: 'deltagare',
    role_facilitator: 'facilitator',
    role_admin: 'administratör',
    role_owner: 'ägare',
    importTitle: 'Deltagarlista',
    importLead: 'Anmälda (Lyyti) och deras organisationer importeras med skript. De visas i rapportens avsnitt Deltagare.',
    selectInstance: 'Välj en instans i menyn överst.',
    loading: 'Laddar…',
    loadFailed: 'Laddningen misslyckades: {{error}}',
    saveFailed: 'Sparandet misslyckades: {{error}}',
    basicPageTitle: 'Grunduppgifter',
    basicPageLead: 'Kubens namn, språk och mål, dess status samt rensning och radering av data.',
    basicTitle: 'Grunduppgifter',
    basicLead: 'Språket styr både gränssnittet och texten som AI:n skriver.',
    kuutioNumber: 'Kuutions nummer',
    kuutioNumberHelp: 'Visas i rapportens rubrik (KUUTIO N) och i rapportens adress (K<N>-…). Deltagarlistan och rapportens bilder hämtas utifrån det. Endast administratörer och huvudfacilitatorer kan ändra det.',
    kuutioNumberInvalid: 'Kuutions nummer måste vara ett positivt heltal.',
    kuutioNumberTaken: 'Sparat, men nummer {{number}} används redan av: {{titles}}.',
    statusTitle: 'Status',
    statusLead: 'Statusen följer normalt faserna (Gå till genomförande, Gå till resultat). Ställ in den för hand endast i undantagsfall.',
    statusHelp: 'Utkast och Arkiverad döljer kuben för deltagarna.',
    dangerTitle: 'Farlig zon',
    dangerLead: 'Rensning tar bort deltagarnas och AI:ns resultat men behåller förberedelserna. Radering tar bort hela kuben.',
    cleared: 'Rensat: {{count}} rader.',
    contentPageTitle: 'Innehåll',
    contentPageLead: 'Allt som är känt före Kuution: scenarier och variabler samt indata för varje modul i flödet. Beslut under Kuution fattas i Workshop.',
    scenariosLead: 'Namn, beskrivning, ikon och färg. Variablerna öppnas från scenariots egen knapp; de blir effektkartans startnoder.',
    participantsPageTitle: 'Deltagare',
    participantsPageLead: 'Hur deltagare och enheter kommer in i kuben.',
    accessTitle: 'Åtkomst',
    accessLead: 'Workshopens PIN är koden som rummet loggar in med. Den visas i genomföranderaden under workshopen.',
    openPinHelp: 'Testläge: vilken PIN som helst öppnar kuben. Håll det avstängt i en riktig workshop.',
    remoteEntryLabel: 'Workshoppen nås från den egna sidan',
    remoteEntryHelp: 'Visar deltagarna knappen Gå till workshoppen på den egna sidan (/me). Av som standard; slå på när workshoppen börjar.',
    datasetsPageTitle: 'Kunskapsbas',
    datasetsPageLead: 'Vilket forskningsmaterial kubens AI kan söka i.',
    datasetsLead: 'Basmaterialet är tillgängligt för alla kuber om det inte utesluts. Andra material kopplas till kuben separat.',
    prepareTitle: 'Förbereda kunskapsbaser',
    prepareLead: "Kuutions forskningsmaterial samlas och granskas under Aineistot → Kunskapsbaser, innan kunskapsbasen kopplas till den här instansen.",
    openPrepare: 'Öppna Kunskapsbaser',
  },
  datasetPanel: {
    title: 'RAG-kunskapsbaser',
    base: 'bas',
    excluded: 'utesluten',
    includeBase: 'Ta med basmaterialet',
    excludeBase: 'Uteslut basmaterialet',
    include: 'Ta med',
    exclude: 'Uteslut',
    detach: 'Koppla bort',
    attach: 'Koppla',
    newIdPlaceholder: 'nytt-material-id',
    namePlaceholder: 'Namn',
    createAttach: 'Skapa och koppla',
  },
  exportPage: {
    title: 'Export',
    lead: 'Att ta ut workshopen ur Kuutio: allt innehåll, forskningsmaterialet och kopior.',
    workshopTitle: 'Workshopen som JSON',
    workshopLead: 'Scenarier, variabler, vägar, vändpunkter, linser, lösningar, transkript, rapport och flöde. Personuppgifter tas bort.',
    workshopButton: 'Ladda ner workshopen (JSON)',
    ragTitle: 'Forskningsmaterial',
    ragLead: 'Kubens RAG-material som JSON.',
    ragButton: 'Ladda ner materialet (JSON)',
    cloneTitle: 'Kloning och export',
    cloneLead: 'En kopia av denna Kuutio med ett nytt namn: på denna server eller som ett klonpaket till en annan miljö. Inget befintligt skrivs över.',
    archiveTitle: 'Arkivering',
    archiveLead: 'En arkiverad kub döljs för deltagarna; rapporten och data sparas.',
    archiveButton: 'Ställ in statusen i Grunduppgifter',
    downloading: 'Laddar ner…',
    failed: 'Nedladdningen misslyckades: {{error}}',
  },
  clone: {
    nameLabel: 'Klonens namn',
    namePlaceholder: 'Nytt namn, t.ex. TEST: {{name}}',
    nameFree: 'Namnet är ledigt.',
    nameTaken: 'Namnet används redan: {{name}}',
    nameInvalid: 'Ange ett namn med bokstäver eller siffror.',
    checking: 'Kontrollerar…',
    modeLabel: 'Vad kopieras',
    modePrepared: 'Endast förberett innehåll',
    modePreparedHelp: 'Inställningar, scenarier och variabler, linser, workshopens flöde, skärmar, organisationer och kopplade kunskapsbaser.',
    modeEverything: 'Allt',
    modeEverythingHelp: 'Även deltagarnas och AI:ns resultat: stigar, linsernas innehåll, hävstångspunkter, lösningar, transkript och rapporten.',
    neverCopied: 'PIN-koder, deltagare, röster, chattar och loggar kopieras aldrig. Klonen får egna PIN-koder.',
    includeFiles: 'Ta med originalfilerna (PDF:er)',
    includeFilesHelp: 'Utan filerna är paketet mindre, men källorna kan inte konverteras på nytt.',
    sameServerTitle: 'Klona på denna server',
    cloneButton: 'Klona',
    cloning: 'Klonar…',
    cloned: 'Klart: {{name}}',
    openClone: 'Öppna klonen',
    exportInstance: 'Exportera Kuutio',
    exportDataset: 'Exportera kunskapsbas',
    exportHelpInstance: 'Laddar ner ett klonpaket (.zip). Importera det i den andra miljön: Hantering av instanser → Importera Kuutio.',
    exportHelpDataset: 'Laddar ner ett klonpaket (.zip). Importera det i den andra miljön: Aineistot → Kunskapsbaser → Importera kunskapsbas.',
    exporting: 'Packar…',
    importInstance: 'Importera Kuutio',
    importDataset: 'Importera kunskapsbas',
    importLeadInstance: 'Ett klonpaket (.zip) från en annan miljö eller denna server. Kuution får ett nytt namn och inget befintligt skrivs över.',
    importLeadDataset: 'Ett klonpaket (.zip) för en kunskapsbas. Kunskapsbasen får ett nytt namn och inget befintligt skrivs över.',
    datasetSectionTitle: 'Kloning och export',
    fileLabel: 'Klonpaket',
    reading: 'Läser paketet…',
    packageFrom: 'Miljö {{env}}, exporterad {{date}}',
    packageRows: '{{count}} rader, {{tables}} tabeller',
    modeIs: 'Innehåll: {{mode}}',
    schemaProblems: 'Denna server saknar delar som paketet behöver. Uppdatera servern först:',
    missingDatasets: 'Dessa kunskapsbaser finns inte på denna server och kopplas därför inte: {{ids}}',
    importButton: 'Importera',
    importing: 'Importerar…',
    failed: 'Misslyckades: {{error}}',
    warningsTitle: 'Hänvisningar som inte kunde behållas:',
    warningCleared: '{{table}}.{{column}}: {{rows}} hänvisningar tömda ({{refTable}} finns inte här)',
    warningDropped: '{{table}}: {{rows}} rader utelämnade ({{refTable}} finns inte här)',
    reindexStarted: 'Workshopens egna RAG-data byggs om i bakgrunden.',
    reindexFailed: 'Ombyggnaden av workshopens RAG-data startade inte: {{error}}',
  },
  scriptHint: {
    skill: 'Görs med ett skript. Instruktioner: färdigheten {{skill}}.',
  },
  reportStatus: {
    title: 'Rapportens material',
  },
  reportSettings: {
    title: 'Rapportinställningar',
    implementationPlans: 'Visa avsnitten "Hur börjar vi?"',
    implementationPlansHelp: 'Genomförandeplanerna visas i rapportens lösningsavsnitt.',
    reportPin: 'Rapportens PIN',
    reportPinHelp: 'Avsnitt som markerats som skyddade öppnas med denna kod. Tom = inga skyddade avsnitt.',
    sectionAccess: 'Avsnittens synlighet (offentlig, skyddad, dold) väljs i rapportens redigeringsläge.',
    openEditor: 'Öppna rapporten',
  },
  reportStep: {
    intro: 'Att skapa rapporten, dess bilder och sammanfattning är den här sektionens åtgärder; här materialet, översättningarna, inställningarna och uteslutningarna.',
    stage: 'Skede',
    inResults: 'I resultatskedet',
    notInResults: 'Inte ännu i resultatskedet (åtgärden Gå till resultat)',
    history: 'Rapporthistorik',
    loadFailed: 'Kunde inte hämta rapportens status: {{error}}',
    created: 'Skapad',
    notCreated: 'Inte skapad ännu',
    translations: 'Översättningar',
    noTranslations: 'Inga översättningar',
    openReport: 'Gå till rapporten',
    moveToResults: 'Gå till resultat',
  },
  pivotsV2Step: {
    intro: 'Vändpunkter söks, godkänns och avfärdas i vändpunktsvyn.',
    loadFailed: 'Kunde inte hämta vändpunkter: {{error}}',
    accepted: 'Godkända',
    proposed: 'Föreslagna',
    dismissed: 'Avfärdade',
    noRun: 'Inga vändpunkter har sökts ännu.',
    open: 'Öppna vändpunkter',
  },
  adminRunStrip: {
    pinLabel: 'PIN',
    instancePin: 'Workshopens PIN',
    pinTitle: 'Deltagarnas PIN-koder',
    copy: 'Kopiera',
    copied: 'Kopierad',
    openParticipantView: 'Öppna deltagarvyn med denna PIN-kod i ett nytt fönster',
    noPins: 'Inga PIN-koder. Lägg till dem på sidan Deltagare under Förberedelse.',
    pinsFailed: 'Kunde inte hämta PIN-koder: {{error}}',
    locked: 'Låst',
    open: 'Öppen',
  },
  screenContent: {
    title: 'Skärminnehåll',
    description: 'Vad varje skärm visar i varje fas. Planeras i förväg; under workshopen styrs enheterna från sidan Enheter.',
    loadFailed: 'Kunde inte läsa in flödet: {{error}}',
  },
  workshopLiveControls: {
    title: 'Live-inställningar',
    statusLabel: 'Status',
    openPinLabel: 'Öppen PIN (test)',
    votingLabel: 'Lösningsröstning',
    scoreLabel: 'Lösningspoäng',
    screenControlLabel: 'Skärmstyrning',
    screenControlHint: 'När på styr /screen väggdisplayer',
    saving: 'Sparar…',
    saved: 'Sparat',
  },

  instanceSettings: {
    language: 'Workshop-språk',
    languageHelp: 'Styr gränssnittet och AI-svarsspråket (FI / EN / SV).',
  },

  artifact: {
    collection: 'Samling',
    collectionItems: 'Sidor ({{n}})',
    eyebrow: 'Kuutio-agenter',
    loading: 'Hämtar…',
    notFound: 'Sidan hittades inte',
    revoked: 'Den här sidan har dragits tillbaka',
    needsSignIn: 'Den här sidan kräver inloggning',
    failed: 'Sidan kunde inte hämtas',
    summary: 'Sammanfattning i chatten',
    summaryLead: 'Det frågeställaren såg i chattpanelen när tråden stängdes.',
    noSummary: 'Ingen separat sammanfattning.',
    report: 'Rapport',
    reportLead: 'Skriven utifrån inläggen och deras ordning, inget annat.',
    history: 'Historik: hur svaret uppstod',
    historyLead: 'Varje steg i den ordning det hände. Varje röst ser bara sin egen grund, sina egna källor och de andras senaste inlägg.',
    sources: 'Källor',
    sourcesLead: 'Ett nummer är en källa i hela svaret. Var och en är hämtad eller läst från röstens eget Kuutio, aldrig ur minnet.',
    asker: 'Frågeställare',
    assistant: 'Assistent',
    turnSources: 'Källor som inlägget hänvisade till ({{n}})',
    filterStep: 'Filtret ordnar (föreslår inget, lägger inte till)',
    synthesisStep: 'Syntesen samlar',
    reportStep: 'Rapporten skrivs',
    reportStepNote: 'Utifrån inläggen och ordningen; avsnitt 2 ovan.',
    summaryStep: 'sammanfattning till chatten',
    summaryStepNote: 'Avsnitt 1 ovan.',
    noOrdering: 'Ordningen sparades inte i den här körningen.',
    agreed: 'Eniga',
    disputed: 'Oeniga',
    open: 'Öppet',
    findings: 'Fynd',
    tensions: 'Spänningar',
    gaps: 'Luckor',
    implications: 'Slutsatser',
    disclaimer: 'Rösterna är synteser av tidigare Kuutios, den här verkstadens eget material eller syntetiska målgruppsagenter från ett opinionsdataset, inte deltagare eller organisationer. Kostnaderna är uppskattningar från prislistan.',
    published: 'Publicerad {{date}}',
  },
  chatAgent: {
    introTitle: 'Hej! Jag är Kuutios AI-assistent.',
    introBody: 'Jag känner till workshopmaterialet, forskningsbakgrunden och deltagarnas idéer. Fråga fritt — jag kan hjälpa dig förstå sammanhang, jämföra perspektiv eller sammanfatta diskussioner.',
    introDisclaimer: 'Ta inte allt jag säger som absolut sanning — jag är en AI och har mina gränser.',
    tryTip: 'Prova Kuutio-assistenten',
    inputPlaceholder: 'Fråga vad som helst...',
    askMeAnything: 'Fråga vad som helst',
    errorPrefix: 'Fel: {{message}}',
    connectionError: 'Anslutningsfel. Försök igen.',
    modelTitle: 'AI-modell',
    clearTitle: 'Rensa konversation',
    clearConfirm: 'Rensa konversationen? Detta kan inte ångras.',
    clear: 'Rensa',
    assistantTitle: 'Kuutio Assistant',
    assistantSubtitle: 'Research-powered insights',
    assistantSubtitleHeadai: 'HeadAI skills & semantics',
    selectModelTitle: 'Välj AI-modell',
    closeChat: 'Stäng chatt',
    jumpToLatest: 'Hoppa till senaste',
    agentsRowTitle: 'Kuutio-agenter:',
    agentIncluded: 'Med i diskussionen — tryck för att lämna utanför',
    agentExcluded: 'Utanför — tryck för att ta med',
    agentsSelectLabel: 'Kuutio-agenter {{included}}/{{total}}',
    agentsSelectTitle: 'Välj vilka Kuutio-agenter som är med i diskussionen',
    agentInfoTitle: 'Om agenten',
    agentInfoSynthesis: 'expertröst från en tidigare Kuutio',
    agentInfoTopic: 'Ämne',
    agentInfoNoPerspective: 'Inget perspektiv skrivet ännu.',
    agentInfoDisclaimer: 'Talar ur sin egen Kuutios perspektiv: dess resultat och kunskapsbas är dess erfarenhet och bevis. Markerade punkter är verkstadens resultat; resten är agentens resonemang ur den vinkeln. Den är verkstadens röst, inte en person eller en organisation.',
    askAgentPrefix: 'Fråga {{name}}:',
    askAgentButton: 'Fråga {{name}}',
    agentsTogether: 'Kuutio-agenterna tillsammans',
    agentThin: 'tunn grund',
    agentThick: 'stark grund',
    agentSynthetic: 'syntetisk',
    agentInfoOpinion: 'syntetisk målgruppsagent från ett opinionsdataset',
    agentInfoDisclaimerOpinion: 'Representerar svarsfördelningen i ett opinionsdataset: grupperna är statistiska rekonstruktioner från en självselekterad nätdiskussion, inte människor och inte ett representativt urval. Varje påstående vilar på datasetets påståenden och deras siffror per grupp; resten är agentens resonemang utifrån gruppernas profiler. Den är inte en person och citeras aldrig som deltagare.',
    agentDocumented: 'dokumenterad ståndpunkt',
    agentInfoParty: 'ett partis dokumenterade ståndpunkt ur offentliga handlingar',
    agentInfoDisclaimerParty: 'Företräder ett partis dokumenterade ståndpunkt i ett ämne: partiprogrammen, regeringsprogrammet som binder partiet och riksdagsgruppens daterade plenaranföranden, alla offentliga handlingar. Det är en grupp, aldrig en person; varje påstående vilar på en markerad handling, resten är agentens slutledning. En rekonstruktion som partiet självt kan läsa och bestrida.',
    tools: {
      listAgents: 'Hämtar Kuutio-agenter...',
      askKuutio: 'En Kuutio-agent svarar...',
      bounce: 'Agenterna diskuterar frågan...',
      deepDive: 'Rösterna analyserar frågan på djupet...',
      headaiPlaybook: 'Laddar HeadAI-guide...',
      headaiAnalysis: 'Hämtar HeadAI-analys...',
      searchResearch: 'Söker forskning...',
      workshopData: 'Hämtar workshopdata...',
      solutions: 'Hämtar lösningar...',
      pivotPoints: 'Hämtar vändpunkter...',
      lensAnalysis: 'Hämtar linsresultat...',
      workshopNodes: 'Hämtar effektkartans noder...',
      impactPath: 'Hämtar effektväg...',
      organisations: 'Hämtar organisationer...',
      fallback: 'Hämtar data...',
    },
    thread: {
      kind: {
        bounce: 'Bollning',
        deep_dive: 'Djupanalys',
      },
      findings: 'fynd {{n}}',
      tensions: 'spänningar {{n}}',
      gaps: 'luckor {{n}}',
      turns: '{{n}} inlägg',
      rounds: '{{n}} rundor',
      running: '{{done}}/{{total}} talade',
      writing: 'Agenterna talar; filtret och rapporten följer…',
      agreed: 'eniga {{n}}',
      disputed: 'oeniga {{n}}',
      open: 'öppet {{n}}',
      converged: 'ingen verklig oenighet',
      share: 'Dela',
      shareCopied: 'Länk kopierad',
      shareTitle: 'Publicera som offentlig sida och kopiera länken',
      sharePublic: 'offentlig länk',
      shareSignIn: 'Delning kräver inloggning (admin).',
      openReport: 'Öppna rapporten',
      noReport: 'rapporten kunde inte skrivas',
      reportTitle: 'Agenternas rapport',
      download: 'Ladda ner som Markdown',
      close: 'Stäng',
      reportDisclaimer: 'Agenterna är tidigare Kuutios röster, inte deltagare eller organisationer. Källmarkeringarna [n] motsvarar chattens källista.',
    },
    split: {
      all: 'alla',
      note: 'Andel av dem som tog ställning. Siffrorna beskriver deltagarna i en självselekterad nätdiskussion, inte befolkningen; grupperna är statistiska rekonstruktioner utifrån rösterna.',
    },
    usage: {
      calls: '{{n}} anrop',
      tokens: '{{n}} tokens',
      cost: '≈ {{usd}} $',
      costUnknown: 'pris okänt',
    },
    deepDiveButton: 'Gör djupanalysen',
    deepDivePrefix: 'Gör en djupanalys:',
    reactions: {
      accept: 'Godkänner',
      reject: 'Förkastar',
      fix: 'Korrigerar',
      acceptHint: 'Det här stämmer',
      rejectHint: 'Det här stämmer inte eller passar inte',
      fixHint: 'Rätt riktning, men något är fel',
      why: 'Varför?',
      reasons: {
        wrong_owner: 'fel ägare',
        impossible_mandate: 'omöjligt mandat',
        tried_already: 'redan prövat',
        politically_dead: 'politiskt dött',
        wrong_scale: 'rätt men fel skala',
      },
    },
  },

  // Tilannekuva — live workshop dashboard (specs/workshop-dashboard.md)
  dashboard: {
    title: 'Lägesbild',
    live: 'Live',
    stale: 'Ingen dataanslutning',
    noData: 'Ingen data ännu',
    notStarted: 'Workshoppen är inte igång',
    paused: 'Paus',
    ragCounter: '{{total}} källor · {{retrieved}} hämtade',
    costToday: 'i dag {{count}} anrop · ${{cost}}',
    chatToday: 'i dag {{count}}',
    estimatedEnd: 'Beräknat slut {{time}}',
    close: 'Stäng',
    noInstance: 'Ingen workshop vald — öppna vyn via workshoppens länk.',
    tiles: {
      flow: 'Workshoppens gång',
      progress: 'Stegets framsteg',
      rag: 'Kunskapsbas',
      cost: 'AI-kostnader',
      feed: 'Händelser',
      schedule: 'Tidtabell',
      chat: 'Chatt',
    },
    units: {
      notes: 'lappar',
      lensItems: 'observationer',
      solutions: 'lösningar',
      pivotPoints: 'hävstångspunkter',
      ongelmat: 'problem',
      ankkurit: 'hinder för förändring',
      juurisyyt: 'rotorsaker',
      v2Nodes: 'noder',
      scenarios: 'scenarier',
      questions: 'frågor',
      futuresChosen: 'valda framtidsbilder',
      fieldAnswers: 'besvarade fält',
      votes: 'röster',
      painPoints: 'smärtpunkter',
      drivers: 'godkända förändringskrafter',
      wildCards: 'jokrar',
      pathSteps: 'steg på vägen',
      futuresApproved: 'godkända önskade framtider',
      timelines: 'simulerade tidslinjer',
      leveragePoints: 'hävstångspunkter',
      pivotThemes: 'teman',
    },
    selected: 'vald',
    noPivot: 'Ingen hävstångspunkt',
    openPivotSummary: 'Öppna hävstångspunktens sammanfattning',
  },

  ragSourceMap: {
    title: 'Kunskapsbas',
    loading: 'Laddar källor…',
    empty: 'Inga källor tillgängliga för denna instans.',
    error: 'Det gick inte att läsa in källkartan.',
    retrievals: 'hämtningar',
    baseCluster: 'Baskälla',
    notRetrieved: 'Inte hämtad ännu',
    counter: '{{total}} källor · {{retrieved}} hämtade',
    resetView: 'Återställ vyn',
    voices: {
      valtio: 'Staten',
      eduskunta: 'Riksdagen och lagstadgade utvärderare',
      kansainvaliset: 'Internationella organisationer',
      tutkimus: 'Forskning och vetenskapspaneler',
      ajatushautomot: 'Tankesmedjor',
      elinkeinoelama: 'Näringsliv och konsulter',
      kunnat: 'Kommuner, löntagare och organisationer',
    },
    contexts: {
      node: 'Effektkarta',
      lens: 'Hinder och möjligheter',
      solution: 'Lösningar',
      pivot: 'Vändpunkter',
      systemic: 'Systemisk karta',
      chat: 'Chatt',
      ai: 'AI-assistent',
      other: 'Övrigt',
    },
  },

  ragSourceMapV2: {
    title: 'Kunskapsbas (v2)',
    loading: 'Laddar källor…',
    empty: 'Inga källor tillgängliga för denna instans.',
    error: 'Det gick inte att läsa in källkartan.',
    perustietopohja: 'Baskälla',
    axis: {
      teema: 'grupperat efter tema',
      aani: 'grupperat efter röst',
    },
    teema: {
      teknologia: 'Teknik',
      ilmasto: 'Klimat',
      demokratia: 'Demokrati',
      yhteiskunta: 'Samhälle',
      governance: 'Governance',
    },
    voices: {
      valtio: 'Staten',
      kansainvaliset: 'Internationella',
      tiede_tutkimus: 'Vetenskap & forskning',
      ajatushautomot: 'Tankesmedjor',
      muut: 'Övriga',
    },
    counter: '{{total}} källor · {{retrieved}} hämtade',
    counterTotal: '{{total}} källor',
    defaultViewToggle: 'Standardvy',
    lockScale: 'Lås skala',
    switcherLabel: 'Byt Kuutio',
    retrievals: 'hämtningar',
    chunksLabel: 'textavsnitt',
    legendSizeUsage: 'Storlek = hämtningar',
    legendSizeDefault: 'Storlek = textavsnitt',
    tarkistettavaNote: '{{count}} behöver granskas (visas inte)',
    notRetrieved: 'Inte hämtad ännu',
  },

  ragSourceMapV4: {
    pickInstance: 'Välj instans',
    modeLahteet: 'Källor',
    modeKaytto: 'Användning',
    breadthLabel: 'olika sökningar',
    statsTitle: 'Användning per kluster',
    vizCluster: 'Klustervy',
    vizList: 'Listvy',
    vizBig: 'Förstorad vy',
    listOrder: {
      theme: 'Tema',
      size: 'Storlek',
      random: 'Slumpmässig',
      cluster: 'Kluster',
    },
    filters: {
      teknologia: 'Teknik',
      ilmasto: 'Klimat',
      demokratia: 'Demokrati',
      yhteiskunta: 'Samhälle',
      governance: 'Staten',
    },
  },

  pivotPoints: {
    drawerTabLabel: 'Vändpunkter ({{count}})',
    loading: 'Laddar vändpunkter...',
    retry: 'Försök igen',
    errors: {
      accessDenied: 'Din session har gått ut. Logga in igen för att se hävstångspunkterna.',
      clustersFailed: 'Det gick inte att läsa in hävstångspunkterna.',
      loadFailed: 'Det gick inte att läsa in data för hävstångspunkterna.',
      noInstance: 'Ingen workshop är vald, så det finns inga hävstångspunkter att visa.',
    },
    viewMode: {
      all: 'Alla',
      impactPaths: 'Påverkansvägar',
      clusters: 'Kluster',
      pivotPoints: 'Vändpunkter',
      list: 'Lista',
      allTitle: 'Visa alla tankar grupperade efter variabel',
      clustersTitle: 'Visa vändpunkter (semantiska kluster) + enskilda tankar',
      listTitle: 'Bläddringsbar lista över vändpunkter',
    },
    method: {
      structural: 'Strukturell',
      structuralTitle: 'Strukturanalys (MICMAC) — påverkan × beroende i påverkningsvägsnätverket. Alltid tillgänglig.',
      semantic: 'Semantisk',
      semanticTitle: 'Semantiska vändpunkter (AI-kluster)',
      semanticTitleEmpty: 'Semantiska vändpunkter — skapa först med AI-analys',
    },
    common: {
      back: 'Tillbaka',
      info: 'Detaljer',
      zoomIn: 'Zooma in',
      zoomOut: 'Zooma ut',
      zoomReset: 'Återställ',
      previousPivot: 'Föregående vändpunkt',
      nextPivot: 'Nästa vändpunkt',
      level: 'Nivå {{depth}}',
      membersCount: '{{count}} medlemmar',
      unknown: 'Okänd',
      pivotPoint: 'Vändpunkt',
      cluster: 'Kluster',
      human: 'Människa',
      more: '+{{count}} till',
      participant: 'Deltagare: {{name}}',
      analysis: 'Analys',
      typeLabel: 'Typ:',
      votesLabel: 'Röster:',
    },
    memberModal: {
      title: 'Tankedetaljer',
    },
    list: {
      empty: 'Inga vändpunkter ännu — använd Kluster-vyn för att hitta semantiskt relaterade tankar.',
      voteHint: 'Tryck på en vändpunkt för att rösta den som viktig',
      loginHint: 'Vändpunkter ({{count}} st) — logga in för att rösta',
      count: '{{count}} st',
      openDetails: 'Öppna vändpunktens detaljer',
      vote: 'Rösta',
      unvote: 'Ta bort röst',
    },
    branch: {
      tree: 'Träd',
      treeTitle: 'Byt till trädvy',
      cardinal: 'Kvadrant',
      cardinalTitle: 'Byt till kvadrantvy',
      snowflake: 'Snöflinga',
      snowflakeTitle: 'Byt till snöflingevy',
    },
    detail: {
      noDescription: 'Ingen beskrivning',
      tabInfo: 'Info',
      tabPaths: 'Vägar ({{count}})',
      tabMap: 'Karta',
      description: 'Beskrivning',
      sourceAi: 'AI-identifierad',
      sourceFacilitator: 'Skapad av facilitator',
      confidence: '{{percent}}% säkerhet',
      crossScenario: 'Tvärscenario',
      linkedPaths: 'Länkade vägar ({{count}})',
      themes: 'Teman',
      noMembers: 'Inga vägar',
      createdAt: 'Skapad: {{date}}',
      severity: 'Utmaningsgrad',
      optimism: 'Lösningsoptimism',
      leverageActor: 'Vem kan agera',
      leverageEffect: 'Effekt på workshopens mål',
      rootCause: 'Rotorsak — att ändra detta skulle kraftigt flytta målet',
    },
    drawer: {
      statsPivots: 'Vändpunkter',
      statsClustered: 'Klustrade',
      statsCrossScenario: 'Tvärscenario',
      analysisSettings: 'Analysinställningar',
      minParticipants: 'Min. deltagare',
      dataParticipants: 'Deltagare i data',
      humanNodes: 'Mänskliga noder',
      minScenarios: 'Min. scenarier',
      maxResults: 'Max. resultat',
      minConfidence: 'Min. säkerhet',
      similarity: 'Likhet',
      sensitivityFallback: 'Medelnivå',
      belowThreshold: 'Datan har bara {{count}} deltagare, men tröskeln är {{threshold}}. Analysen sänker tröskeln automatiskt, men resultaten kan bli tunna.',
      aiModel: 'AI-modell',
      autoReports: 'Skapa rapporter automatiskt',
      autoReportsHint: 'AI-rapport för varje vändpunkt (förbrukar tokens)',
      preview: 'Förhandsvisning',
      fullAnalysis: 'Full analys',
      progressHint: '{{elapsed}} — detta tar några minuter',
      empty: 'Inga vändpunkter.',
      emptyStart: 'Inga vändpunkter ännu.\nVändpunkter körs från workshopadmin (/admin/workshop).',
      presets: {
        conservative: { name: 'Strikt', description: 'Starka kopplingar' },
        balanced: { name: 'Balanserad', description: 'Standard' },
        exploratory: { name: 'Bred', description: 'Även svagare kopplingar' },
        discovery: { name: 'Upptäckter', description: 'Vändpunkter, spänningar, överraskningar' },
      },
      sensitivity: {
        strict: 'Strikt (identiska)',
        moderate: 'Medelnivå (samma tema)',
        loose: 'Lös (relaterade)',
      },
      aiModels: {
        sonnet: { description: 'Snabb, bra kvalitet' },
        opus: { description: 'Bästa kvalitet, långsammare' },
      },
    },
    structural: {
      nodes: 'Noder',
      edges: 'Kopplingar',
      relays: 'Reläer (hävstång)',
      convergences: 'Konvergenspunkter',
      candidatesTitle: 'Strukturella vändpunktskandidater',
      showStarters: 'Visa också scenariovariabler',
      hideStarters: 'Dölj scenariovariabler',
      empty: 'Inga kopplade noder i påverkningsvägar.',
      influenceDep: 'påv {{influence}} · ber {{dependence}}',
      loadingPathways: 'Laddar påverkningsvägar…',
      loadFailed: 'Kunde inte ladda data: {{error}}',
      coverageMapTitle: 'Täckningskarta — påverkan efter djup',
      networkFooter: 'Samma strukturanalys finns som metodval i vändpunktsvyn (Strukturell / Semantisk). Nästa steg: betweenness-centralitet och en interaktiv nätverksvy.',
    },
    reachMap: {
      sizeLegend: '⬤ storlek = nedströms täckning (påverkan, max {{max}})',
      hint: 'Banor = djup i kausal kedja (beroende). Bladnoder (täckning 0) dolda.',
      nodeTitle: '{{label}}\npåverkan {{influence}} · beroende {{dependence}}',
    },
    quadrant: {
      driving: 'Drivande',
      relay: 'Reläer / kritiska',
      dependent: 'Beroende',
      autonomous: 'Autonoma',
    },
    spatial: {
      back: '← Tillbaka',
      noConnections: 'Inga kopplingar',
      noAnalysis: 'Ingen analys tillgänglig',
      linkedVariables: 'Länkade variabler ({{count}})',
      noScenarioInfo: 'Ingen scenarioinformation',
    },
  },

  // Participant entry screens
  tablet: {
    subtitle: 'Deltagargränssnitt',
    selectType: 'Välj typ',
    typeIdea: 'Idé',
    typeConcern: 'Oro',
    typeQuestion: 'Fråga',
    typeScenario: 'Scenario',
    inputLabel: 'Skriv din idé, fråga eller observation',
    placeholder: 'Skriv här...',
    clear: 'Rensa',
    send: 'Skicka',
    ownInputs: 'Egna inlägg',
  },

  welcome: {
    subtitle: 'Välkommen till workshopen',
  },

  scenarioSelector: {
    subtitle: 'Välj en framtidsbild som grund för din påverkansväg',
    noScenarios: 'Inga scenarier',
    noScenariosSubtitle: 'Inga scenarier har definierats för den här instansen',
    variableCount: 'Innehåller 6 variabler som färdig utgångspunkt',
    initializing: 'Initierar...',
    startPathway: 'Starta påverkansväg',
  },

  startNode: {
    defaultTitle: 'Nuläge',
    defaultDescription: 'Börja bygga din väg mot framtiden. Välj en startpunkt och skapa den första konsekvensen.',
  },

  scenarioWelcome: {
    missingInstance: 'Instans saknas i URL (?kid=...)',
  },

  // Solution Page
  solutionPage: {
    loading: 'Läser in lösning...',
    notFound: 'Lösningen hittades inte',
    unknownError: 'Okänt fel',
    backToReport: 'Tillbaka till rapport',
    printPdf: 'Skriv ut PDF',
    hybridBadge: 'Hybridlösning',
    scoreLabels: {
      impact: 'Påverkan',
      feasibility: 'Genomförbarhet',
      innovation: 'Innovationsvärde',
      evidence: 'Bevis',
    },
    navTabs: {
      summary: 'Sammanfattning',
      description: 'Beskrivning',
      context: 'Sammanhang och resurser',
      impact: 'Påverkningsområden',
      analysis: 'AI-analys',
      plan: 'Genomförande',
    },
    workshopLabel: 'Kuutio — Lösningsförslag',
    workshopLabelWithTitle: 'Kuutio — {{title}}',
    humanWritten: 'skrivet av deltagare',
    sourceSolutions: 'Kombinerade originallösningar',
    problemLabel: 'Vilket problem löser detta?',
    resourcesLabel: 'Resurser och aktörer',
    futureLabel: 'Varför bygger detta en bättre framtid?',
    impactLabels: {
      mindsets: 'Tankesätt',
      structures: 'Strukturer',
      behavior: 'Beteende',
    },
    showAiPlan: 'Visa AI-genererad implementeringsplan',
    hideAiPlan: 'Dölj AI-förslag',
    footer: 'Kuutio Workshop Platform — Lösningsförslag',
    createdDate: 'Skapad {{date}}',
  },

  // Solutions List Page
  solutionsList: {
    loading: 'Läser in lösningar...',
    instanceMissingError: 'Instans-ID saknas',
    addInstanceUrl: 'Lägg till ?kid=... i URL',
    averageScore: '/ 5 genomsnitt (gamla analyser)',
    evidenceLabel: 'utvärderad med taggar',
    total: 'totalt',
    groupSolutions: 'Grupplösningar',
    hybridSolutions: 'Hybridlösningar',
    hybridBadge: 'Hybrid',
    footer: 'Kuutio Workshop Platform — Lösningsförslag',
  },

  reportGen: {
    movedToWorkshop: 'Att skapa rapporten, dess bilder, sammanfattning, översättningar, inställningar och uteslutningar finns i rapportsektionen i Työpaja.',
    openWorkshop: 'Öppna Työpaja',
    title: 'Rapport',
    description: 'Skapa workshoprapporten, översätt den och bestäm vad den offentliga rapporten visar.',
    instanceFallback: 'Rapport',
    selectInstance: 'Välj instans i den övre menyn',
    creating: 'Skapar...',
    create: 'Skapa rapport',
    openPublic: 'Öppna offentlig rapport',
    history: 'Historik',
    empty: 'Inga rapporter ännu',
    readers: {
      title: 'Rapportens läsare',
      lead: 'Bjud in personer som inte deltog i workshopen att läsa rapportens skyddade avsnitt och diskutera den med Kuutio. Deltagarna läser redan rapporten. En läsare får en inbjudan per e-post och loggar in i rapporten med en engångskod.',
      emailPlaceholder: 'namn@organisation.fi',
      add: 'Lägg till och bjud in',
      empty: 'Inga läsare ännu',
      invited: 'Inbjudan skickad',
      inviteFailed: 'Läsaren lades till, men inbjudan kunde inte skickas: {{error}}',
      alreadyParticipant: 'Den här personen har redan åtkomst till denna Kuutio och läser alltså redan rapporten.',
      invitedOn: 'Inbjuden {{date}}',
      notInvited: 'Inte inbjuden',
      lastLogin: 'senast inloggad {{date}}',
      resend: 'Skicka inbjudan igen',
      remove: 'Ta bort läsare',
    },
    type: {
      full: 'Fullständig rapport',
      summary: 'Sammandrag',
      pivotOnly: 'Hävstångspunkter',
      fallback: 'Rapport',
    },
    status: {
      lensSummariesRunning: 'AI-sammandrag skapat — sammanställer linssammandrag...',
      plansRunning: 'Linssammandrag sammanställda — genererar genomförandeplaner...',
      plansDone: 'AI-sammandrag skapat, genomförandeplaner: {{generated}}/{{total}}',
      plansDoneExcluded: 'AI-sammandrag skapat, genomförandeplaner: {{generated}}/{{total}}. {{excluded}} inmatningar utelämnade från sammandragen',
      plansFailed: 'AI-sammandrag skapat, men genomförandeplanerna misslyckades',
      createFailed: 'Rapporten kunde inte skapas',
      deleteFailed: 'Borttagningen misslyckades',
      translateRunning: 'Översätter rapporten ({{langs}})...',
      translateDone: 'Översättning klar: {{translated}} fält (hoppade över {{skipped}})',
      translateFailed: 'Översättningen misslyckades',
      translatePartial: 'Översättning klar delvis ({{failed}} batchar misslyckades)',
    },
    translate: {
      title: 'Översätt rapport',
      button: 'Starta översättning',
      translating: 'Översätter...',
      includeTranscripts: 'Inkludera transkript',
      pickLanguage: 'Välj minst ett målspråk',
      original: 'Original: {{lang}}',
      targets: 'Målspråk:',
      existing: 'Sparade översättningar',
      existingEmpty: 'Inga sparade översättningar',
      existingCount: '{{count}} fält',
      remove: 'Ta bort',
      removing: 'Tar bort...',
      removeConfirm: 'Ta bort {{lang}}-översättningen för den här rapporten? Detta går inte att ångra.',
      removeDone: '{{lang}}-översättningen borttagen ({{deleted}} fält)',
      removeFailed: 'Kunde inte ta bort översättningen',
      panelTitle: 'Översättningar',
      addLanguage: 'Lägg till språk',
      update: 'Uppdatera',
      updateTitle: 'Översätt de ändrade texterna på nytt',
      latest: 'uppdaterad {{date}}',
      translateCount: 'Översätt ({{count}})',
      uiNote: 'För andra språk än finska, engelska och svenska översätts också rapportens rubriker och knappar, en gång per språk.',
    },
    meta: {
      participants: '{{count}} deltagare',
      nodes: ' / {{count}} noder',
    },
    exclusions: {
      title: 'Felaktiga inmatningar',
      hint: 'Dessa inmatningar utelämnas från AI-sammanställda sammandrag. Deltagarnas kort syns ändå i rapportlistorna.',
      count: '{{count}} inmatningar utelämnade från analyser',
      empty: 'Inga felaktiga inmatningar',
      loadFailed: 'Kunde inte läsa utelämnade inmatningar',
      includeAnyway: 'Inkludera ändå',
      included: 'Inkluderad',
      forced: 'Utelämnad av facilitatorn',
      codes: {
        too_short: 'För kort',
        garbled: 'Osamanhängande',
        test_data: 'Testdata',
      },
      stages: {
        impact_path_node: 'Effektkedja',
        lens_item: 'Lins',
        solution: 'Lösning',
      },
    },
  },

  // Print Report
  printReport: {
    chromeOnly: 'Chrome-webbläsare krävs',
    useChromeMessage: 'Använd Chrome-webbläsare för utskrift.',
    toolbarTitle: 'Kuutio #3 — Rapport (10 / 40 sidor)',
    downloadPdf: 'Ladda ner PDF',
  },

  formCheck: {
    pendingLabel: 'Kontrollerar inmatningen…',
    okLabel: 'Inmatningen ser bra ut',
    warnLabel: 'Inmatningen har anmärkningar',
    dismiss: 'Dölj',
    suggestedLabel: 'Menade du detta?',
    acceptSuggestion: 'Använd förslaget',
    pill: {
      advisory: 'AI-förslag',
      blocking: 'Kontrollera texten',
    },
    tidyBtn: 'Formatera texten',
    tidyFailed: 'Texten kunde inte formateras. Försök igen.',
    a11y: {
      pending: 'Kontroll av inmatningen pågår',
      ok: 'Inmatningen är kontrollerad, inga anmärkningar',
      warn: 'Inmatningen har anmärkningar',
    },
    issues: {
      too_short: 'Skriv lite mer så att idén går att förstå.',
      garbled: 'Texten gick inte att läsa. Försök skriva om den.',
      test_data: 'Det här ser ut som testdata. Skriv en idé som hör till workshopen.',
      off_topic: 'Det här verkar inte relatera till workshopens tema.',
      wrong_stage: 'Idén passar bättre i ett annat workshopsteg.',
      multiple_ideas: 'Här finns flera idéer. Dela upp dem i egna poster.',
    },
  },

  instanceAccess: {
    pageTitle: 'Behörigheter',
    pageLead: 'Vem som får arbeta med denna Kuutio. Deltagarna hanteras på sidan Deltagare.',
    sectionTitle: 'Kuutions team',
    sectionLead: 'En förvaltare ändrar inställningar, PIN-koder och behörigheter; en facilitator leder workshoppen och redigerar rapporten.',
    empty: 'Inga behörigheter beviljade. Administratörer och Kuutions skapare kommer in utan separat behörighet.',
    notAllowed: 'Denna Kuutios behörigheter ändras av dess förvaltare eller en administratör.',
    emailLabel: 'E-post',
    emailPlaceholder: 'fornamn.efternamn@exempel.fi',
    levelLabel: 'Nivå',
    add: 'Lägg till',
    remove: 'Ta bort',
    actions: { manage: 'Förvaltare', facilitate: 'Facilitator' },
  },
  usersScreen: {
    title: 'Användare',
    lead: 'Varje konto, dess roll och behörigheter. Ett nytt Sitra-konto föds utan behörigheter — rollen och de första behörigheterna ges här.',
    tabUsers: 'Användare',
    tabLinks: 'Länkar',
    filterPlaceholder: 'Filtrera på namn eller adress…',
    roleLabel: 'Roll',
    roles: { owner: 'Ägare', admin: 'Administratör', usermanager: 'Huvudfacilitator', facilitator: 'Facilitator', participant: 'Deltagare' },
    lastLogin: 'Inloggad {{date}}',
    neverLoggedIn: 'Aldrig inloggad',
    kuutio: 'Kuutio',
    dataset: 'Databas',
    grantActions: { manage: 'förvaltare', facilitate: 'facilitator', participate: 'deltagare', contribute: 'bidragsgivare', view: 'läsare' },
    dropGrant: 'Ta bort behörigheten',
    removeAccount: 'Ta bort kontot',
    linksLead: 'Alla länkar som släpper in någon utan inloggning. Länkar skapas i databasens inställningar.',
    noLinks: 'Inga länkar.',
    uses: '{{count}} användningar',
    revoke: 'Återkalla',
    revoked: 'återkallad',
  },
  datasetWorkspace: {
    tabDocuments: 'Dokument',
    tabDatasets: 'Kunskapsbaser',
    kind: 'Typ',
    kinds: {
      all: 'Alla',
      fact: 'Fakta',
      policy: 'Riktlinje',
      opinion: 'Åsikt',
      testimony: 'Vittnesmål',
      none: 'Ingen typ',
    },
    searchLink: 'Webbsökning',
    searchLinkHelp: 'PDF:en angav ingen egen webbadress, så länken är en webbsökning på namn och utgivare. Ersätt den med den riktiga adressen när du hittar den.',
    profileFailed: 'Namn, utgivare och typ kunde inte läsas ur filen: {{error}}. Fyll i dem genom att redigera, eller konvertera källan igen.',
    pdfUpload: {
      title: 'Ladda upp PDF-filer',
      lead: 'En eller flera PDF-filer, eller ZIP-filer med PDF:er. Varje PDF blir en egen källa som läggs till kunskapsbasens övriga källor. Namn, utgivare, länk och typ (fakta, riktlinje, åsikt) läses inifrån filen, inte från filnamnet.',
      drop: 'Släpp PDF- eller ZIP-filer här, eller välj dem',
      picked: '{{count}} filer valda',
      upload: 'Ladda upp ({{count}})',
      added: '{{count}} PDF:er tillagda; konverteringen börjar.',
      skipped: 'Hoppades över, inga PDF:er: {{files}}',
    },
    manual: {
      title: 'Ladda ner för hand ({{count}})',
      lead: 'Dessa länkar kunde inte laddas ner automatiskt, troligen för att webbplatsen blockerar bottar. Öppna länken, ladda ner PDF:en i din egen webbläsare och ladda upp den på raden. Namn, utgivare och länk behålls.',
    },
    listTitle: 'Kunskapsbaser',
    listLead: 'Kuutions forskningsmaterial samlas innan instansen finns. Koppla en färdig kunskapsbas till en instans under Förberedelse → Kunskapsbas.',
    newDataset: 'Ny kunskapsbas',
    nameLabel: 'Namn',
    namePlaceholder: 't.ex. Kuutio 9: Vattensäkerhet',
    topicLabel: 'Ämne',
    topicPlaceholder: 'Vad den kommande Kuution handlar om',
    languageLabel: 'Språk',
    create: 'Skapa kunskapsbas',
    open: 'Öppna',
    back: 'Alla kunskapsbaser',
    sourceCount: '{{count}} källor i arbetsytan',
    indexCount: '{{documents}} dokument i sökningen ({{chunks}} delar)',
    cliDocs: {
      title: 'Indexerade från kommandoraden ({{count}})',
      lead: 'Dessa dokument indexerades med kommandoradsverktyget innan arbetsytan för kunskapsbaser fanns. De finns i sökningen ({{chunks}} delar), men deras filer sparades aldrig, så de kan inte konverteras eller indexeras om här.',
      show: 'Visa dokument',
      excluded: 'utesluten från sökningen',
    },
    attachedTo: 'Kopplad: {{instances}}',
    notAttached: 'Inte kopplad till en instans än',
    global: 'Basdatabas',
    empty: 'Inga kunskapsbaser än.',
    sourcesTitle: 'Källor',
    noSources: 'Inga källor än. Ladda upp PDF-filer ovan.',
    addSource: 'Lägg till källa',
    sourceName: 'Namn',
    publisher: 'Utgivare',
    link: 'Länk',
    file: 'PDF (valfri)',
    fileHelp: 'Utan PDF hämtas filen från länken. En webbsida konverteras som den är.',
    add: 'Lägg till',
    status: 'Status',
    quality: 'Kvalitet',
    chunks: 'Delar',
    approve: 'Godkänn och indexera',
    reject: 'Avvisa',
    remove: 'Ta bort',
    save: 'Spara',
    edit: 'Redigera',
    cancel: 'Avbryt',
    preview: 'Konverterad text',
    noPreview: 'Ingen konverterad text än.',
    pages: '{{pages}} sidor, varav {{visual}} visuella',
    confirmRemove: 'Ta bort källan?',
    fixTitle: 'Rätta källan',
    uploadFile: 'Ladda upp fil',
    openPdf: 'Öppna PDF',
    replaceFile: 'Ersätt fil',
    uploading: 'Laddar upp…',
    blockedHelp: 'Webbplatsen tillåter inte automatisk nedladdning. Ladda ner filen från länken i din egen webbläsare och ladda upp den här. Namn, utgivare och länk behålls.',
    failedHelp: 'Rätta länken genom att redigera källan, eller ladda upp filen själv.',
    awaitingHelp: 'Källan saknar fil. Lägg till en länk genom att redigera källan, eller ladda upp filen.',
    errorDetails: 'Felinformation',
    errors: {
      download_blocked: 'Fel: automatisk nedladdning blockerad',
      download_failed: 'Fel: nedladdningen misslyckades',
      generic: 'Fel',
    },
    settings: {
      open: 'Inställningar',
      description: 'Beskrivning',
      global: 'Basdatabas: alla instanser söker i den',
      globalHelp: 'En basdatabas syns i varje Kuutio utan koppling, och flera basdatabaser läggs ihop. En kunskapsbas kan inte tas bort: dess delar skulle försvinna ur sökningen utan att märkas.',
      confirmGlobalOn: 'Detta blir en basdatabas som syns i alla {{count}} instanser direkt. Fortsätta?',
      confirmGlobalOff: 'Detta är inte längre en basdatabas: instanser som den inte är kopplad till söker inte längre i den ({{count}} instanser totalt). Fortsätta?',
      otherGlobals: 'Obs: det finns redan basdatabaser: {{names}}. Alla söks tillsammans.',
    },
    access: {
      title: 'Behörigheter',
      lead: 'Vem som får använda denna databas. En förvaltare godkänner källor och ändrar inställningar, en bidragsgivare lägger till och rättar källor tills de godkänts, en läsare ser källorna och deras status.',
      empty: 'Inga behörigheter beviljade. Administratörer ser alla databaser utan separat behörighet.',
      emailLabel: 'E-post',
      emailPlaceholder: 'fornamn.efternamn@exempel.fi',
      levelLabel: 'Nivå',
      add: 'Lägg till',
      remove: 'Ta bort',
      actions: { manage: 'Förvaltare', contribute: 'Bidragsgivare', view: 'Läsare' },
      shareLabel: 'Skicka den här länken till dem du lagt till. Personer utanför Sitra loggar in med en kod som skickas till deras e-post:',
      copy: 'Kopiera',
      copied: 'Kopierat',
    },
    bulk: {
      select: 'Välj',
      selectAll: 'Välj alla som väntar ({{count}})',
      approve: 'Godkänn och indexera {{count}} (~{{cost}} $)',
      reject: 'Avvisa {{count}}',
      clear: 'Rensa valet',
      confirmReject: 'Avvisa {{count}} källor?',
      approveDone: '{{count}} godkända, indexeringen börjar',
      rejectDone: '{{count}} avvisade',
    },
    duplicates: {
      flag: 'dubblett?',
      detail: 'Samma text som: {{titles}}',
    },
    text: {
      edit: 'Redigera texten',
      edited: 'redigerad',
    },
    vision: {
      run: 'Läs bilder ({{pages}} sidor, ~{{cost}} $)',
      confirm: 'De {{pages}} visuella sidorna läses med bildigenkänning, cirka {{cost}} $. Källan konverteras igen och behöver godkännas på nytt. Fortsätta?',
    },
    rerun: {
      redownload: 'Hämta igen',
      reconvert: 'Konvertera igen',
      reindex: 'Indexera igen',
      confirmIndexed: 'Källan konverteras igen och behöver godkännas på nytt. Den nuvarande versionen finns kvar i sökningen tills den nya är indexerad. Fortsätta?',
      editIndexedHint: 'Ändringen syns i sökningen när källan indexeras igen.',
    },
    results: {
      images: 'Bilder',
      imagesRead: 'lästa på {{described}}/{{pages}} sidor',
      imagesNotRead: 'inte lästa',
      conversion: 'Konvertering',
      file: 'Fil',
      pages: 'Sidor',
      matched: 'Kopplad',
      cost: 'Uppskattad kostnad',
      reviewReason: 'Att kontrollera',
      rejectionReason: 'Skäl för avvisning',
      index: 'Index',
      chunks: 'Delar',
      words: 'Ord',
      language: 'Språk',
      topics: 'Ämnen',
      indexedAt: 'Indexerad',
      quality: 'Kvalitet',
      credibility: 'Trovärdighet',
      researchBasis: 'Forskningsgrund',
      recency: 'Aktualitet',
      documentType: 'Dokumenttyp',
      publisherType: 'Utgivartyp',
      year: 'Utgivningsår',
      bias: 'Perspektiv',
      none: 'Inga resultat än.',
    },
    statuses: {
      draft: 'I import',
      unmatched_file: 'Utan källa',
      awaiting_file: 'Väntar på fil',
      pending_download: 'Hämtas',
      pending_conversion: 'Konverteras',
      needs_review: 'Kontrollera',
      pending_review: 'Väntar på godkännande',
      approved: 'Godkänd',
      indexing: 'Indexeras',
      indexed: 'Indexerad',
      rejected: 'Avvisad',
      failed: 'Fel',
    },
  },

  datasetImport: {
    alternative: 'Alternativt en källförteckning (Excel eller CSV) och PDF:er som matchas mot dess rader.',
    openForm: 'Importera en källförteckning',
    title: 'Importera källförteckning och PDF:er',
    lead: 'En källförteckning (Excel eller CSV: namn, utgivare, länk) och ett ZIP-paket med PDF:er. PDF:erna kopplas till förteckningens rader utifrån filnamn, PDF-metadata och de första sidorna. Konverteringen börjar först när du bekräftar kopplingarna.',
    sourcesLabel: 'Källförteckning (.xlsx, .csv)',
    archiveLabel: 'PDF-paket (.zip)',
    filesLabel: 'Eller enskilda PDF:er',
    start: 'Importera',
    uploading: 'Laddar upp…',
    extracting: 'Läser PDF:erna och kopplar dem till källor…',
    failed: 'Importen misslyckades',
    summary: '{{matched}} kopplade, {{pdfs}} PDF:er och {{rows}} rader utan par',
    aiCalls: 'AI läste {{count}} PDF:er',
    matchedTitle: 'Kopplade',
    unmatchedPdfsTitle: 'PDF:er utan källa',
    unmatchedRowsTitle: 'Källor utan PDF',
    noUnmatchedPdfs: 'Alla PDF:er är hanterade.',
    noUnmatchedRows: 'Alla källor har en PDF.',
    readAs: 'Enligt PDF:en',
    unknownTitle: 'Inget namn hittades',
    suggestions: 'Förslag',
    selectPdf: 'Välj PDF',
    selected: 'Vald',
    matchHere: 'Koppla den valda PDF:en hit',
    unmatch: 'Koppla loss',
    auto: 'automatisk',
    manual: 'manuell',
    own: 'egen källa',
    keepOwn: 'Egen källa',
    keep: 'Lägg till som egen källa',
    discard: 'Kasta',
    excerpt: 'Första sidan',
    rowNumber: 'rad {{n}}',
    linkNote: 'Hämtas från länken efter bekräftelse',
    noLinkNote: 'Ingen länk: väntar på en fil',
    confirm: 'Bekräfta och starta konverteringen',
    confirmBlocked: 'Hantera först alla PDF:er: koppla, lägg till som egen källa eller kasta.',
    cancel: 'Avbryt importen',
    confirmCancel: 'Avbryta importen? Raderna och PDF:erna tas bort.',
    methods: {
      filename_column: 'filnamn i förteckningen',
      link_filename: 'länkens filnamn',
      title_in_text: 'titeln i texten',
      pdf_metadata: 'PDF-metadata',
      first_page_title: 'titelsidan',
      ai_title: 'titel läst av AI',
      filename: 'filnamn',
      text: 'ord i texten',
    },
  },


  painPointVote: {
    title: 'Vad gör mest ont?',
    intro: 'Dessa grupper av smärtpunkter samlades från förhandsuppgifterna. Du har {{budget}} röster: ge dem till dem som dagen bör ägnas åt.',
    closedIntro: 'Omröstningen är avslutad. Här är rummets resultat.',
    left: '{{left}} / {{budget}} röster kvar',
    closed: 'Omröstningen är inte öppen',
    noVotesLeft: 'Dina röster är använda. Ta bort en för att flytta den.',
    empty: 'Inga grupper ännu. Facilitatorn grupperar smärtpunkterna före omröstningen.',
    noInstance: 'Ingen workshop vald.',
  },
  homework: {
    title: 'Hemuppgifter',
    tabBefore: 'Före Kuutio',
    tabAfter: 'Efter Kuutio',
    prev: 'Föregående',
    next: 'Nästa',
    empty: 'Inga svar ännu.',
    answered: '{{count}} svarade',
    mean: 'medelvärde',
    agree: 'Av samma åsikt', unsure: 'Vet inte', disagree: 'Av annan åsikt',
    holds: 'Stämmer', notHere: 'Inte här',
    doneTitle: 'Rummet före Kuutio',
    doneLead: 'Så många gjorde förhandsuppgifterna. Dagen börjar från det rummet redan vet.',
    invited: 'inbjudna',
    didSelfAssessment: 'gjorde självutvärderingen',
    didKysely: 'svarade på enkäten',
    didPainPoints: 'namngav en smärtpunkt ({{count}} smärtpunkter)',
    selfAssessmentTitle: 'Självutvärdering: så bedömer vi oss själva',
    dividedTitle: 'Var vi är oeniga',
    dividedLead: 'De mest splittrade påståendena först. Börja här.',
    claimsTitle: 'Vad som stämmer i dag',
    targetTitle: 'Vad målbilden måste uppfylla',
    expectTitle: 'Var vi tror att workshoppen landar',
    painPointsTitle: 'Smärtpunkter',
    painPointsCount: '{{count}} smärtpunkter från {{people}} personer',
    promoted: 'som variabel',
    ungrouped: '+ {{count}} ogrupperade',
    peilausTitle: 'Speglingar: vad källorna sade, och om det stämde',
    peilausLead: 'Deltagarna tog ställning till källornas påståenden utifrån sin egen smärtpunkt.',
    mirrorsAnswered: '{{count}} speglingar',
    allMirrors: 'Alla speglingar',
    unknownSource: 'Okänd källa',
    afterDoneTitle: 'Rummet efter Kuutio',
    didSelfAssessmentBefore: 'självutvärderingar före',
    didSelfAssessmentAfter: 'självutvärderingar efter',
    noPost: 'Inga hemuppgifter gjorda ännu.',
    changeTitle: 'Självutvärdering före och efter',
    beforeAfter: 'före {{before}} · efter {{after}}',
    before: 'före',
    after: 'efter',
  },
  clicker: {
    step: 'Steg {{i}}/{{n}}',
    tila: 'Läge {{i}}/{{n}}',
    slide: 'Bild {{i}}/{{n}}',
    paused: 'Pausad',
    notRunning: 'Verkstaden är inte igång.',
    prev: 'Föregående',
    next: 'Nästa',
    start: 'Starta verkstaden',
    pause: 'Paus',
    resume: 'Fortsätt',
    steps: 'Steg',
    stop: 'Avsluta',
    stopHint: 'Öppna stegen först; Avsluta stoppar verkstaden.',
    phase: 'Stegets reglage',
    phaseEmpty: 'Det här steget har inga reglage.',
  },
  infoWall: {
    title: 'Kuutio · vad som byggs nu',
    week: 'vecka {{week}}',
    underWork: 'Under arbete',
    nextDemo: 'Nästa demo',
    noDemo: 'Ingen demo bestämd. Skriv in den på /admin/info.',
    shipped: 'Senast klart',
    theme: 'Tema',
    themeLight: 'ljust',
    themeDark: 'mörkt',
    doors: 'Dörrar',
    doorsHint: 'Skanna, öppna i telefonen',
    pulse: 'Puls',
    pulseKuutiot: 'Kuutio hållna',
    pulseArticles: 'Artiklar i kunskapsbasen',
    pulseParticipants: 'Deltagare',
    pulseNext: 'Nästa Kuutio',
    pulseLenses: 'Hinder och möjligheter',
    pulseSolutions: 'Lösningar',
    pulseUpcoming: 'Kuutio på väg',
    pulseNodes: 'Noder på kartorna',
    pulsePrework: 'Förhandsuppgifter gjorda',
    vote: 'Vad intresserar dig i Kuutios utveckling?',
    voteHint: 'Tryck på en. Koden tar dig till att svara i telefonen.',
    voteAnswers: '{{n}} svar',
    voteQr: 'Frågor och mer i telefonen',
    voteQrHint: 'En kod: idéerna, tre frågor per idé, berättelserna och Kuutios ord.',
    kysyLead: 'Svara anonymt. Tre frågor per idé, när du vill.',
    sanasto: 'Kuutios ordlista',
    kysyTitle: 'Tre frågor',
    kysyThanks: 'Tack! Dina svar är sparade, anonymt.',
    kysySend: 'Skicka',
    kysyMissing: 'Idén hittades inte.',
    voteNoIdeas: 'Inga idéer att rösta på. Märk ett ärende med idea.',
    voteEmail: 'Din e-post',
    voteSend: 'Rösta',
    voteCancel: 'Avbryt',
    voteThanks: 'Tack! Skanna koden om du vill säga mer.',
    voteAgain: 'Du hade redan röstat på denna.',
    voteRemoved: 'Rösten togs tillbaka.',
    voteAsk: 'svara',
    voteHintOwn: 'Tryck på en. Svara på frågorna direkt här.',
    votes: '{{n}} röster',
    vaihe: { tuotannossa: 'I produktion', testissa: 'I test', kokeilu: 'Experiment', tutkimus: 'Forskning' },
    stateOpen: 'på väg',
    stateDone: 'klart',
    empty: 'Inget att visa. Märk ett ärende med info.',
    lint: 'Berättelser utan väggmening: {{list}}',
    noSource: 'Ingen kontakt med GitHub.',
    upcoming: 'Den här veckan',
    upcomingNoDate: 'datum öppet',
    calendarStale: 'kalendern uppdateras inte',
    eventNew: '{{n}} nya funktioner',
    eventNotes: 'Nytt',
    eventMinimise: 'Stäng',
    eventOngoing: 'Pågår',
    weeks: { next: 'Nästa vecka', later: 'Senare', showNext: 'Visa nästa vecka' },
    countdown: { kuutio: 'Kuutio {{n}}', days: '{{d}} d {{h}} h', hours: '{{h}} h' },
    weather: { clear: 'klart', partly: 'halvklart', cloudy: 'mulet', fog: 'dimma', drizzle: 'duggregn', rain: 'regn', showers: 'skurar', snow: 'snö', thunder: 'åska', feels: 'känns som {{t}}°', range: '{{lo}}…{{hi}}°' },
    lunch: { title: 'Lunch i dag', lead: 'Dagens listor från ställena i närheten, lästa från deras sidor en gång om dagen.', loading: 'Läser listorna…', error: 'Listorna kunde inte läsas: {{message}}', noMenu: 'Ingen lista för i dag på sidan.', noPlaces: 'Inga lunchställen. Lägg till dem på /admin/info.' },
    tryOut: 'Prova',
    tryOutEmpty: 'Inget att prova ännu. Lägg till raderna "Kokeile: /sökväg" och "Kuva: /info/thumbs/N.jpg" på kortet (eller klistra in en skärmbild).',
    tryOutBack: 'Tillbaka till väggen',
    tryOutOpen: 'Öppna i ny flik',
    tryOutPhone: 'Prova på din telefon: läs koden och gå igenom.',
    event: { allDay: 'hela dagen', organizer: 'Arrangör', open: 'Öppna i Outlook' },
    story: {
      loading: 'Laddar…',
      error: 'Kortet kunde inte läsas: {{message}}',
      body: 'Kort',
      subIssues: 'Deluppgifter {{done}}/{{total}}',
      open: 'Öppna på GitHub #{{number}}',
    },
    demoEditor: {
      title: 'Demor',
      edit: 'Redigera demor',
      loading: 'Laddar…',
      signIn: 'Redigering kräver administratörsinloggning.',
      date: 'Datum',
      time: 'Klockan',
      place: 'Plats',
      sessionTitle: 'Rubrik (valfri)',
      note: 'En rad för väggen (valfri)',
      slots: 'Vem visar vad',
      who: 'Vem',
      what: 'Vad',
      noStory: '(inget kort)',
      slotNote: 'Beskrivning vid behov',
      addSlot: 'Lägg till presentation',
      addPresenter: 'Lägg till presentatör',
      up: 'Upp',
      down: 'Ner',
      noStories: 'Inga öppna kort under det här namnet.',
      sessions: 'Demor',
      noSessions: 'Inga demor avtalade.',
      addSession: 'Lägg till demo',
      remove: 'Ta bort',
      removeSession: 'Ta bort demon',
      cancel: 'Stäng',
      save: 'Spara',
      badDate: 'Datum som ÅÅÅÅ-MM-DD.',
      error: 'Sparandet misslyckades: {{message}}',
    },
    upcomingEmpty: 'Inga berättelser märkta för denna Kuutio ännu.',
    noUpcoming: 'Inget känt evenemang. Skriv in det på /admin/info.',
    progress: '{{done}}/{{total}} klara',
    admin: {
      title: 'Infovägg',
      lead: 'Vad /info berättar om nästa evenemang och nästa demo. Berättelser och idéer kommer från GitHub: etiketterna info, idea och K9.',
      nextEvent: 'Nästa evenemang',
      nextDemo: 'Nästa demo',
      eventTitle: 'Rubrik (t.ex. Kuutio 9)',
      date: 'Datum',
      time: 'Klockan',
      place: 'Plats',
      note: 'En mening för väggen',
      eventHint: 'Lämnas tom tar väggen nästa Kuutio från instanserna. Berättelser vars milstolpe eller etikett är denna Kuutio visas under den.',
      demoHint: 'Bocka för berättelserna i demons ordning. Demon försvinner från väggen efter sin dag; kortets ansvariga på GitHub visas som demoförare.',
      demoItems: 'Berättelser som visas i demon',
      demoItemsNone: 'Inga öppna info-berättelser.',
      lunch: 'Lunchställen',
      lunchHint: 'Väggens lunchknapp läser de här sidorna en gång om dagen och plockar ut dagens lista. Namn och sidan med listan.',
      lunchName: 'Restaurang',
      lunchAdd: 'Lägg till ställe',
      save: 'Spara',
      saved: 'Sparat',
      open: 'Öppna /info',
      loading: 'Laddar…',
      error: 'Det gick inte att spara: {{message}}',
    },
  },

  me: {
    datasets: { title: 'Databaser', sources: '{{count}} källor' },
    heading: 'Din Kuutio',
    signInPrompt: 'Logga in med din e-post för att se din Kuutio.',
    signIn: 'Logga in',
    enterWorkshop: 'Gå till verkstaden',
    openFacilitator: 'Öppna facilitatorvyn',
    enterLater: 'Workshoppen öppnas från den här sidan när den börjar.',
    enterOnSite: 'Verkstaden hålls på plats. Om distansdeltagande öppnas når du kartan härifrån.',
    signInInvited: 'Koden skickas bara till inbjudna deltagare. Använd adressen du anmälde dig med.',
    selfAssessment: {
      label: 'Självutvärdering',
      postLabel: 'Självutvärdering efter workshoppen',
      hint: 'Sju påståenden, två minuter.',
      postHint: 'Samma påståenden som före workshoppen, plus ett.',
      intro: 'Bedöm din egen framsyns- och innovationsförmåga. Svara utifrån vad du tänker nu. Svaren är för dig och för utvärderingen av Kuutios effekt; ingen kan läsa dem under ditt namn.',
      postIntro: 'Samma påståenden som före workshoppen. Svara som du tänker nu, inte som du svarade då.',
      progress: '{{n}} / {{of}}',
      scale: { 1: 'helt av annan åsikt', 2: 'delvis av annan åsikt', 3: 'varken av samma eller annan åsikt', 4: 'delvis av samma åsikt', 5: 'helt av samma åsikt' },
      unknown: 'Vet inte',
      submit: 'Skicka svaren',
      finalNote: 'Svaren sparas som slutgiltiga och kan inte ändras efteråt.',
      done: 'Självutvärdering gjord',
      doneNote: 'Tack. Dina svar är sparade.',
      postDoneNote: 'Tack. Dina svar ingår i utvärderingen av Kuutios effekt.',
      items: {
        1: 'Jag känner igen egna och andras antaganden om framtiden.',
        2: 'Jag använder framsyn som stöd för beslutsfattandet i min organisation.',
        3: 'Jag kan främja framtidstänkande i min egen organisation.',
        4: 'Jag ser på saker systemiskt och känner igen mångdimensionella orsakssamband.',
        5: 'Jag kan använda metoder som stöder innovation och kreativitet i mitt arbete.',
        6: 'Jag kan identifiera lösningar på framtidens utmaningar.',
        7: 'Jag är motiverad att använda framsyns- och innovationsmetoder och -verktyg i mitt arbete.',
        8: 'Arbetet i Kuutio stärkte min framsyns- och innovationsförmåga.',
      },
      info: {
        title: 'Så sparas dina svar',
        close: 'Stäng',
        stored: 'Dina svar sparas i Kuutios databas tillsammans med din e-postadress, liksom dina andra förhandsuppgifter. Endast Kuutios utvecklingsteam hanterar dem.',
        paired: 'Svaren visar om något förändrades genom Kuutio. "Ingen förändring" är också ett resultat.',
        whoSees: 'Facilitatorn och Sitra ser bara hur rummet svarade på varje påstående sammanlagt. Ingen ser en enskild persons svar.',
        purpose: 'Sitra använder uppgifterna för att utvärdera Kuutios effekt: stärktes deltagarnas framsyns- och innovationsförmåga genom Kuutio.',
      },
    },
    kysely: {
      label: 'Enkät',
      hint: 'Tolv punkter, tre minuter. Samma för alla.',
      intro: 'Svara utifrån vad du tänker nu. Svaren visas för rummet bara som summor, och ingen ser vems de är. Det här är din utgångspunkt; vi återkommer till den efter verkstaden.',
      part: 'Del {{n}} / {{of}}',
      claimsQ: 'Vilka av dessa stämmer i dag?',
      claimsHint: 'Välj alla du håller med om.',
      stanceQ: 'Ta ställning till varje påstående.',
      socketsQ: 'Vilka av dessa måste målbilden uppfylla?',
      socketsHint: 'Välj dem du anser nödvändiga.',
      expectQ: 'Var tror du att verkstaden landar?',
      expectHint: 'Ett val. Vi återkommer till det när verkstaden är över.',
      expectFoot: 'Förväntan före verkstaden, jämförs med resultatet efteråt.',
      agree: 'Håller med',
      unsure: 'Vet inte',
      disagree: 'Håller inte med',
      submit: 'Skicka svaren',
      finalNote: 'Skickandet är slutgiltigt. Samma frågor ställs igen efter verkstaden.',
      done: 'Enkäten besvarad',
      resultsIntro: 'Så här har rummet svarat hittills. Dina egna svar är markerade.',
      answered: '{{count}} har svarat',
      notReady: 'Enkäten för den här Kuution är inte klar ännu. Vi meddelar när den är det.',
    },
    online: 'På nätet. Länken till verkstaden öppnas på den här sidan.',
    placeLater: 'Platsen meddelas närmare tidpunkten.',
    kuutioRoom: 'Sitras Kuutio-rum',
    dateLater: 'Tidpunkten meddelas närmare.',
    door: {
      emailLabel: 'E-postadress',
      emailPlaceholder: 'fornamn.efternamn@exempel.fi',
      sendCode: 'Skicka kod',
      codeSent: 'En kod skickades till {{email}}. Den gäller i 10 minuter.',
      codeLabel: 'Sexsiffrig kod',
      verify: 'Logga in',
      resend: 'Skicka ny kod',
      resendIn: 'Ny kod om {{seconds}} s',
      resent: 'En ny kod har skickats.',
      changeEmail: 'Byt adress',
      signingIn: 'Loggar in…',
      joining: 'Du går med i Kuutio ”{{title}}”.',
      joiningUnknown: 'En länk för att gå med i en Kuutio.',
      noJoinCode: 'Den här Kuution har ingen anslutningskod. Be arrangören om en ny länk.',
      howJoin: 'Logga in med din e-post. Koden i länken lägger till dig i den här Kuution.',
    },
    none: 'Ingen Kuutio har öppnats för dig ännu. Kontakta arrangören om du väntade dig något.',
    loading: 'Laddar…',
    failed: 'Kunde inte ladda dina uppgifter.',
    chooseWorkshop: 'Du har fler än en Kuutio. Välj vilken du vill se.',
    staffView: 'Du ser alla Kuutio eftersom du är administratör. En deltagare ser bara sina egna.',
    back: 'Tillbaka',
    when: 'När',
    where: 'Var',
    directions: 'Visa på kartan',
    contact: 'Frågor?',
    goodToKnow: 'Bra att veta',
    tabPractical: 'Praktisk information',
    tabPreWork: 'Förhandsuppgifter',
    tabHomework: 'Hemuppgifter',
    homeworkIntro: 'Workshoppen är över. Hemuppgifterna är korta, och de bygger bilden av vad som förändrades.',
    homeworkTodo: 'Ogjorda hemuppgifter',
    preWorkClosed: 'Förhandsuppgifterna är låsta: workshoppen är över. Dina svar förblir som de var före workshoppen.',
    preWorkClosedShort: 'Låst',
    noPreWork: 'Inga förhandsuppgifter har publicerats ännu. Vi meddelar när de är klara.',
    phone: 'Telefon',
    assistant: 'Meddelanden även till',
    preWorkIntro: 'Gör förhandsuppgifterna före verkstaden. Då börjar dagen från det du redan vet, och vi får ut det mesta av den.',
    preWorkBack: 'Alla förhandsuppgifter',
    preWorkBackToList: 'Tillbaka till listan',
    preWorkDone: 'Klar',
    countdown: { days: '{{days}} d {{hours}} h till Kuutio', hours: '{{hours}} h {{minutes}} min till Kuutio' },
    reading: {
      title: 'Förhandsläsning: standardscenarierna',
      body: 'I Kuutio granskas ämnet genom fyra standardscenarier: demokrati, befolkning, teknologi och klimat. Ögna igenom scenariorapporterna före verkstaden så att framtidsbilderna är bekanta när arbetet börjar.',
      url: 'https://www.sitra.fi/kuutio',
      linkText: 'sitra.fi/kuutio',
    },
    preWorkLocked: 'Öppnas när Kipupiste är klar',
    preWorkLockedAfter: 'Öppnas när ”{{title}}” är klar',
    chatham: {
      title: 'Chatham House-regeln',
      body: 'Det som sägs i Kuutio får användas, men talaren eller organisationen namnges inte.',
    },
    peilaus: {
      researchSearchFailed: 'Kunskapsbasen kunde inte sökas just nu. Försök igen om en stund.',
      researchNoDatasets: 'Inget forskningsmaterial är kopplat till den här workshoppen, så det finns inget att spegla mot.',
      intro: 'Kunskapsbasen speglas mot det du behöll på kartan: högst tre ställen där en källa säger något annat eller lägger till ett faktum. Du säger om det stämmer hos er. Oenighet är värdefullt.',
      pick: 'Välj en smärtpunkt',
      label: 'Spegling',
      start: 'Spegla',
      loading: 'Läser kunskapsbasen… det tar en stund.',
      you: 'Du',
      source: 'Kunskapsbas',
      kindPain: 'Smärtpunkt',
      holds: 'Stämmer',
      not_here: 'Inte hos oss',
      unsure: 'Vet inte',
      notePlaceholder: 'Varför? (valfritt)',
      done: 'Tack. Dina ställningstaganden finns på kartan som anteckningar med källor. Vi fortsätter därifrån i verkstaden.',
      empty: 'Kunskapsbasen säger inget direkt om denna smärtpunkt. Det är också information, och vi återkommer till det i verkstaden.',
    },
    phase: { upcoming: 'Kommande', ongoing: 'Pågår', past: 'Avslutad', online: 'Online' },
    preWorkTodo: 'Förhandsuppgifter väntar',
    devices: { title: 'Enheter', body: 'Arbetet sker på Kuutios egna enheter; du behöver inte ta med egna.' },
    comfort: { title: 'Yllesockor och en avslappnad attityd', body: 'Klä dig bekvämt. Yllesockor är välkomna, liksom en avslappnad attityd: Kuutio är en verkstad, inte ett seminarium.' },
    about: {
      title: 'Kuutio i korthet',
      lines: [
        'Kuutio är Sitras metod där vi granskar ett ämne genom möjliga framtider och deras orsakssamband, och tillsammans söker hävstångspunkter och lösningar. AI stöder arbetet.',
        'Kuutio är ett experiment. Kasta dig in och lita på processen.',
        'Till AI-plattformen förs bara expertgranskat material, och inga personuppgifter matas in.',
        'Det är välkommet att dela på sociala medier: @Sitra på LinkedIn, @sitrafund på Instagram.',
      ],
    },
    transit: { subway: 'Metro', train: 'Tåg', tram: 'Spårvagnar', bus: 'Bussar', more: '+{{count}} till' },
    preWorkUntitled: 'Förhandsuppgift',
    kipupiste: {
      scenario: 'Vilket scenario hör detta till?',
      aiSuggested: 'AI:s förslag',
      defaultQuestion: 'Vilket är det mest brännande problemet kring dagens tema?',
      intro: 'Med egna ord. Sedan ställer jag några frågor och föreslår det jag hörde; du behåller eller förkastar. Bara det du behåller når verkstadens karta.',
      placeholder: 'Till exempel: beskattningen når inte plattformsekonomins inkomster…',
      start: 'Börja',
      answer: 'Svara',
      stop: 'Det räcker för nu',
      thinking: 'Ett ögonblick…',
      answerPlaceholder: 'Svara med egna ord',
      heard: 'Det här hörde jag',
      cause: 'Orsak',
      blocker: 'Hinder',
      keep: 'Behåll',
      drop: 'Förkasta',
      kept: 'På kartan',
      dropped: 'Förkastad',
      done: 'Tack. {{count}} saker blev kvar på kartan kring din smärtpunkt. Vi fortsätter därifrån i verkstaden.',
      addAnother: 'Lägg till en ny smärtpunkt ({{count}}/{{max}})',
      addFirst: 'Skriv en smärtpunkt',
      label: 'Smärtpunkt',
      causeOf: 'Bakom: {{cause}}',
      mergedInto: 'Din smärtpunkt är nu variabeln ”{{title}}” i scenariot {{scenario}}.',
      mergedWith: 'Tillsammans med {{count}} andra.',
      cancelNew: 'Avbryt',
      yours: 'Dina smärtpunkter ({{count}}/{{max}})',
      inProgress: 'Pågår',
      keptCount: '{{count}} på kartan',
      limit: 'Högst {{max}} smärtpunkter. Spara resten till verkstaden.',
    },
    assistantIntro: 'Du är assistent för {{name}}. Detta är vad arrangören har om hen. Det kan ändras på hens anmälningssida.',
    theirDetails: 'Anmälningsuppgifter',
    editTheirs: 'Ändra uppgifter',
    attendingCount: '{{count}} anmälda deltagare',
    yourDetails: 'Din anmälan',
    detailsIntro: 'Detta är vad arrangören har om dig. Du kan ändra det på din egen anmälningssida.',
    editInLyyti: 'Ändra mina uppgifter',
    organisation: 'Organisation',
    title: 'Titel',
    allergies: 'Matallergier',
    diet: 'Specialkost',
    notGiven: 'Ej angivet',
    noRegistration: 'Vi hittade inte din anmälan till denna Kuutio. Du är ändå välkommen — kontakta arrangören om detta ser fel ut.',
    noEventInfo: 'Praktiska detaljer bekräftas närmare datumet.',
    detailsUnavailable: 'Praktiska uppgifter kan inte hämtas just nu. Försök igen om en stund.',
  },

  futureSelection: {
    loading: 'Laddar scenarier...',
    empty: 'Inga scenarier.',
    scenarioFallback: 'Scenario',
    futuresCount: '{{count}} framtidsbilder',
    activeFuture: 'Aktiv framtidsbild',
    customFuture: 'Egen framtidsbild',
    freeBadge: 'Fri',
    saving: 'Sparar...',
    saved: 'Sparat',
    noFutures: 'Inga framtidsbilder',
    modalTitle: 'Byta framtidsbild?',
    modalExisting: 'Scenariot {{scenario}} har redan {{count}} noder som deltagarna skapat med den nuvarande framtidsbilden {{previous}}.',
    modalRecommendation: 'Rekommenderat: behåll deltagarnas innehåll och byt bara framtidsbild + variabler. Kommande AI-analys använder den nya framtidsbilden {{next}}.',
    switching: 'Byter…',
    keepContent: 'Behåll innehållet, byt framtidsbild',
    wipeAndRestart: 'Töm effektvägen och börja om',
    swapFailed: 'Bytet av framtidsbild misslyckades: {{error}}',
    wipeFailed: 'Tömningen misslyckades: {{error}}',
  },

  topicFocus: {
    selectedLabel: 'Valt perspektiv',
    noneSelected: 'Inget valt – alla perspektiv',
    noFilter: 'Ingen avgränsning',
    noFilterDescription: 'Alla perspektiv är likvärdiga',
    saving: 'Sparar...',
    saved: 'Sparat',
    focusLabel: 'Avgränsning',
    original: 'Ursprunglig: {{title}}',
  },

  pivotPointContent: {
    loading: 'Laddar hävstångspunkter...',
    saveFailed: 'Det gick inte att spara hävstångspunkten: {{error}}',
    deleteTitle: 'Ta bort hävstångspunkt',
    deleteMessage: 'Ta bort "{{title}}"? Det här kan inte ångras.',
    clearTitle: 'Ta bort alla valda hävstångspunkter?',
    clearMessage: 'Det här lämnar workshoppen utan valda hävstångspunkter — vyerna Linser, Lösningar och rapporten visar ingenting förrän du väljer nya. Fortsätta?',
    clearConfirm: 'Töm valen',
  },

  preworkCuration: {
    loading: 'Laddar förhandsuppgifter…',
    title: 'Förhandsuppgifter: från smärtpunkter till variabler',
    intro: 'AI:n föreslår grupperna, rubrikerna och scenariot. Du bestämmer vad som blir en variabel. Deltagarnas egna ord ändras inte.',
    clustering: 'Grupperar… det här tar ungefär en minut',
    recluster: 'Gruppera om',
    cluster: 'Gruppera',
    countPainPoints: 'smärtpunkter',
    countParticipants: 'deltagare',
    countGroups: 'grupper',
    countPromoted: 'variabler på kartan',
    unembedded: '{{count}} utan vektor (grupperingen bäddar in dem)',
    noPainPoints: 'Ingen har skrivit en smärtpunkt ännu.',
    noClusters: 'Inga grupper ännu. Tryck på Gruppera.',
    closeVote: 'Stäng röstningen',
    openVote: 'Öppna röstningen för rummet',
    voteOpenInfo: 'Röstningen är öppen: enheterna på adressen /kipupisteet, {{budget}} röster per enhet. Rösterna flyttar upp en grupp i ordningen.',
    voteClosedInfo: 'När grupperna är klara kan rummet rösta om dem på sina enheter innan du lyfter fram variablerna.',
    scenarioFallback: 'Scenario',
    noScenario: 'Utan scenario',
    groupHeading: '{{title}} · {{count}} variabler',
    unclusteredHeading: 'Ogrupperade · {{count}}',
    clusterCard: {
      rankTitle: 'Ordning inom scenariot: rummets röster, deltagare, oenighet, hinder',
      namePlaceholder: 'Variabelns namn',
      scenarioPlaceholder: 'Scenario…',
      votes: 'röster',
      participants: 'deltagare',
      painPoints: 'smärtpunkter',
      disagreement: 'oenighet',
      obstacles: 'hinder',
      overCap: 'scenariot har redan många variabler',
      promoted: 'Variabel på kartan: {{title}}',
      undo: 'Ångra',
      promote: 'Gör till variabel',
      pickScenarioFirst: 'välj scenario först',
      dissolve: 'Lös upp gruppen',
    },
    painPoint: {
      move: 'Flytta…',
      ownGroup: 'Till en egen grupp',
      untitled: '(namnlös)',
      done: 'Smärtpunkt klar',
      inProgress: 'Smärtpunkt pågår',
      causes: '{{count}} orsaker',
      blockers: '{{count}} hinder',
      noVector: 'ingen vektor',
      stance: {
        holds: 'stämmer',
        not_here: 'inte hos oss',
        unsure: 'osäker',
      },
    },
    scenarioProposal: {
      fromAction: 'Förslaget kommer från sektionens åtgärd Föreslå scenarier från grupperna; det visas här för redigering.',
      proposing: 'Föreslår… ungefär en minut',
      propose: 'Föreslå scenarier utifrån grupperna',
      form: 'Bilda scenarier utifrån grupperna',
      place: 'Placera grupperna i befintliga scenarier',
      hintExisting: 'Scenarierna finns redan; grupperna placeras i dem, eller så föreslår AI:n nya om inget passar.',
      hintNone: 'Instansen har inga scenarier. AI:n föreslår dem utifrån smärtpunktsgrupperna och grundorsakerna; du redigerar och bekräftar.',
      heading: 'Förslag: {{count}} scenarier',
      editHint: 'Redigera rubrikerna och beskrivningarna. Grupperna kan flyttas mellan scenarierna efter att de skapats.',
      namePlaceholder: 'Scenariots namn',
      existingTag: 'finns',
      descriptionPlaceholder: 'Beskrivning',
      unplaced: 'Utan placering: {{titles}}. De förblir grupper som du själv väljer scenario för.',
      create: 'Skapa och placera',
      reject: 'Förkasta',
    },
  },

  // Legacy room screens: what they say instead of invented data (#1413)
  moodScreen: {
    loading: 'Läser in stämningsdata...',
    title: 'Stämningen i workshopen',
    analysed: '{{count}} förslag analyserade',
    noInstance: 'Ingen workshop är vald, så det finns ingen stämning att visa.',
    loadFailed: 'Det gick inte att läsa in stämningsdata: {{reason}}',
    empty: 'Inga förslag ännu, så det finns ingen stämning att visa.',
    retry: 'Försök igen',
    moods: {
      positive: 'Positiv',
      neutral: 'Neutral',
      negative: 'Orolig',
      hopeful: 'Hoppfull',
      concerned: 'Bekymrad',
    },
  },
  impactMachine: {
    loading: 'Läser in den sparade planen...',
    empty: 'Ingen plan har sparats ännu, så väggen är tom.',
    loadFailed: 'Det gick inte att läsa in den sparade planen: {{reason}}',
    noAnswer: 'Servern svarade inte på begäran om den sparade planen. Ladda om sidan.',
    accessDenied: 'Servern vägrade läsa in planen eftersom det inte finns någon session. Logga in igen.',
    connectFailed: 'Anslutningen till servern misslyckades: {{reason}}',
  },
  solutionComponents: solutionComponentsSv,
  lensComponents: lensComponentsSv,
  moduleIntro: moduleIntroSv,
  languagePicker: {
    common: 'Vanligast:',
    search: 'Sök ett språk på namn eller kod (t.ex. estniska, eesti, et)',
    noMatch: 'Inga träffar',
    remove: 'Ta bort {{lang}} från valet',
  },
  report: reportStringsSv,
  foresight: { ...foresightSv, ...foresightScenarioSv, ...foresightPathSv, ...foresightWildcardSv },
};